webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*import toastr from 'toastr';

toastr.options.preventDuplicates = true;
toastr.options.progressBar = true;
toastr.options.closeDuration = 5000;
toastr.options.positionClass = 'toast-top-center';

export default toastr;*/

function sendToastr(message) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';


	if (window.self === window.top) {
		alert('[' + type.toUpperCase() + '] - ' + message);
	} else {

		window.parent.postMessage({
			schoolastic: {
				toastr: {
					type: type,
					message: message,
					options: {
						preventDuplicates: true,
						progressBar: true,
						closeDuration: 5000,
						positionClass: 'toast-top-center'
					}
				}
			}
		}, '*');
	}
}

exports.default = {
	error: function error(message) {
		return sendToastr(message, 'error');
	},
	info: function info(message) {
		return sendToastr(message, 'info');
	},
	success: function success(message) {
		return sendToastr(message);
	},
	version: '2.0.3 <iframe /> wrapper',
	warning: function warning(message) {
		return sendToastr(message, 'warning');
	}
};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1053),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(656);

var _promise2 = _interopRequireDefault(_promise);

var _loading = __webpack_require__(920);

var _loading2 = _interopRequireDefault(_loading);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _loading3 = __webpack_require__(906);

var _loading4 = _interopRequireDefault(_loading3);

var _axios = __webpack_require__(426);

var _axios2 = _interopRequireDefault(_axios);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_MESSAGE = 'Nosso sistema está passando por uma atualização. Por favor, tente novamente em alguns instantes.';
var SUPPORT_MESSAGE = 'Idenficamos um problema. Por favor, entre em contato com o suporte.';

var Http = _axios2.default.create({
	baseURL: '/api/',
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json; charset=utf-8'
	}
});

var loadingInstances = {};
var loadingOptions = {
	text: 'Carregando...'
};

Http.interceptors.request.use(function (config) {

	config.startTime = new Date().getTime();

	loadingInstances[config.startTime] = _loading4.default.service(loadingOptions);

	return config;
}, function (error) {

	loadingInstances[error.response.config.startTime].close();

	return _promise2.default.reject(error);
});

Http.interceptors.response.use(function (response) {

	response.config.endTime = new Date().getTime();
	loadingInstances[response.config.startTime].close();

	return response;
}, function (error) {

	if (error.response) {
		var _error$response = error.response,
		    status = _error$response.status,
		    data = _error$response.data;


		if (status === 404) {
			_toastr2.default.error(UPDATE_MESSAGE);
		}

		if (data.statusDescription) {

			if (status === 400 || status === 401 || status === 500) {
				_toastr2.default.error(data.statusDescription);
			}

			if (status === 412) {
				_toastr2.default.warning(data.statusDescription);
			}
		} else {

			if (status === 500) {
				_toastr2.default.error(SUPPORT_MESSAGE);
			}
		}
	}

	loadingInstances[error.response.config.startTime].close();

	return _promise2.default.reject(error);
});

exports.default = Http;

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1076),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

exports.default = {

	// https://github.com/jprichardson/string.js/blob/master/lib/string.js#L85
	capitalize: function capitalize(str) {
		return str.substr(0, 1).toUpperCase() + str.substring(1).toLowerCase();
	},

	// https://gist.github.com/TravelingTechGuy/32454b95a50d296912b9
	toQueryStringParameters: function toQueryStringParameters(obj) {

		return (0, _lodash.reduce)(obj, function (result, value, key) {

			if (!(0, _lodash.isNull)(value) && !(0, _lodash.isUndefined)(value)) {

				if ((0, _lodash.isArray)(value)) {

					result += (0, _lodash.reduce)(value, function (result1, value1) {

						if (!(0, _lodash.isNull)(value1) && !(0, _lodash.isUndefined)(value1)) {

							result1 += key + '=' + value1 + '&';
							return result1;
						} else {
							return result1;
						}
					}, '');
				} else {
					result += key + '=' + value + '&';
				}

				return result;
			} else {
				return result;
			}
		}, '').slice(0, -1);
	},

	toQueryString: function toQueryString(queryString, object) {
		return (queryString !== '?' ? '&' : '') + this.toQueryStringParameters(object);
	},

	makeQueryString: function makeQueryString(payload) {
		var queryString = '?';

		if (payload) {

			if (!(0, _lodash.isEmpty)(payload.filter)) {
				queryString += this.toQueryString(queryString, payload.filter);
			}

			if (!(0, _lodash.isEmpty)(payload.pagination)) {
				queryString += this.toQueryString(queryString, payload.pagination);
			}
		}

		if (queryString !== '?') {
			return queryString;
		}

		return '';
	}

};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1039),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1092),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7fdc0612",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1042),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1054),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1108),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c96989aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1083),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filteredResponse = function filteredResponse(context, payload, response) {
	var updateState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


	var data = [];

	if (payload.onlyPending) {

		data = response.data.map(function (item) {

			item.plans = item.plans.filter(function (plan) {
				return plan.date === undefined;
			});

			return item;
		});
	} else {
		data = response.data;
	}

	data = data.map(function (item) {

		item.plans = item.plans.map(function (plan) {

			plan.date = plan.date ? new Date(plan.date + 'T00:00:00') : null;

			return plan;
		});

		return item;
	});

	if (updateState) {
		context.commit('SET_SCHOOL_CLASS_LESSON_PLAN', data);
	}

	return data;
};

exports.default = {
	state: {
		list: [],
		report: []
	},
	getters: {
		schoolClassLessonPlan: function schoolClassLessonPlan(state) {
			return state.list;
		}
	},
	mutations: {
		SET_SCHOOL_CLASS_LESSON_PLAN: function SET_SCHOOL_CLASS_LESSON_PLAN(state, payload) {
			state.list = payload;
		},
		UDPATE_SCHOOL_CLASS_LESSON_PLAN: function UDPATE_SCHOOL_CLASS_LESSON_PLAN(state, payload) {
			state.list[payload.parentIndex].plans[payload.index] = payload.value;
		}
	},
	actions: {
		clearSchoolClassLessonPlan: function clearSchoolClassLessonPlan(context) {

			context.commit('SET_SCHOOL_CLASS_LESSON_PLAN', {});
		},
		getSchoolClassLessonPlan: function getSchoolClassLessonPlan(context, payload) {

			if (payload && payload.year && payload.theme && payload.class && payload.userId) {

				var route = 'v1/school-class-lesson-plan/theme/' + payload.theme + '/user/' + payload.userId + '?year=' + payload.year + '&class=' + payload.class;

				return _http2.default.get(route).then(function (response) {
					return filteredResponse(context, payload, response, true);
				});
			}
		},
		updateSchoolClassLessonPlan: function updateSchoolClassLessonPlan(context, payload) {
			context.commit('UDPATE_SCHOOL_CLASS_LESSON_PLAN', payload);
		},
		putSchoolClassLessonPlan: function putSchoolClassLessonPlan(context, payload) {

			if (payload && payload.schoolClassId && payload.themeId && payload.year && payload.userId) {

				var route = 'v1/school-class-lesson-plan/school-class/' + payload.schoolClassId + '/theme/' + payload.themeId + '/year/' + payload.year + '/user/' + payload.userId;

				return _http2.default.put(route, payload.data.map(function (plan) {

					plan.date = plan.date ? (0, _moment2.default)(plan.date).format('YYYY-MM-DD') : null;

					return plan;
				})).then(function (response) {
					return filteredResponse(context, payload, response);
				});
			}
		},
		getLessonReport: function getLessonReport(context, payload) {

			if (payload && payload.filter.schoolClassId && payload.filter.startDate && payload.filter.endDate) {

				var queryString = _string2.default.makeQueryString(payload.filter);

				return _http2.default.get('v1/school-class-lesson-plan/school-class/' + payload.filter.schoolClassId + '/user/' + payload.userId + '/report' + queryString).then(function (response) {

					return response;
				});
			}
		},
		copySchoolClassLessonPlan: function copySchoolClassLessonPlan(context, payload) {

			if (payload && payload.data && payload.themeId && payload.year && payload.userId) {

				var route = 'v1/school-class-lesson-plan/theme/' + payload.themeId + '/year/' + payload.year + '/user/' + payload.userId + '/copy';

				return _http2.default.post(route, payload.data).then(function (response) {

					return response;
				});
			}
		}
	}
};

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1100),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1085),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getAgenda: function getAgenda(context, payload) {

		if (payload && payload.userId && payload.studentId && payload.date) {
			var userId = payload.userId,
			    studentId = payload.studentId,
			    date = payload.date;


			var route = 'v2/agenda/user/' + userId + '?studentId=' + studentId + '&date=' + date;

			return _http2.default.get(route).then(function (response) {

				if (!response.data.additionalMeals) {
					response.data.additionalMeals = [];
				}

				if (!response.data.sleepy) {
					response.data.sleepy = [];
				}

				if (!response.data.evacuation) {
					response.data.evacuation = [];
				}

				if (!response.data.eventualMedicines) {
					response.data.eventualMedicines = [];
				}

				if (!response.data.questions) {
					response.data.questions = [];
				}

				if (!response.data.replacementItens) {
					response.data.replacementItens = [];
				}

				context.commit('SET_AGENDA', response.data);

				return response;
			});
		}
	},
	getAgendaStatus: function getAgendaStatus(context, payload) {

		if (payload && payload.userId && payload.schoolClassId && payload.date) {
			var userId = payload.userId,
			    schoolClassId = payload.schoolClassId,
			    date = payload.date;


			var route = 'v2/agenda/schoolClass/' + schoolClassId + '/day/' + date + '/user/' + userId + '/status';

			return _http2.default.get(route).then(function (response) {

				context.commit('SET_STUDENT_STATUS', response.data);
				return response;
			});
		}
	},
	saveAgenda: function saveAgenda(context) {

		if (!context.getters.getAgendaCompletionStatus.eventualMedicine) {
			return _toastr2.default.warning('Há itens não incluídos no bloco de medicação eventual.');
		}

		if (!context.getters.getAgendaCompletionStatus.nap) {
			return _toastr2.default.warning('Há itens não incluídos no bloco de soneca.');
		}

		if (!context.getters.getAgendaCompletionStatus.evacuation) {
			return _toastr2.default.warning('Há itens não incluídos no bloco de evacuação.');
		}

		if (!context.getters.getAgendaCompletionStatus.additionalMeal) {
			return _toastr2.default.warning('Há itens não incluídos no bloco de alimentos adicionais.');
		}

		var payload = {};

		var _context$getters = context.getters,
		    user = _context$getters.getLoggedUser,
		    student = _context$getters.getStudent,
		    agenda = _context$getters.getAgenda,
		    klass = _context$getters.getClass;


		var date = context.getters.getAgendaDate;
		date = typeof date === 'string' ? date : date.toISOString();

		var route = 'v2/agenda/user/' + user.id + '/student/' + student.studentId + '/date/' + date.split('T')[0];

		function getClassLevel(level) {

			return {
				'Bercario': 'KID',
				'Infantil': 'KID',
				'Fundamental_1': 'CHILD',
				'Fundamental_2': 'YOUNG',
				'EnsinoMedio': 'TEEN',
				'Universitario': ''
			}[level];
		}

		var classLevel = getClassLevel(klass.schoolClassLevel);

		delete agenda.creationDateTime;
		delete agenda.updateUserLog;

		payload.type = classLevel;
		payload['agenda' + _string2.default.capitalize(classLevel)] = agenda;

		return _http2.default.post(route, payload).then(function (response) {

			_toastr2.default.success('Agenda salva com sucesso!');

			context.commit('SET_AGENDA', response.data);

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'eventualMedicine',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'nap',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'evacuation',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'additionalMeal',
				value: true
			});

			_eventBus.EventBus.$emit('agendaSaved', response.data);

			return response;
		});
	},
	publishAgenda: function publishAgenda(context) {
		var _context$getters2 = context.getters,
		    user = _context$getters2.getLoggedUser,
		    student = _context$getters2.getStudent,
		    klass = _context$getters2.getClass;


		var date = context.getters.getAgendaDate;
		date = typeof date === 'string' ? date : date.toISOString();

		var route = 'v2/agenda/user/' + user.id + '/publish';

		return _http2.default.post(route, {
			schoolClassId: klass.schoolClassId,
			studentId: student.studentId,
			date: date.split('T')[0]
		}).then(function (response) {

			context.commit('SET_AGENDA', response.data);
			_toastr2.default.success('Agenda publicada com sucesso!');

			_eventBus.EventBus.$emit('agendaPublished', response.data);

			return response;
		});
	},
	publishAllAgendas: function publishAllAgendas(context) {
		var _context$getters3 = context.getters,
		    user = _context$getters3.getLoggedUser,
		    klass = _context$getters3.getClass;


		var date = context.getters.getAgendaDate;
		date = typeof date === 'string' ? date : date.toISOString();

		var route = 'v2/agenda/user/' + user.id + '/publish-all';

		return _http2.default.post(route, {
			schoolClassId: klass.schoolClassId,
			date: date.split('T')[0]
		}).then(function (response) {

			context.commit('SET_AGENDA', response.data);
			_toastr2.default.success('Agendas publicadas com sucesso!');

			_eventBus.EventBus.$emit('agendaPublishedAll', response.data);

			return response;
		});
	},
	putAgendaDate: function putAgendaDate(context, payload) {
		context.commit('PUT_AGENDA_DATE', payload);
	},
	putAgendaWater: function putAgendaWater(context, payload) {
		context.commit('PUT_AGENDA_WATER', payload.target.value);
	},
	putAgendaHumor: function putAgendaHumor(context, payload) {
		context.commit('PUT_AGENDA_HUMOR', payload.target.value);
	},
	putAgendaUrine: function putAgendaUrine(context, payload) {
		context.commit('PUT_AGENDA_URINE', payload.target.value);
	},
	putAgendaBrush: function putAgendaBrush(context, payload) {
		context.commit('PUT_AGENDA_BRUSH', payload.target.value);
	},
	putAgendaBathQuantity: function putAgendaBathQuantity(context, payload) {
		context.commit('PUT_AGENDA_BATH_QUANTITY', payload.target.value);
	},
	putAgendaDiaperQuantity: function putAgendaDiaperQuantity(context, payload) {
		context.commit('PUT_AGENDA_DIAPER_QUANTITY', payload.target.value);
	},
	putAgendaMealPortion: function putAgendaMealPortion(context, payload) {

		context.commit('PUT_AGENDA_MEAL_PORTION', {
			index: parseInt(payload.target.dataset.index),
			value: payload.target.value
		});
	},
	putAgendaBeveragePortion: function putAgendaBeveragePortion(context, payload) {

		context.commit('PUT_AGENDA_BEVERAGE_PORTION', {
			index: parseInt(payload.target.dataset.index),
			value: payload.target.value
		});
	},
	postAgendaAdditionalMealsItem: function postAgendaAdditionalMealsItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = payload.time + ':00';
		}

		context.commit('POST_AGENDA_ADDITIONAL_FOOD_ITEM', payload);
	},
	putAgendaAdditionalMealsItem: function putAgendaAdditionalMealsItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = payload.time + ':00';
		}

		context.commit('PUT_AGENDA_ADDITIONAL_FOOD_ITEM', payload);
	},
	deleteAdditionalMealsItem: function deleteAdditionalMealsItem(context, payload) {
		context.commit('DELETE_ADDITIONAL_MEALS_ITEM', payload);
	},
	putAgendaScheduledMedicine: function putAgendaScheduledMedicine(context, payload) {

		context.commit('PUT_AGENDA_SCHEDULED_MEDICINE', {
			index: payload.target.dataset.index,
			value: payload.target.checked
		});
	},
	putAgendaObservation: function putAgendaObservation(context, payload) {
		context.commit('PUT_AGENDA_OBSERVATION', payload.target.value);
	},
	putAgendaActivities: function putAgendaActivities(context, payload) {

		context.commit('PUT_AGENDA_ACTIVITIES', {
			index: payload.target.dataset.index,
			value: payload.target.checked
		});
	},
	putAgendaParticipation: function putAgendaParticipation(context, payload) {
		context.commit('PUT_AGENDA_PARTICIPATION', payload.target.value);
	},
	putAgendaPresence: function putAgendaPresence(context, payload) {
		context.commit('PUT_AGENDA_PRESENCE', payload.target.value);
	},
	postAgendaQuestions: function postAgendaQuestions(context, payload) {

		context.commit('POST_AGENDA_QUESTIONS', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});
	},
	putAgendaQuestions: function putAgendaQuestions(context, payload) {

		context.commit('PUT_AGENDA_QUESTIONS', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});
	},
	deleteNapItem: function deleteNapItem(context, payload) {
		context.commit('DELETE_NAP_ITEM', payload);
	},
	deleteEvacuationItem: function deleteEvacuationItem(context, payload) {
		context.commit('DELETE_EVACUATION_ITEM', payload);
	},
	deleteEventualMedicineItem: function deleteEventualMedicineItem(context, payload) {
		context.commit('DELETE_EVENTUAL_MEDICINE_ITEM', payload);
	},
	postAgendaNapsItem: function postAgendaNapsItem(context, payload) {

		if (payload.startTime.length === 5) {
			payload.startTime = payload.startTime + ':00';
		}

		if (payload.endTime.length === 5) {
			payload.endTime = payload.endTime + ':00';
		}

		context.commit('POST_AGENDA_NAPS_ITEM', payload);
	},
	putAgendaNapsItem: function putAgendaNapsItem(context, payload) {

		if (payload.startTime.length === 5) {
			payload.startTime = payload.startTime + ':00';
		}

		if (payload.endTime.length === 5) {
			payload.endTime = payload.endTime + ':00';
		}

		context.commit('PUT_AGENDA_NAPS_ITEM', payload);
	},
	postAgendaEventualMedicineItem: function postAgendaEventualMedicineItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = payload.time + ':00';
		}

		context.commit('POST_AGENDA_EVENTUAL_MEDICINE_ITEM', payload);
	},
	putAgendaEventualMedicineItem: function putAgendaEventualMedicineItem(context, payload) {
		context.commit('PUT_AGENDA_EVENTUAL_MEDICINE_ITEM', payload);
	},
	postAgendaEvacuationItem: function postAgendaEvacuationItem(context, payload) {
		context.commit('POST_EVACUATION_ITEM', payload);
	},
	putAgendaEvacuationItem: function putAgendaEvacuationItem(context, payload) {
		context.commit('PUT_EVACUATION_ITEM', payload);
	},
	putAgendaRestockingItem: function putAgendaRestockingItem(context, payload) {
		context.commit('PUT_RESTOCKING_ITEM', payload);
	},
	putAgendaScheduledHomework: function putAgendaScheduledHomework(context, payload) {

		context.commit('PUT_AGENDA_SCHEDULED_HOMEWORK', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});
	},
	putAgendaExclusiveHomework: function putAgendaExclusiveHomework(context, payload) {
		context.commit('PUT_EXCLUSIVE_HOMEWORK', payload);
	},
	putCompletionStatus: function putCompletionStatus(context, payload) {
		context.commit('PUT_COMPLETION_STATUS', payload);
	},
	copyHomeworkbyClass: function copyHomeworkbyClass(context, payload) {
		context.commit('PUT_EXCLUSIVE_HOMEWORK_ID', payload);
	},
	pushReplacementItem: function pushReplacementItem(context, payload) {

		var payloadClone = (0, _lodash.cloneDeep)(payload);
		payloadClone.dueDate = (0, _moment2.default)(payloadClone.dueDate).format('YYYY-MM-DD');

		context.commit('PUSH_REPLACEMENT_ITEM', payloadClone);
	},
	putReplacementItem: function putReplacementItem(context, payload) {
		context.commit('PUT_REPLACEMENT_ITEM', payload);
	},
	removeReplacementItem: function removeReplacementItem(context, payload) {
		context.commit('DELETE_REPLACEMENT_ITEM', payload);
	}
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getAgenda: function getAgenda(state) {
		return state.agenda;
	},
	getAgendaDate: function getAgendaDate(state) {
		return state.date;
	},
	getAgendaHumor: function getAgendaHumor(state) {
		return state.agenda.humor;
	},
	getAdditionalMeals: function getAdditionalMeals(state) {
		return state.agenda.additionalMeals;
	},
	getAgendaRegularMedicines: function getAgendaRegularMedicines(state) {
		return state.agenda.regularMedicines;
	},
	getAgendaScheduledHomework: function getAgendaScheduledHomework(state) {
		return state.agenda.scheduledHomework;
	},
	getAgendaSleepy: function getAgendaSleepy(state) {
		return state.agenda.sleepy;
	},
	getAgendaCompletionStatus: function getAgendaCompletionStatus(state) {
		return state.completionStatus;
	},
	getAgendaExclusiveHomework: function getAgendaExclusiveHomework(state) {
		return state.agenda.exclusiveHomework;
	},
	getReplacementItens: function getReplacementItens(state) {
		return state.agenda.replacementItens;
	}
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	PUT_AGENDA_DATE: function PUT_AGENDA_DATE(state, payload) {
		state.date = payload;
	},
	SET_AGENDA_HOMEWORK: function SET_AGENDA_HOMEWORK(state, payload) {
		state.homework = payload;
	},
	SET_AGENDA: function SET_AGENDA(state, payload) {
		state.agenda = payload;
	},
	PUT_AGENDA_WATER: function PUT_AGENDA_WATER(state, payload) {
		state.agenda.water = payload;
	},
	PUT_AGENDA_HUMOR: function PUT_AGENDA_HUMOR(state, payload) {
		state.agenda.humor = payload;
	},
	PUT_AGENDA_URINE: function PUT_AGENDA_URINE(state, payload) {
		state.agenda.piss = payload;
	},
	PUT_AGENDA_BRUSH: function PUT_AGENDA_BRUSH(state, payload) {
		state.agenda.brush = payload;
	},
	PUT_AGENDA_DIAPER_QUANTITY: function PUT_AGENDA_DIAPER_QUANTITY(state, payload) {
		state.agenda.diaperQuantity = payload;
	},
	PUT_AGENDA_BATH_QUANTITY: function PUT_AGENDA_BATH_QUANTITY(state, payload) {
		state.agenda.bathQuantity = payload;
	},
	PUT_AGENDA_MEAL_PORTION: function PUT_AGENDA_MEAL_PORTION(state, payload) {
		state.agenda.meals[payload.index].mealPortion = payload.value;
	},
	PUT_AGENDA_BEVERAGE_PORTION: function PUT_AGENDA_BEVERAGE_PORTION(state, payload) {
		state.agenda.meals[payload.index].beveragePortion = payload.value;
	},
	POST_AGENDA_ADDITIONAL_FOOD_ITEM: function POST_AGENDA_ADDITIONAL_FOOD_ITEM(state, payload) {

		if (!state.agenda.additionalMeals) {
			state.agenda.additionalMeals = [];
		}

		state.agenda.additionalMeals.push(payload);
	},
	PUT_AGENDA_ADDITIONAL_FOOD_ITEM: function PUT_AGENDA_ADDITIONAL_FOOD_ITEM(state, payload) {

		state.agenda.additionalMeals[payload.index] = payload;
		delete state.agenda.additionalMeals[payload.index].index;
	},
	DELETE_ADDITIONAL_MEALS_ITEM: function DELETE_ADDITIONAL_MEALS_ITEM(state, payload) {
		state.agenda.additionalMeals.splice(payload, 1);
	},
	PUT_AGENDA_SCHEDULED_MEDICINE: function PUT_AGENDA_SCHEDULED_MEDICINE(state, payload) {
		state.agenda.regularMedicines[payload.index].isTaken = payload.value;
	},
	PUT_AGENDA_OBSERVATION: function PUT_AGENDA_OBSERVATION(state, payload) {
		state.agenda.observation = payload;
	},
	PUT_AGENDA_ACTIVITIES: function PUT_AGENDA_ACTIVITIES(state, payload) {
		state.agenda.activities[payload.index].fulfilled = payload.value;
	},
	PUT_AGENDA_PARTICIPATION: function PUT_AGENDA_PARTICIPATION(state, payload) {
		state.agenda.participation = payload;
	},
	PUT_AGENDA_PRESENCE: function PUT_AGENDA_PRESENCE(state, payload) {
		state.agenda.presence = payload;
	},
	POST_AGENDA_QUESTIONS: function POST_AGENDA_QUESTIONS(state, payload) {

		if (!state.agenda.questions) {
			state.agenda.questions = [];
		}

		state.agenda.questions[payload.index].answer = payload.value;
	},
	PUT_AGENDA_QUESTIONS: function PUT_AGENDA_QUESTIONS(state, payload) {
		state.agenda.questions[payload.index].answer = payload.value;
	},
	DELETE_NAP_ITEM: function DELETE_NAP_ITEM(state, payload) {
		state.agenda.sleepy.splice(payload, 1);
	},
	DELETE_EVACUATION_ITEM: function DELETE_EVACUATION_ITEM(state, payload) {
		state.agenda.evacuation.splice(payload, 1);
	},
	DELETE_EVENTUAL_MEDICINE_ITEM: function DELETE_EVENTUAL_MEDICINE_ITEM(state, payload) {
		state.agenda.eventualMedicines.splice(payload, 1);
	},
	POST_AGENDA_NAPS_ITEM: function POST_AGENDA_NAPS_ITEM(state, payload) {

		if (!state.agenda.sleepy) {
			state.agenda.sleepy = [];
		}

		state.agenda.sleepy.push(payload);
	},
	PUT_AGENDA_NAPS_ITEM: function PUT_AGENDA_NAPS_ITEM(state, payload) {

		state.agenda.sleepy[payload.index] = payload;
		delete state.agenda.sleepy[payload.index].index;
	},
	POST_AGENDA_EVENTUAL_MEDICINE_ITEM: function POST_AGENDA_EVENTUAL_MEDICINE_ITEM(state, payload) {

		if (!state.agenda.eventualMedicines) {
			state.agenda.eventualMedicines = [];
		}

		state.agenda.eventualMedicines.push(payload);
	},
	PUT_AGENDA_EVENTUAL_MEDICINE_ITEM: function PUT_AGENDA_EVENTUAL_MEDICINE_ITEM(state, payload) {

		state.agenda.eventualMedicines[payload.index] = payload;
		delete state.agenda.eventualMedicines[payload.index].index;
	},
	POST_EVACUATION_ITEM: function POST_EVACUATION_ITEM(state, payload) {

		if (!state.agenda.evacuation) {
			state.agenda.evacuation = [];
		}

		state.agenda.evacuation.push(payload);
	},
	PUT_EVACUATION_ITEM: function PUT_EVACUATION_ITEM(state, payload) {

		state.agenda.evacuation[payload.index] = payload;
		delete state.agenda.evacuation[payload.index].index;
	},
	PUT_AGENDA_SCHEDULED_HOMEWORK: function PUT_AGENDA_SCHEDULED_HOMEWORK(state, payload) {
		state.agenda.scheduledHomework[payload.index].status = payload.value;
	},
	PUT_COMPLETION_STATUS: function PUT_COMPLETION_STATUS(state, payload) {
		state.completionStatus[payload.key] = payload.value;
	},
	PUT_EXCLUSIVE_HOMEWORK: function PUT_EXCLUSIVE_HOMEWORK(state, payload) {
		state.agenda.exclusiveHomework.themes[payload.index] = payload.theme;
	},
	PUT_EXCLUSIVE_HOMEWORK_ID: function PUT_EXCLUSIVE_HOMEWORK_ID(state, payload) {
		state.agenda.exclusiveHomework.themes[payload.index] = payload.themes[payload.index];
	},
	PUSH_REPLACEMENT_ITEM: function PUSH_REPLACEMENT_ITEM(state, payload) {

		if (!state.agenda.replacementItens) {
			state.agenda.replacementItens = [];
		}

		state.agenda.replacementItens.push(payload);
	},
	PUT_REPLACEMENT_ITEM: function PUT_REPLACEMENT_ITEM(state, payload) {

		delete payload.value.index;
		state.agenda.replacementItens[payload.index] = payload.value;
	},
	DELETE_REPLACEMENT_ITEM: function DELETE_REPLACEMENT_ITEM(state, payload) {
		state.agenda.replacementItens.splice(payload, 1);
	}
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	date: (0, _moment2.default)().format('YYYY-MM-DD'),
	agenda: {
		replacementItens: []
	},
	completionStatus: {
		eventualMedicine: true,
		nap: true,
		evacuation: true,
		additionalMeal: true
	}
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		list: {}
	},
	getters: {
		evaluationQuestionsList: function evaluationQuestionsList(state) {
			return state.list;
		},
		evaluationQuestions: function evaluationQuestions(state) {
			return state.list.questions;
		},
		evaluationStudentsQuestions: function evaluationStudentsQuestions(state) {
			return state.list.students;
		},
		evaluationType: function evaluationType(state) {
			return state.list.type;
		}
	},
	mutations: {
		SET_EVALUATION_QUESTION_LIST: function SET_EVALUATION_QUESTION_LIST(state, payload) {
			state.list = payload;
		},
		SET_EVALUATION_QUESTION_ANSWER: function SET_EVALUATION_QUESTION_ANSWER(state, payload) {

			var student = state.list.students.filter(function (student) {
				return student.student.studentId === payload.student;
			})[0];
			var question = student.questions.filter(function (question) {
				return question.id === payload.question;
			})[0];

			question.answer = payload.answer;
		}
	},
	actions: {
		setEvaluationQuestionAnswer: function setEvaluationQuestionAnswer(context, payload) {
			context.commit('SET_EVALUATION_QUESTION_ANSWER', payload);
		},
		clearEvaluationQuestion: function clearEvaluationQuestion(context) {
			context.commit('SET_EVALUATION_QUESTION_LIST', {});
		},
		getEvaluationQuestion: function getEvaluationQuestion(context, payload) {

			if (payload.userId && payload.schoolClassId) {

				var route = 'v2/evaluation-question/user/' + payload.userId + '?schoolClassId=' + payload.schoolClassId;

				return _http2.default.get(route).then(function (response) {

					context.commit('SET_EVALUATION_QUESTION_LIST', response.data);

					return response;
				});
			}
		},
		saveEvaluationQuestion: function saveEvaluationQuestion(context, payload) {

			if (payload.data && payload.userId && payload.schoolClassId) {

				var route = 'v2/evaluation-question/user/' + payload.userId;
				var data = payload.data;

				delete data.questions;

				return _http2.default.post(route, (0, _extends3.default)({
					userId: payload.userId,
					schoolClassId: payload.schoolClassId
				}, data)).then(function (response) {

					context.commit('SET_EVALUATION_QUESTION_LIST', response.data);

					return response;
				});
			}
		}
	}
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(210);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _card = __webpack_require__(271);

var _card2 = _interopRequireDefault(_card);

var _card3 = __webpack_require__(263);

var _card4 = _interopRequireDefault(_card3);

var _upload = __webpack_require__(273);

var _upload2 = _interopRequireDefault(_upload);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _upload3 = __webpack_require__(265);

var _upload4 = _interopRequireDefault(_upload3);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _lodash = __webpack_require__(9);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _students = __webpack_require__(89);

var _students2 = _interopRequireDefault(_students);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'album',
	components: {
		PageBar: _pageBar2.default,
		Students: _students2.default,
		Upload: _upload4.default,
		Card: _card4.default,
		ClassList: _main2.default
	},
	data: function data() {
		return {
			showAssingVisible: false,
			viewersGalleryType: '',
			dataUpload: {
				title: '',
				description: '',
				id: ''
			},
			isEdit: false,
			assingPhotos: [],
			checkPhoto: []
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['album', 'getLoggedUser', 'ENUM', 'getClass', 'getStudent'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'setAlbum', 'newAlbum', 'unpublishAlbum', 'setUpload', 'unpublishPhotos', 'publishPhotos', 'publishAlbum', 'setInfoPhoto', 'editAlbum', 'removePhoto', 'putAssignPhotoUsers', 'cleanAlbum']), {
		selectPhotos: function selectPhotos(event, photo) {

			if (event.target.checked) {
				this.assingPhotos.push(photo);
			} else {
				this.assingPhotos = (0, _lodash.filter)(this.assingPhotos, function (n) {
					return n.id !== photo.id;
				});
			}
		},
		unselectAllPhotos: function unselectAllPhotos() {
			this.assingPhotos = [];
		},
		selectAllPhotos: function selectAllPhotos() {

			this.assingPhotos = (0, _lodash.cloneDeep)(this.album.photos);
		},
		deletePhoto: function deletePhoto(id) {
			var _this = this;

			this.removePhoto({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_toastr2.default.success(_this.$gettext('Foto excluída com sucesso!'));
				_this.setAlbum({
					userId: _this.getLoggedUser.id,
					id: _this.$route.params.id
				});
			});
		},
		isChecked: function isChecked(id) {

			var photosId = [];

			this.assingPhotos.forEach(function (value) {
				photosId.push(value.id);
			});

			return (0, _lodash.includes)(photosId, id);
		},
		changeInfoPhoto: function changeInfoPhoto(id, title, description) {

			this.setInfoPhoto({
				id: id,
				infoPhoto: {
					title: title,
					description: description
				},
				userId: this.getLoggedUser.id
			});
		},
		getStatusLabelColor: function getStatusLabelColor(status) {

			var redClass = 'bg-red-flamingo bg-font-red-flamingo';
			var yellowClass = 'bg-yellow-lemon bg-font-yellow-lemon';
			var grayClass = 'bg-grey-salsa bg-font-grey-salsa';
			var greenClass = 'bg-green-jungle bg-font-green-jungle';

			return {
				'NOT_CREATED': redClass,
				'CREATED': yellowClass,
				'IN_APPROVAL': yellowClass,
				'IN_REVISION': redClass,
				'PROCESSING': grayClass,
				'REPROCESS': yellowClass,
				'APPROVED': greenClass,
				'SENT': greenClass,
				'READED': greenClass
			}[status];
		},
		unpublishPhotoItem: function unpublishPhotoItem() {
			var _this2 = this;

			var photos = [];

			this.assingPhotos.forEach(function (value) {
				photos.push(value.id);
			});

			this.unpublishPhotos({
				id: this.$route.params.id,
				userId: this.getLoggedUser.id,
				photos: photos
			}).then(function () {
				_toastr2.default.success(_this2.$gettext('Fotos despublicadas com sucesso!'));
				_this2.setAlbum({
					userId: _this2.getLoggedUser.id,
					id: _this2.$route.params.id
				});
			});
		},
		publishPhotoItem: function publishPhotoItem() {
			var _this3 = this;

			var photos = [];

			this.assingPhotos.forEach(function (value) {
				photos.push(value.id);
			});

			this.publishPhotos({
				id: this.$route.params.id,
				userId: this.getLoggedUser.id,
				photos: photos
			}).then(function () {
				_toastr2.default.success(_this3.$gettext('Fotos publicadas com sucesso!'));
				_this3.setAlbum({
					userId: _this3.getLoggedUser.id,
					id: _this3.$route.params.id
				});
			});
		},
		dataUploadStringify: function dataUploadStringify() {
			return {
				album: (0, _stringify2.default)(this.dataUpload)
			};
		},
		createAlbum: function createAlbum() {
			var _this4 = this;

			if (this.isEdit === false) {

				if (this.viewersGalleryType == 'SCHOOL_CLASS') {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getClass,
						scope: 'SCHOOL_CLASS'
					}).then(function (response) {
						_this4.dataUpload.id = response.id;
						_this4.$route.params.id = response.id;
						_this4.isEdit = true;
						_toastr2.default.success(_this4.$gettext('Álbum criado com sucesso!'));
					});
				} else if (this.viewersGalleryType == 'STUDENT') {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						students: this.getStudent,
						scope: 'STUDENT'
					}).then(function (response) {
						_this4.dataUpload.id = response.id;
						_this4.$route.params.id = response.id;
						_this4.isEdit = true;
						_toastr2.default.success(_this4.$gettext('Álbum criado com sucesso!'));
					});
				} else {

					this.newAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						scope: 'ALL'
					}).then(function (response) {
						_this4.dataUpload.id = response.id;
						_this4.$route.params.id = response.id;
						_this4.isEdit = true;
						_toastr2.default.success(_this4.$gettext('Álbum criado com sucesso!'));
					});
				}
			} else {

				if (this.viewersGalleryType == 'SCHOOL_CLASS') {

					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getClass,
						scope: 'SCHOOL_CLASS'
					}).then(function () {
						_toastr2.default.success(_this4.$gettext('Álbum editado com sucesso!'));
					});
				} else if (this.viewersGalleryType == 'STUDENT') {

					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						schoolClass: this.getStudent,
						scope: 'STUDENT'
					}).then(function () {
						_toastr2.default.success(_this4.$gettext('Álbum editado com sucesso!'));
					});
				} else {
					this.editAlbum({
						userId: this.getLoggedUser.id,
						album: this.dataUpload,
						scope: 'ALL'
					}).then(function () {
						_toastr2.default.success(_this4.$gettext('Álbum editado com sucesso!'));
					});
				}
			}
		},
		upload: function upload(response) {
			var _this5 = this;

			this.setUpload(response).then(function () {
				_this5.album;
			});
		},
		publish: function publish(id) {
			var _this6 = this;

			this.publishAlbum({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_toastr2.default.success(_this6.$gettext('Álbum publicado com sucesso!'));
			});
		},
		unpublish: function unpublish(id) {
			var _this7 = this;

			this.unpublishAlbum({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_toastr2.default.success(_this7.$gettext('Álbum despublicado com sucesso!'));
			});
		}
	}),
	created: function created() {
		var _this8 = this;

		if (this.$route.params.id) {
			this.isEdit = true;
		}

		if (this.$route.params.id === undefined) {
			this.$route.params.id = '';
		}

		if (this.isEdit) {

			this.setAlbum({
				userId: this.getLoggedUser.id,
				id: this.$route.params.id
			}).then(function () {

				if (_this8.isEdit) {
					_this8.viewersGalleryType = _this8.album.scope;
					_this8.classList = _this8.album.schoolClasses;
					_this8.student = _this8.album.students;
					_this8.dataUpload = {
						id: _this8.$route.params.id,
						title: _this8.album.title,
						description: _this8.album.description
					};
				} else {
					_this8.dataUpload = {
						id: '',
						title: '',
						description: ''
					};
				}
			});
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.$route.params.id = '';
		_eventBus.EventBus.$off('showAssing');

		this.cleanAlbum();
	},
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Galeria'
		}, {
			text: 'Álbum'
		}]);
	}
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _card = __webpack_require__(271);

var _card2 = _interopRequireDefault(_card);

var _card3 = __webpack_require__(263);

var _card4 = _interopRequireDefault(_card3);

var _pagination = __webpack_require__(167);

var _pagination2 = _interopRequireDefault(_pagination);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _pagination3 = __webpack_require__(162);

var _pagination4 = _interopRequireDefault(_pagination3);

var _vuex = __webpack_require__(4);

var _students = __webpack_require__(89);

var _students2 = _interopRequireDefault(_students);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _eventBus = __webpack_require__(5);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main3 = __webpack_require__(119);

var _main4 = _interopRequireDefault(_main3);

var _state = __webpack_require__(449);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(446);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(448);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(447);

var _getters2 = _interopRequireDefault(_getters);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'gallery',
	components: {
		PageBar: _pageBar2.default,
		ClassGrade: _main4.default,
		SchoolClassList: _main2.default,
		Students: _students2.default,
		Pagination: _pagination4.default,
		Card: _card4.default,
		ClassList: _main2.default

	},
	data: function data() {
		return {
			albumName: '',
			payloadFilter: {},
			studentName: '',
			scopeFilter: '',
			classList: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'list', 'settings', 'ENUM', 'getClass'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'setAlbunsList', 'publishAlbum', 'unpublishAlbum', 'setAlbum', 'getAlbumList']), {
		filter: function filter() {
			var queryFilter = {
				description: this.albumName,
				studentName: this.studentName,
				scope: this.scopeFilter,
				schoolClassId: this.getClass.schoolClassId
			};

			return this.setAlbunsList({
				userId: this.getLoggedUser.id,
				filter: queryFilter
			});
		},
		publish: function publish(id) {
			var _this = this;

			this.publishAlbum({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_toastr2.default.success(_this.$gettext('Álbum publicado com sucesso!'));
				_eventBus.EventBus.$emit('albumListChange');
			});
		},
		unpublish: function unpublish(id) {
			var _this2 = this;

			this.unpublishAlbum({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_toastr2.default.success(_this2.$gettext('Álbum despublicado com sucesso!'));
				_eventBus.EventBus.$emit('albumListChange');
			});
		},
		handleCurrentChange: function handleCurrentChange(page) {

			this.payloadFilter.pagination = {
				quantity: this.settings.Pagination.pageSize,
				page: page - 1,
				albumName: this.albumName
			};

			this.payloadFilter.userId = this.getLoggedUser.id;

			this.getAlbumList(this.payloadFilter);
		}
	}),
	beforeDestroy: function beforeDestroy() {
		_eventBus.EventBus.$off('albumListChange');
	},
	mounted: function mounted() {
		var _this3 = this;

		this.handleCurrentChange(1);

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Galeria'
		}]);

		_eventBus.EventBus.$on('albumListChange', function () {

			_this3.setAlbunsList({
				userId: _this3.getLoggedUser.id,
				albumName: _this3.albumName
			});
		});
	}
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _state = __webpack_require__(456);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(450);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(452);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(451);

var _getters2 = _interopRequireDefault(_getters);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _sidebarMenu = __webpack_require__(118);

var _sidebarMenu2 = _interopRequireDefault(_sidebarMenu);

var _messageReceived = __webpack_require__(1016);

var _messageReceived2 = _interopRequireDefault(_messageReceived);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'inbox',
	components: {
		PageBar: _pageBar2.default,
		SidebarMenu: _sidebarMenu2.default,
		MessageReceived: _messageReceived2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getMessageReceivedList'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMessageRecipient', 'putUnreadMessages'])),
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);

		/*window.parent.postMessage({
  	schoolastic: {
  		getNotificationQuantity: true
  	}
  }, '*');
  	window.addEventListener('message', (event) => {
  	console.log('waiting notificationQuantity', event);
  		if (event.data.schoolastic && event.data.schoolastic.notificationQuantity) {
  		this.putUnreadMessages(event.data.schoolastic.notificationQuantity);
  	}
  	}, false);*/
	}
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _vueDigitalClock = __webpack_require__(1028);

var _vueDigitalClock2 = _interopRequireDefault(_vueDigitalClock);

var _paginateArray = __webpack_require__(960);

var _paginateArray2 = _interopRequireDefault(_paginateArray);

var _screenfull = __webpack_require__(962);

var screenfull = _interopRequireWildcard(_screenfull);

var _actions = __webpack_require__(457);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(459);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(458);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(460);

var _state2 = _interopRequireDefault(_state);

var _eventBus = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'leaving-monitor',
	data: function data() {
		return {
			paginateCollection: []
		};
	},
	components: {
		Clock: _vueDigitalClock2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		userId: function userId(state) {
			return state.Logged.user.id;
		}
	}), (0, _vuex.mapGetters)({
		students: 'students'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getLeavingMonitor', 'postStudentRelease']), {
		removeStudentItem: function removeStudentItem(student) {

			this.postStudentRelease(student).then(function () {
				_eventBus.EventBus.$emit('loadMonitor');
			});
		},
		fullscreen: function fullscreen() {

			if (screenfull.enabled) {
				screenfull.toggle();
			}
		},
		loadMonitor: function loadMonitor() {
			var _this = this;

			var currentPage = 1;

			this.getLeavingMonitor(this.userId).then(function () {

				_this.paginateCollection = (0, _paginateArray2.default)(_this.students, currentPage);
			}).then(function () {

				setInterval(function () {
					currentPage++;
					if (_this.paginateCollection.totaPages >= currentPage) {
						_this.paginateCollection = (0, _paginateArray2.default)(_this.students, currentPage);
					}
					if (_this.paginateCollection.totaPages + 1 === currentPage) {
						currentPage = 0;
					}
				}, 10000);
			});
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		this.loadMonitor();

		_eventBus.EventBus.$on('loadMonitor', function () {
			_this2.loadMonitor();
		});

		setInterval(function () {
			_eventBus.EventBus.$emit('loadMonitor');
		}, 1000 * 40);
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('loadMonitor');
	}
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getMealMenu: function getMealMenu(context, payload) {

		if (payload) {

			var queryString = _string2.default.makeQueryString(payload);

			return _http2.default.get('v2/school-meal-menu/user/' + payload.userId + queryString).then(function (response) {

				context.commit('SET_MEAL_MENU', response.data.map(function (item) {

					item.isBefore = (0, _moment2.default)(item.date).add(1, 'day').isBefore();

					return item;
				}));

				return response;
			});
		}
	},
	putMealMenu: function putMealMenu(context, payload) {

		if (payload) {

			return _http2.default.put('v2/school-meal-menu/user/' + payload.userId, payload.data).then(function (response) {

				context.commit('SET_MEAL_MENU', response.data);

				return response;
			});
		}
	},
	updateMealMenu: function updateMealMenu(context, payload) {

		if (payload) {
			context.commit('SET_MEAL_MENU', payload);
		}
	},
	removeMeal: function removeMeal(context, payload) {

		if (payload.mealId && payload.userId) {

			return _http2.default.delete('v2/school-meal-menu/' + payload.mealId + '/user/' + payload.userId).then(function (response) {

				return response;
			});
		}
	}
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	mealMenu: function mealMenu(state) {
		return state.list;
	}
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_MEAL_MENU: function SET_MEAL_MENU(state, payload) {
		state.list = payload;
	},
	SET_MEAL_MENU_ITEM: function SET_MEAL_MENU_ITEM(state, payload) {
		state.list[payload.index].times.push(payload.data);
	}
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: []
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _medicineFilters = __webpack_require__(1023);

var _medicineFilters2 = _interopRequireDefault(_medicineFilters);

var _medicineLabels = __webpack_require__(1025);

var _medicineLabels2 = _interopRequireDefault(_medicineLabels);

var _medicinePending = __webpack_require__(1026);

var _medicinePending2 = _interopRequireDefault(_medicinePending);

var _medicineHistory = __webpack_require__(1024);

var _medicineHistory2 = _interopRequireDefault(_medicineHistory);

var _actions = __webpack_require__(464);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(466);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(465);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(467);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'medicine',
	components: {
		MedicineFilters: _medicineFilters2.default,
		MedicineLabels: _medicineLabels2.default,
		MedicinePending: _medicinePending2.default,
		MedicineHistory: _medicineHistory2.default,
		PageBar: _pageBar2.default
	},
	data: function data() {
		return {
			datepicker: {
				today: new Date(),
				selected: new Date()
			},
			student: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser',
		history: 'medicineHistory',
		pending: 'medicinePending'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMedicine', 'getMedicineIsTaken', 'setMedicineHistory', 'setMedicinePending']), {
		retriveMedicineList: function retriveMedicineList(user, date, studentName) {
			var _this = this;

			return this.getMedicine({
				user: user.id,
				filter: {
					date: date,
					studentName: studentName
				}
			}).then(function (response) {

				_this.getMedicineIsTaken(true).then(function (response) {
					_this.setMedicineHistory(response);
				});

				_this.getMedicineIsTaken(false).then(function (response) {
					_this.setMedicinePending(response);
				});

				_eventBus.EventBus.$emit('medicineListRetrived');

				return response;
			});
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Medicações'
		}]);

		_eventBus.EventBus.$on('medicineListChange', function () {

			_this2.retriveMedicineList(_this2.user, (0, _moment2.default)(_this2.datepicker.selected).format('YYYY-MM-DD'), _this2.student);
		});

		this.retriveMedicineList(this.user, (0, _moment2.default)(this.datepicker.selected).format('YYYY-MM-DD'), this.student);
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('medicineListRetrived');
		_eventBus.EventBus.$off('medicineListChange');
	}
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	sendFormLead: function sendFormLead(context, payload) {

		return _http2.default.post('v1/lead', payload).then(function (response) {
			context.commit('SET_LEAD', response.data);
			return response;
		});
	},
	updateLead: function updateLead(context, payload) {

		return _http2.default.put('v1/lead/' + payload.id, payload).then(function (response) {
			context.commit('SET_LEAD', response.data);
			return response;
		});
	},
	sendForm: function sendForm(context, payload) {

		return _http2.default.post('v1/school', payload).then(function (response) {
			context.commit('SET_LEAD', response.data);
			return response;
		});
	}
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getLead: function getLead(state) {
		return state.lead;
	}
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_LEAD: function SET_LEAD(state, payload) {
		state.lead = payload;
	}
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	lead: {
		schoolName: '',
		contactName: '',
		contactEmailAddress: '',
		mobilePhoneNumber: '',
		studentsQuantity: 500,
		plan: '',
		levels: [],
		voucherNumber: ''
	}
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _state = __webpack_require__(479);

var _state2 = _interopRequireDefault(_state);

var _getters = __webpack_require__(477);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(478);

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__(476);

var _actions2 = _interopRequireDefault(_actions);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	actions: _actions2.default,
	name: 'breadcrumb',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		pages: 'breadcrumbPages'
	}))
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(655);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(483);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(480);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(481);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(482);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	name: 'month',
	data: function data() {
		return {
			month: ''
		};
	},
	props: {
		name: {
			type: String,
			default: 'month'
		},
		label: {
			type: String,
			default: 'Mês'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'currentMonth'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putCurrentMonth']), {
		changed: function changed() {

			var data = {
				index: (0, _keys2.default)(this.ENUM.Month).indexOf(this.month),
				value: this.month
			};

			_eventBus.EventBus.$emit(this.name + 'Changed', data);

			this.putCurrentMonth(data);
		}
	}),
	mounted: function mounted() {
		var _this = this;

		this.month = this.currentMonth.value;

		_eventBus.EventBus.$on('yearChanged', function () {
			_this.month = '';
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('yearChanged');
		_eventBus.EventBus.$off('monthChanged');
	}
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(487);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(484);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(485);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(486);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	name: 'week',
	data: function data() {
		return {
			week: ''
		};
	},
	props: {
		name: {
			type: String,
			default: 'week'
		},
		label: {
			type: String,
			default: 'Semana'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: true
		},
		showFirst: {
			type: Boolean,
			default: true
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentYear', 'currentMonth', 'currentWeek', 'weeks'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putWeekList', 'putCurrentWeek']), {
		changed: function changed() {

			this.putCurrentWeek(this.week);
			_eventBus.EventBus.$emit(this.name + 'Changed', this.week);
		},
		getMonthWeeks: function getMonthWeeks(year, month) {

			if (year && month >= 0) {

				var weeks = [];
				var baseDate = (0, _moment2.default)().set({
					'year': year,
					'month': month,
					'date': 1
				});
				var monthWeeks = Math.ceil(baseDate.daysInMonth() / 7);

				var currentDate = baseDate;

				if (month === 1) {
					monthWeeks + 1;
				}

				for (var week = 0; week < monthWeeks; week++) {

					weeks.push({
						startDate: (0, _lodash.cloneDeep)(currentDate).startOf('week').format('YYYY-MM-DD'),
						endDate: (0, _lodash.cloneDeep)(currentDate).endOf('week').format('YYYY-MM-DD')
					});

					currentDate = currentDate.add(1, 'w');
				}

				return weeks;
			}
		}
	}),
	mounted: function mounted() {
		var _this = this;

		if (!(0, _lodash.isEmpty)(this.currentWeek)) {
			this.week = this.currentWeek;
		}

		this.putWeekList(this.getMonthWeeks(this.currentYear, this.currentMonth.index));

		_eventBus.EventBus.$on('updateWeekList', function (payload) {

			if (payload.year && payload.month) {

				_this.week = '';
				_this.putWeekList(_this.getMonthWeeks(payload.year, payload.month.index));
				_this.putCurrentWeek({});
			} else {
				_this.putWeekList([]);
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('updateWeekList');
	}
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		current: (0, _moment2.default)().get('Y'),
		list: []
	},
	getters: {
		currentYear: function currentYear(state) {
			return state.current;
		},
		years: function years(state) {
			return state.list;
		}
	},
	mutations: {
		PUT_CURRENT_YEAR: function PUT_CURRENT_YEAR(state, payload) {
			state.current = payload;
		},
		PUT_YEARS_LIST: function PUT_YEARS_LIST(state, payload) {
			state.list = payload;
		},
		PUSH_YEAR: function PUSH_YEAR(state, payload) {
			state.list.unshift(payload);
		}
	},
	actions: {
		putCurrentYear: function putCurrentYear(context, payload) {
			context.commit('PUT_CURRENT_YEAR', payload);
		},
		putYearsList: function putYearsList(context, payload) {
			context.commit('PUT_YEARS_LIST', payload);
		},
		pushYear: function pushYear(context, payload) {
			context.commit('PUSH_YEAR', payload);
		}
	}
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		list: [],
		selected: {}
	},
	getters: {
		classGrade: function classGrade(state) {
			return state.selected;
		},
		classGradeList: function classGradeList(state) {
			return state.list;
		}
	},
	mutations: {
		SET_CLASS_GRADE_LIST: function SET_CLASS_GRADE_LIST(state, payload) {
			state.list = payload;
		},
		SET_SELECTED_CLASS_GRADE: function SET_SELECTED_CLASS_GRADE(state, payload) {
			state.selected = payload;
		}
	},
	actions: {
		setSelectedClassGrade: function setSelectedClassGrade(context, payload) {
			context.commit('SET_SELECTED_CLASS_GRADE', payload);
		},
		getClassGrade: function getClassGrade(context, payload) {
			var _this = this;

			if (payload) {

				var queryString = _string2.default.makeQueryString(payload.filter);
				var route = 'v1/school-class-grade/user/' + payload.userId + queryString;

				return _http2.default.get(route).then(function (response) {

					// Based at http://jsfiddle.net/thefourtheye/WYCF8/
					var data = (0, _lodash.chain)(response.data).groupBy('level').toPairs().map(function (current) {

						var zip = (0, _lodash.zipObject)(['gradeLevel', 'list'], current);

						zip.gradeName = _this.getters.ENUM['SchoolClassLevelType'][zip.gradeLevel];

						return zip;
					}).value();

					context.commit('SET_CLASS_GRADE_LIST', data);

					return response;
				});
			}
		}
	}
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(536);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(533);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(534);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(535);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	name: 'class-level',
	props: {
		label: {
			type: String,
			default: 'Nível de ensino'
		},
		required: {
			type: Boolean,
			default: false
		},
		blacklist: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	data: function data() {
		return {
			classLevelModel: '',
			schoolClassLevels: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'classLevel'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setSelectedClassLevel']), {
		changed: function changed() {

			this.setSelectedClassLevel(this.classLevelModel);
			_eventBus.EventBus.$emit('classLevelSelected', this.classLevelModel);
		}
	}),
	mounted: function mounted() {
		var _this = this;

		if (this.classLevel) {
			this.classLevelModel = this.classLevel;
		}

		this.schoolClassLevels = (0, _lodash.cloneDeep)(this.ENUM.SchoolClassLevelType);

		if (this.blacklist.length) {

			this.blacklist.forEach(function (value) {
				delete _this.schoolClassLevels[value];
			});
		}
	}
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		list: [],
		selected: {}
	},
	mutations: {
		SET_CLASS_LIST: function SET_CLASS_LIST(state, payload) {
			state.list = payload;
		},
		SET_SELECTED_CLASS: function SET_SELECTED_CLASS(state, payload) {
			state.selected = payload;
		}
	},
	getters: {
		getClass: function getClass(state) {
			return state.selected;
		}
	},
	actions: {
		setSelectedClass: function setSelectedClass(context, payload) {
			context.commit('SET_SELECTED_CLASS', payload);
		},
		getClassByUser: function getClassByUser(context, payload) {

			if (payload) {
				var queryString = '?' + _string2.default.toQueryStringParameters(payload);
				var scope = payload.scope ? payload.scope : 'global';

				return _http2.default.get('v1/school-class/user/' + payload.userId + queryString).then(function (response) {

					if (scope === 'global') {
						context.commit('SET_CLASS_LIST', response.data.object);
					}

					return response;
				});
			}
		}
	}
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: {
		list: [],
		selected: {}
	},
	getters: {
		themes: function themes(state) {
			return state.list;
		},
		currentTheme: function currentTheme(state) {
			return state.selected;
		}
	},
	mutations: {
		SET_THEME_LIST: function SET_THEME_LIST(state, payload) {
			state.list = payload;
		},
		SET_THEME: function SET_THEME(state, payload) {
			state.selected = payload;
		}
	},
	actions: {
		getSchoolThemes: function getSchoolThemes(context, payload) {
			var _this = this;

			if (payload && payload.id) {

				return _http2.default.get('v1/school-theme/user/' + payload.id).then(function (response) {

					var data = (0, _lodash.chain)(response.data).groupBy('level').toPairs().map(function (current) {

						var zip = (0, _lodash.zipObject)(['gradeLevel', 'list'], current);

						zip.gradeName = _this.getters.ENUM['SchoolClassLevelType'][zip.gradeLevel];

						return zip;
					}).value();

					context.commit('SET_THEME_LIST', data);

					return response;
				});
			}
		},
		setTheme: function setTheme(context, payload) {
			context.commit('SET_THEME', payload);
		}
	}
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getStudents: function getStudents(context, payload) {

		if (payload && payload.userId && payload.schoolClassId) {

			var route = 'v1/student/user/' + payload.userId + '?schoolClassId=' + payload.schoolClassId;

			return _http2.default.get(route).then(function (response) {

				response.data.forEach(function (value) {

					if (!value.photoURL) {
						value.photoURL = 'assets/images/default-avatar.png';
					}
				});

				context.commit('SET_STUDENTS_LIST', response.data);

				return response;
			});
		}
	},
	setStudent: function setStudent(context, payload) {
		context.commit('SET_STUDENT', payload);
	},
	setStudentStatus: function setStudentStatus(context, payload) {
		context.commit('SET_STUDENT_STATUS', payload);
	},
	updateStudentList: function updateStudentList(context, payload) {
		context.commit('SET_STUDENTS_LIST', payload);
	}
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getStudent: function getStudent(state) {
		return state.selected;
	}
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

exports.default = {
	SET_STUDENTS_LIST: function SET_STUDENTS_LIST(state, payload) {
		state.list = payload;
	},
	SET_STUDENT: function SET_STUDENT(state, payload) {
		state.selected = payload;
	},
	SET_STUDENT_STATUS: function SET_STUDENT_STATUS(state, payload) {
		state.list = (0, _lodash.merge)((0, _lodash.cloneDeep)(state.list), payload);
	}
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: [],
	selected: {}
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(4);

var _vuex2 = _interopRequireDefault(_vuex);

var _sample = __webpack_require__(468);

var _sample2 = _interopRequireDefault(_sample);

var _breadcrumb = __webpack_require__(197);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _year = __webpack_require__(488);

var _year2 = _interopRequireDefault(_year);

var _month = __webpack_require__(198);

var _month2 = _interopRequireDefault(_month);

var _week = __webpack_require__(199);

var _week2 = _interopRequireDefault(_week);

var _agenda = __webpack_require__(444);

var _agenda2 = _interopRequireDefault(_agenda);

var _inbox = __webpack_require__(186);

var _inbox2 = _interopRequireDefault(_inbox);

var _leavingMonitor = __webpack_require__(187);

var _leavingMonitor2 = _interopRequireDefault(_leavingMonitor);

var _gallery = __webpack_require__(185);

var _gallery2 = _interopRequireDefault(_gallery);

var _album = __webpack_require__(184);

var _album2 = _interopRequireDefault(_album);

var _medicine = __webpack_require__(192);

var _medicine2 = _interopRequireDefault(_medicine);

var _mealMenu = __webpack_require__(463);

var _mealMenu2 = _interopRequireDefault(_mealMenu);

var _simulator = __webpack_require__(474);

var _simulator2 = _interopRequireDefault(_simulator);

var _lessonPlanning = __webpack_require__(461);

var _lessonPlanning2 = _interopRequireDefault(_lessonPlanning);

var _evaluation = __webpack_require__(445);

var _evaluation2 = _interopRequireDefault(_evaluation);

var _logged = __webpack_require__(525);

var _logged2 = _interopRequireDefault(_logged);

var _classList = __webpack_require__(537);

var _classList2 = _interopRequireDefault(_classList);

var _theme = __webpack_require__(539);

var _theme2 = _interopRequireDefault(_theme);

var _student = __webpack_require__(540);

var _student2 = _interopRequireDefault(_student);

var _homework = __webpack_require__(512);

var _homework2 = _interopRequireDefault(_homework);

var _classGrade = __webpack_require__(532);

var _classGrade2 = _interopRequireDefault(_classGrade);

var _classLevel = __webpack_require__(202);

var _classLevel2 = _interopRequireDefault(_classLevel);

var _state = __webpack_require__(557);

var _state2 = _interopRequireDefault(_state);

var _getters = __webpack_require__(555);

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__(554);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(556);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://vuex.vuejs.org/en/


// Default
_vue2.default.use(_vuex2.default);

// Domains


// Pages/app


// Components
exports.default = new _vuex2.default.Store({
	state: _state2.default,
	getters: _getters2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	strict: true,
	modules: {
		Sample: _sample2.default,
		Breadcrumb: _breadcrumb2.default,
		Year: _year2.default,
		Month: _month2.default,
		Week: _week2.default,
		Agenda: _agenda2.default,
		Inbox: _inbox2.default,
		LeavingMonitor: _leavingMonitor2.default,
		Medicine: _medicine2.default,
		MealMenu: _mealMenu2.default,
		Gallery: _gallery2.default,
		Album: _album2.default,
		Logged: _logged2.default,
		Theme: _theme2.default,
		Class: _classList2.default,
		Student: _student2.default,
		Homework: _homework2.default,
		ClassGrade: _classGrade2.default,
		ClassLevel: _classLevel2.default,
		LessonPlanning: _lessonPlanning2.default,
		Evaluation: _evaluation2.default,
		Simulator: _simulator2.default
	}
});

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1051),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1079),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1097),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1037),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1044),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1112),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(950)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c49d2702",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1078),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1101),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1082),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61906a0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1069),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1087),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2512e81a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1043),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1073),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1096),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1060),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1064),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47761c48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1049),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1040),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19b68ac0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

module.exports = {"pt_BR":{"search":"Busca","notfound":"Emoji n�o encontrado","categories":{"search":"Resultado da busca","recent":"Utilizados recentemente","people":"Smileys & Pessoas","nature":"Animais & Natureza","foods":"Comidas & Bebidas","activity":"Atividades","places":"Viajens & Lugares","objects":"Objetos","symbols":"S�mbolos","flags":"Bandeiras","custom":"Diversos"}}}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vMask = __webpack_require__(966);

var _vMask2 = _interopRequireDefault(_vMask);

var _logrocket = __webpack_require__(276);

var _logrocket2 = _interopRequireDefault(_logrocket);

var _vuejsLogger = __webpack_require__(1122);

var _vuejsLogger2 = _interopRequireDefault(_vuejsLogger);

var _veeValidate = __webpack_require__(967);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _dictionary = __webpack_require__(561);

var _dictionary2 = _interopRequireDefault(_dictionary);

var _cnpj = __webpack_require__(559);

var _cnpj2 = _interopRequireDefault(_cnpj);

var _cpf = __webpack_require__(560);

var _cpf2 = _interopRequireDefault(_cpf);

var _vueCurrencyFilter = __webpack_require__(968);

var _vueCurrencyFilter2 = _interopRequireDefault(_vueCurrencyFilter);

var _vueGettext = __webpack_require__(969);

var _vueGettext2 = _interopRequireDefault(_vueGettext);

var _translations = __webpack_require__(1124);

var _translations2 = _interopRequireDefault(_translations);

var _ptBr = __webpack_require__(908);

var _ptBr2 = _interopRequireDefault(_ptBr);

var _locale = __webpack_require__(84);

var _locale2 = _interopRequireDefault(_locale);

var _vueMasonry = __webpack_require__(1119);

var _App = __webpack_require__(970);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(552);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(209);

var _store2 = _interopRequireDefault(_store);

var _filters = __webpack_require__(546);

var _filters2 = _interopRequireDefault(_filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------------------------------------------------------

if (true) {
	_logrocket2.default.init("qubdhv/schoolastic");
} // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.use(_vueMasonry.VueMasonryPlugin);

_vue2.default.use(_vueCurrencyFilter2.default, {
	symbol: 'R$',
	thousandsSeparator: '.',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'front',
	symbolSpacing: true
});

_locale2.default.use(_ptBr2.default);
_moment2.default.locale('pt_BR');

_vue2.default.use(_vMask2.default);

_vue2.default.use(_vuejsLogger2.default, {
	logLevel: 'debug',
	showLogLevel: true
});

_vue2.default.use(_veeValidate2.default, {
	locale: 'pt_BR',
	dictionary: _dictionary2.default
});

_veeValidate.Validator.extend('cnpj', _cnpj2.default);
_veeValidate.Validator.extend('cpf', _cpf2.default);

_vue2.default.use(_vueGettext2.default, {
	availableLanguages: {
		'pt_BR': 'Português',
		'en_US': 'English'
	},
	defaultLanguage: 'pt_BR',
	silent: true,
	translations: _translations2.default
});

_vue2.default.config.productionTip = true;

_vue2.default.filter('enum', _filters2.default.storeENUM);
_vue2.default.filter('now', _filters2.default.now);
_vue2.default.filter('date', _filters2.default.date);
_vue2.default.filter('truncate', _filters2.default.truncate);
_vue2.default.filter('size', _filters2.default.size);
_vue2.default.filter('capitalize', _filters2.default.capitalize);
_vue2.default.filter('linebreak', _filters2.default.linebreak);
_vue2.default.filter('ucwords', _filters2.default.ucwords);
_vue2.default.filter('currency', _filters2.default.currency);

/* eslint-disable no-new */
new _vue2.default({
	el: '#app',
	store: _store2.default,
	router: _router2.default,
	template: '<App/>',
	components: {
		App: _App2.default
	}
});

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

var _vueStrap = __webpack_require__(173);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(182);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(179);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(181);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(180);

var _getters2 = _interopRequireDefault(_getters);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(419);

var _main4 = _interopRequireDefault(_main3);

var _themes = __webpack_require__(415);

var _themes2 = _interopRequireDefault(_themes);

var _create = __webpack_require__(414);

var _create2 = _interopRequireDefault(_create);

var _students = __webpack_require__(89);

var _students2 = _interopRequireDefault(_students);

var _agendaViewers = __webpack_require__(403);

var _agendaViewers2 = _interopRequireDefault(_agendaViewers);

var _agendaEditors = __webpack_require__(402);

var _agendaEditors2 = _interopRequireDefault(_agendaEditors);

var _name = __webpack_require__(420);

var _name2 = _interopRequireDefault(_name);

var _StudentPresence = __webpack_require__(410);

var _StudentPresence2 = _interopRequireDefault(_StudentPresence);

var _humor = __webpack_require__(407);

var _humor2 = _interopRequireDefault(_humor);

var _alimentation = __webpack_require__(404);

var _alimentation2 = _interopRequireDefault(_alimentation);

var _activities = __webpack_require__(401);

var _activities2 = _interopRequireDefault(_activities);

var _main5 = __webpack_require__(406);

var _main6 = _interopRequireDefault(_main5);

var _health = __webpack_require__(405);

var _health2 = _interopRequireDefault(_health);

var _questions = __webpack_require__(411);

var _questions2 = _interopRequireDefault(_questions);

var _main7 = __webpack_require__(408);

var _main8 = _interopRequireDefault(_main7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'agenda',
	components: {
		PageBar: _pageBar2.default,
		ClassName: _main4.default,
		CreateHomeworkButton: _create2.default,
		CreateHomeworkTheme: _themes2.default,
		Students: _students2.default,
		StudentName: _name2.default,
		StudentPresence: _StudentPresence2.default,
		StudentHumor: _humor2.default,
		AgendaViewers: _agendaViewers2.default,
		AgendaEditors: _agendaEditors2.default,
		SchoolClassList: _main2.default,
		tab: _vueStrap.tab,
		tabs: _vueStrap.tabs,
		tabGroup: _vueStrap.tabGroup,
		DatePicker: _datePicker4.default,
		Alimentation: _alimentation2.default,
		Activities: _activities2.default,
		Health: _health2.default,
		Highlight: _main6.default,
		Questions: _questions2.default,
		Others: _main8.default
	},
	data: function data() {
		return {
			homeworkVisible: false,
			datepicker: {
				today: new Date(),
				selected: new Date()
			},
			activeTabs: 0
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		agenda: function agenda(state) {
			return state.Agenda;
		},
		classes: function classes(state) {
			return state.Class;
		},
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		presence: function presence(state) {
			return state.Agenda.agenda.presence;
		}
	}), (0, _vuex.mapGetters)({
		klass: 'getClass',
		user: 'getLoggedUser',
		student: 'getStudent'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getAgenda', 'saveAgenda', 'setBreadcrumb', 'putAgendaDate', 'getStudents', 'getMessages', 'publishAgenda', 'publishAllAgendas', 'setStudent', 'getAgendaStatus', 'setSelectedClass']), {
		getStatus: function getStatus() {

			this.getAgendaStatus({
				userId: this.user.id,
				schoolClassId: this.klass.schoolClassId,
				date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
			});
		},
		setAgendaDate: function setAgendaDate(currentDate) {

			if (currentDate) {
				var _currentDate$split = currentDate.split('/'),
				    _currentDate$split2 = (0, _slicedToArray3.default)(_currentDate$split, 3),
				    date = _currentDate$split2[0],
				    month = _currentDate$split2[1],
				    year = _currentDate$split2[2];

				currentDate = (0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: 0,
					minute: 0,
					second: 0
				});

				this.putAgendaDate((0, _moment2.default)(currentDate).format('YYYY-MM-DD'));

				if (this.student && this.student.studentId) {

					this.getAgenda({
						userId: this.user.id,
						studentId: this.student.studentId,
						date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
					}).then(function () {
						_eventBus.EventBus.$emit('setAgenda');
					});
				}

				if (this.klass && this.klass.schoolClassId) {
					this.getStatus();
				}
			}
		},
		resetStudent: function resetStudent() {

			this.setStudent({});
			this.getStudents();
		},
		save: function save() {
			var _this = this;

			this.saveAgenda().then(function () {
				_this.getStatus();
			});
		},
		publish: function publish() {
			var _this2 = this;

			this.publishAgenda().then(function () {

				_this2.resetStudent();
				_this2.getStatus();
			});
		},
		publishAll: function publishAll() {
			var _this3 = this;

			this.publishAllAgendas().then(function () {

				_this3.resetStudent();
				_this3.getStatus();
			});
		}
	}),
	created: function created() {

		this.setSelectedClass({});

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Preparar Agenda'
		}]);
	},
	mounted: function mounted() {
		var _this4 = this;

		_eventBus.EventBus.$on('toggleHomework', function () {
			_this4.homeworkVisible = !_this4.homeworkVisible;
		});

		_eventBus.EventBus.$on('setStudent', function () {
			_this4.activeTabs = 0;
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('toggleHomework');
		_eventBus.EventBus.$off('setStudent');
	}
};

// import $ from 'jquery';

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _store = __webpack_require__(183);

var _store2 = _interopRequireDefault(_store);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(412);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(413);

var _main4 = _interopRequireDefault(_main3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'EvaluationPage',
	data: function data() {
		return {
			// TODO
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'evaluationQuestions', 'evaluationStudentsQuestions'])),
	components: {
		PageBar: _pageBar2.default,
		EvaluationQuestionsFilter: _main2.default,
		EvaluationQuestions: _main4.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getEvaluationQuestion'])),
	created: function created() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Indicadores'
		}]);
	}
});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	newAlbum: function newAlbum(context, payload) {

		if (payload.scope === 'SCHOOL_CLASS') {
			payload.album.schoolClasses = [];

			payload.schoolClass.forEach(function (value) {
				payload.album.schoolClasses.push(value.schoolClassId);
			});
		} else if (payload.scope === 'STUDENT') {
			payload.album.students = [];

			payload.students.forEach(function (value) {
				payload.album.students.push(value.studentId);
			});
		}

		payload.album.scope = payload.scope;

		if (payload.userId) {

			var route = 'v1/gallery/album/user/' + payload.userId;

			return _http2.default.post(route, payload.album).then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response.data;
			});
		}
	},
	editAlbum: function editAlbum(context, payload) {

		if (payload.userId) {

			var route = 'v1/gallery/album/' + payload.album.id + '/user/' + payload.userId;

			return _http2.default.put(route, {
				title: payload.album.title,
				description: payload.album.description
			}).then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response.data;
			});
		}
	},
	getAlbumList: function getAlbumList(context, payload) {

		if (payload.userId) {

			var route = 'v1/gallery/album/user/' + payload.userId + '?quantity=' + payload.pagination.quantity + '&page=' + payload.pagination.page;

			return _http2.default.get(route).then(function (response) {

				context.commit('SET_ALBUM_LIST', response.data);

				return response.data;
			});
		}
	},
	setAlbum: function setAlbum(context, payload) {

		if (payload.userId && payload.id) {

			var route = 'v1/gallery/user/' + payload.userId + '?albumId=' + payload.id;

			return _http2.default.get(route).then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response.data;
			});
		}
	},
	setUpload: function setUpload(context, payload) {
		if (payload) {

			context.commit('SET_UPLOAD', payload);

			return payload;
		}
	},
	setAlbunsList: function setAlbunsList(context, payload) {

		var queryString = _string2.default.makeQueryString(payload);

		if (payload.userId) {

			return _http2.default.get('v1/gallery/album/user/' + payload.userId + queryString).then(function (response) {

				context.commit('SET_ALBUM_LIST', response.data);

				return response;
			});
		}
	},
	publishAlbum: function publishAlbum(context, payload) {

		if (payload.userId) {

			return _http2.default.post('v1/gallery/album/' + payload.id + '/user/' + payload.userId + '/publish').then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response;
			});
		}
	},
	unpublishAlbum: function unpublishAlbum(context, payload) {

		if (payload.userId) {

			return _http2.default.post('v1/gallery/album/' + payload.id + '/user/' + payload.userId + '/unpublish').then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response;
			});
		}
	},
	unpublishPhotos: function unpublishPhotos(context, payload) {

		if (payload.userId) {
			return _http2.default.post('v1/gallery/album/' + payload.id + '/user/' + payload.userId + '/unpublish', {
				'photos': payload.photos
			}).then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response;
			});
		}
	},
	publishPhotos: function publishPhotos(context, payload) {

		if (payload.userId) {
			return _http2.default.post('v1/gallery/album/' + payload.id + '/user/' + payload.userId + '/publish', {
				'photos': payload.photos
			}).then(function (response) {

				context.commit('SET_ALBUM', response.data);

				return response;
			});
		}
	},
	setInfoPhoto: function setInfoPhoto(context, payload) {

		if (payload.id && payload.userId) {

			var route = 'v1/gallery/' + payload.id + '/user/' + payload.userId;

			return _http2.default.put(route, payload.infoPhoto).then(function (response) {

				context.commit('SET_PHOTO', response.data);

				return response.data;
			});
		}
	},
	removePhoto: function removePhoto(context, payload) {
		if (payload.userId) {
			return _http2.default.delete('v1/gallery/' + payload.id + '/user/' + payload.userId).then(function (response) {

				return response;
			});
		}
	},
	putAssignPhotoUsers: function putAssignPhotoUsers(context, payload) {

		if (payload.userId && payload.albumId) {

			var route = 'v1/gallery/album/' + payload.albumId + '/user/' + payload.userId + '/selection';

			var imgSelect = {
				photos: [],
				schoolClasses: [],
				students: []
			};

			payload.photos.forEach(function (value) {
				imgSelect.photos.push(value.id);
			});

			if (payload.schoolClass) {
				payload.schoolClass.forEach(function (value) {
					imgSelect.schoolClasses.push(value.schoolClassId);
				});
			}
			if (payload.students) {
				payload.students.forEach(function (value) {
					imgSelect.students.push(value.studentId);
				});
			}
			imgSelect.scope = payload.scope;

			return _http2.default.put(route, imgSelect).then(function (response) {

				return response;
			});
		}
	},
	cleanAlbum: function cleanAlbum(context) {
		context.commit('SET_ALBUM', '');
	}
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	album: function album(state) {
		return state.album;
	},
	list: function list(state) {
		return state.list;
	}
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_ALBUM: function SET_ALBUM(state, payload) {
		state.album = payload;
	},
	SET_PHOTO: function SET_PHOTO(state, payload) {
		state.album.photos[payload.index] = payload.data;
	},
	SET_UPLOAD: function SET_UPLOAD(state, payload) {
		state.album = payload;
	},
	SET_ALBUM_LIST: function SET_ALBUM_LIST(state, payload) {
		state.list = payload;
	}
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	album: {},
	list: []
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _lodash = __webpack_require__(9);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getMessageRecipient: function getMessageRecipient(context, payload) {

		if (payload && payload.userId && payload.studentId) {

			return _http2.default.get('v1/messages/recipient?userId=' + payload.userId + '&studentId=' + payload.studentId).then(function (response) {

				response.data.forEach(function (value) {

					if (!value.photoURL) {
						value.photoURL = 'assets/images/default-avatar.png';
					}
				});

				context.commit('SET_MESSAGE_RECIPIENT_LIST', response.data);

				return response;
			});
		}
	},
	setMessageRecipientList: function setMessageRecipientList(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_LIST', payload);
	},
	setSentInboxFilter: function setSentInboxFilter(context, payload) {
		context.commit('SET_SENT_INBOX_FILTER', payload);
	},
	setReceivedInboxFilter: function setReceivedInboxFilter(context, payload) {
		context.commit('SET_RECEIVED_INBOX_FILTER', payload);
	},
	setMessageRecipientResponsible: function setMessageRecipientResponsible(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_RESPONSIBLE', payload);
	},
	setMessageRecipientSchoolMembers: function setMessageRecipientSchoolMembers(context, payload) {
		context.commit('SET_MESSAGE_RECIPIENT_SCHOOLMEMBERS', payload);
	},
	getMessageRecipientIsResponsible: function getMessageRecipientIsResponsible(context, payload) {

		if (payload) {

			return (0, _lodash.compact)(context.state.list.map(function (item) {

				if (item.responsible) {
					return item;
				}
			}));
		} else {

			return (0, _lodash.compact)(context.state.list.map(function (item) {

				if (!item.responsible) {
					return item;
				}
			}));
		}
	},
	getReceivedMessages: function getReceivedMessages(context, payload) {

		var queryString = _string2.default.makeQueryString(payload);

		return _http2.default.get('v1/messages/user/' + payload.data.id + '/inbox' + queryString).then(function (response) {

			context.commit('SET_MESSAGE_RECEIVED_LIST', response.data);

			return response;
		});
	},
	getSentMessages: function getSentMessages(context, payload) {

		var queryString = _string2.default.makeQueryString(payload);

		return _http2.default.get('v1/messages/user/' + payload.data.id + '/sent' + queryString).then(function (response) {

			context.commit('SET_MESSAGE_SENT_LIST', response.data);

			return response;
		});
	},
	getMessages: function getMessages(context, payload) {

		if (payload && payload.userId && payload.studentId) {
			var userId = payload.userId,
			    studentId = payload.studentId;


			var route = 'v1/messages/inbox/' + userId + '/student/' + studentId + '?page=0&quantity=5';

			return _http2.default.get(route).then(function (response) {

				response.data.forEach(function (value) {

					if (value.messages) {

						value.messages.forEach(function (aux) {

							if (!aux.from.photoURL) {
								aux.from.photoURL = 'assets/images/default-avatar.png';
							}
						});
					}
				});

				context.commit('SET_MESSAGES_AGENDA_LIST', response.data);

				return response;
			});
		}
	},
	putMessageResponsible: function putMessageResponsible(context, payload) {
		context.commit('PUT_MESSAGE_RESPONSIBLE', payload.target._value);
	},
	putMessageRecipientSelected: function putMessageRecipientSelected(context, payload) {
		context.commit('PUT_MESSAGE_RECIPIENT_SELECTED', payload.value);
	},
	putMessageRecipients: function putMessageRecipients(context, payload) {

		if (payload) {

			var route = 'v1/messages/' + payload.messageGroup + '/user/' + payload.userId + '/add-user/' + payload.newUserId;

			return _http2.default.put(route).then(function (response) {

				context.commit('SET_MESSAGE_GROUP', response.data);

				return response;
			});
		}
	},
	putMessageSchoolMembers: function putMessageSchoolMembers(context, payload) {
		context.commit('PUT_MESSAGE_SCHOOLMEMBERS', payload.value);
	},
	putMessageSubject: function putMessageSubject(context, payload) {
		context.commit('PUT_MESSAGE_SUBJECT', payload.value);
	},
	putMessageMessage: function putMessageMessage(context, payload) {
		context.commit('PUT_MESSAGE_MESSAGE', payload.value);
	},
	getMessageGroup: function getMessageGroup(context, payload) {

		if (context && context.getters.getLoggedUser.id) {

			return _http2.default.get('v1/messages/' + payload + '/user/' + context.getters.getLoggedUser.id).then(function (response) {

				response.data.messages = response.data.messages.reverse();

				response.data.messages.forEach(function (aux) {

					if (!aux.from.photoURL) {
						aux.from.photoURL = 'assets/images/default-avatar.png';
					}
				});

				context.commit('SET_MESSAGE_GROUP', response.data);

				return response;
			});
		}
	},
	sendMessageChat: function sendMessageChat(context, payload) {

		var route = 'v1/messages/' + context.state.messageGroup.messageGroup;

		return _http2.default.post(route, payload).then(function (response) {
			return response;
		});
	},
	sendMessageNew: function sendMessageNew(context, payload) {

		var route = 'v1/messages';

		return _http2.default.post(route, payload).then(function (response) {
			return response;
		});
	},
	putUnreadMessages: function putUnreadMessages(context, payload) {
		context.commit('PUT_UNREAD_MESSAGES', payload);
	}
};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getInboxResponsibles: function getInboxResponsibles(state) {
		return state.responsible;
	},
	getInboxSchoolMembers: function getInboxSchoolMembers(state) {
		return state.schoolMembers;
	},
	getReceivedMessageList: function getReceivedMessageList(state) {
		return state.messages.received;
	},
	getSentMessageList: function getSentMessageList(state) {
		return state.messages.sent;
	},
	getInboxHeighlights: function getInboxHeighlights(state) {
		return state.inboxAgenda;
	},
	messageGroup: function messageGroup(state) {
		return state.messageGroup;
	},
	inboxSentFilter: function inboxSentFilter(state) {
		return state.filter.sent;
	},
	inboxReceivedFilter: function inboxReceivedFilter(state) {
		return state.filter.received;
	}
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_MESSAGE_RECIPIENT_LIST: function SET_MESSAGE_RECIPIENT_LIST(state, payload) {
		state.list = payload;
	},
	SET_RECEIVED_INBOX_FILTER: function SET_RECEIVED_INBOX_FILTER(state, payload) {
		state.filter.received = payload;
	},
	SET_SENT_INBOX_FILTER: function SET_SENT_INBOX_FILTER(state, payload) {
		state.filter.sent = payload;
	},
	SET_MESSAGE_RECIPIENT_RESPONSIBLE: function SET_MESSAGE_RECIPIENT_RESPONSIBLE(state, payload) {

		payload.forEach(function (value) {
			value.formatedName = value.name;
		});

		state.responsible = payload;
	},
	SET_MESSAGE_RECIPIENT_SCHOOLMEMBERS: function SET_MESSAGE_RECIPIENT_SCHOOLMEMBERS(state, payload) {

		payload.forEach(function (value) {
			value.formatedName = value.name + " (" + value.role + ")";
		});

		state.schoolMembers = payload;
	},
	SET_MESSAGE_RECEIVED_LIST: function SET_MESSAGE_RECEIVED_LIST(state, payload) {
		state.messages.received = payload;
	},
	SET_MESSAGE_SENT_LIST: function SET_MESSAGE_SENT_LIST(state, payload) {
		state.messages.sent = payload;
	},
	SET_MESSAGES_AGENDA_LIST: function SET_MESSAGES_AGENDA_LIST(state, payload) {
		state.inboxAgenda = payload;
	},
	PUT_MESSAGE_RESPONSIBLE: function PUT_MESSAGE_RESPONSIBLE(state, payload) {
		state.compose = payload;
	},
	PUT_MESSAGE_SCHOOLMEMBERS: function PUT_MESSAGE_SCHOOLMEMBERS(state, payload) {
		state.compose.schoolMembers = payload;
	},
	PUT_MESSAGE_SUBJECT: function PUT_MESSAGE_SUBJECT(state, payload) {
		state.compose.subject = payload;
	},
	PUT_MESSAGE_MESSAGE: function PUT_MESSAGE_MESSAGE(state, payload) {
		state.compose.message = payload;
	},
	SET_MESSAGE_GROUP: function SET_MESSAGE_GROUP(state, payload) {
		state.messageGroup = payload;
	},
	SET_RECIPIENTS_SELECTED: function SET_RECIPIENTS_SELECTED(state, payload) {
		state.compose.push(payload);
	},
	PUT_UNREAD_MESSAGES: function PUT_UNREAD_MESSAGES(state, payload) {
		state.unreadMessages = payload;
	}
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _sidebarMenu = __webpack_require__(118);

var _sidebarMenu2 = _interopRequireDefault(_sidebarMenu);

var _main = __webpack_require__(1014);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'new-message',
	components: {
		PageBar: _pageBar2.default,
		SidebarMenu: _sidebarMenu2.default,
		MessageNew: _main2.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb'])),
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);
	}
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _sidebarMenu = __webpack_require__(118);

var _sidebarMenu2 = _interopRequireDefault(_sidebarMenu);

var _messageReply = __webpack_require__(1017);

var _messageReply2 = _interopRequireDefault(_messageReply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'reply-message',
	components: {
		PageBar: _pageBar2.default,
		SidebarMenu: _sidebarMenu2.default,
		MessageReply: _messageReply2.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb'])),
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);
	}
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _sidebarMenu = __webpack_require__(118);

var _sidebarMenu2 = _interopRequireDefault(_sidebarMenu);

var _messageSend = __webpack_require__(1020);

var _messageSend2 = _interopRequireDefault(_messageSend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'send-message',
	components: {
		PageBar: _pageBar2.default,
		SidebarMenu: _sidebarMenu2.default,
		MessageSend: _messageSend2.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb'])),
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Caixa de Entrada'
		}]);
	}
};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: [],
	filter: {
		received: {
			studentName: '',
			memberName: '',
			onlyNotReadedMessages: '',
			startDate: null,
			endDate: null
		},
		sent: {
			studentName: '',
			memberName: '',
			onlyNotReadedMessages: '',
			startDate: null,
			endDate: null
		}
	},
	compose: [],
	responsible: [],
	schoolMembers: [],
	messageGroup: {
		creationUser: {},
		dateTime: '',
		members: '',
		messageGroup: '',
		messages: [],
		student: {},
		subject: '',
		users: []
	},
	unreadMessages: 0,
	messages: {
		received: [],
		sent: []
	},
	inboxAgenda: []
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getLeavingMonitor: function getLeavingMonitor(context, payload) {

		if (payload) {

			return _http2.default.get('v1/get-at-school/user/' + payload + '?schoolClassId=').then(function (response) {

				response.data.forEach(function (value) {

					if (!value.student.photoURL) {
						value.student.photoURL = 'assets/images/default-avatar.png';
					}
				});

				context.commit('SET_LEAVING_MONITOR', response.data);

				return response;
			});
		}
	},
	postStudentRelease: function postStudentRelease(context, payload) {

		var route = '/v1/get-at-school/' + payload.id + '/user/1';

		return _http2.default.post(route, payload).then(function (response) {

			_toastr2.default.success('Aluno liberado com sucesso!');

			return response;
		});
	}
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	students: function students(state) {
		return state.students;
	}
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_LEAVING_MONITOR: function SET_LEAVING_MONITOR(state, payload) {
		state.students = payload;
	}
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	students: []
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(417);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(418);

var _main4 = _interopRequireDefault(_main3);

var _store = __webpack_require__(121);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'LessonPlanningPage',
	data: function data() {
		return {
			onlyPending: false
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolClassLessonPlan'])),
	components: {
		PageBar: _pageBar2.default,
		PlanningFilter: _main2.default,
		Planning: _main4.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'putSchoolClassLessonPlan'])),
	created: function created() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Planejamento de aula'
		}]);
	}
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(210);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(172);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(171);

var _main4 = _interopRequireDefault(_main3);

var _main5 = __webpack_require__(119);

var _main6 = _interopRequireDefault(_main5);

var _main7 = __webpack_require__(28);

var _main8 = _interopRequireDefault(_main7);

var _main9 = __webpack_require__(88);

var _main10 = _interopRequireDefault(_main9);

var _main11 = __webpack_require__(116);

var _main12 = _interopRequireDefault(_main11);

var _main13 = __webpack_require__(117);

var _main14 = _interopRequireDefault(_main13);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'meal-menu-clone',
	data: function data() {
		return {
			recipientGroup: '',
			year: '',
			month: '',
			week: '',
			level: '',
			grade: '',
			schoolClass: '',
			mealMenuClone: [],
			params: {}
		};
	},
	components: {
		PageBar: _pageBar2.default,
		RecipientsGroup: _main2.default,
		ClassLevel: _main4.default,
		ClassGrade: _main6.default,
		SchoolClass: _main8.default,
		Year: _main10.default,
		Month: _main12.default,
		Week: _main14.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'getLoggedUser', 'currentYear', 'currentMonth', 'currentWeek', 'classLevel', 'classGrade', 'mealMenu', 'getClass'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMealMenu', 'putMealMenu', 'updateMealMenu', 'putCurrentMonth', 'putCurrentWeek', 'putWeekList']), {
		formIsValid: function formIsValid() {

			return !(0, _lodash.isEmpty)(this.recipientGroup) && (0, _lodash.isInteger)(this.year) && !(0, _lodash.isEmpty)(this.month) && !(0, _lodash.isEmpty)(this.week);
		},
		updateState: function updateState(data) {
			return this.updateMealMenu(data);
		},
		updateMonth: function updateMonth() {

			this.month = '';
			this.putCurrentMonth({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		updateWeek: function updateWeek() {

			this.week = '';
			this.putCurrentWeek({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		getSchoolMealMenu: function getSchoolMealMenu(filter) {
			var _this = this;

			if (filter.year && filter.month && filter.startDate && filter.endDate) {

				var queryFilter = {
					startDate: filter.startDate,
					endDate: filter.endDate
				};

				if (filter.recipientGroup === 'PER_LEVEL') {
					queryFilter.level = this.classLevel;
				}

				if (filter.recipientGroup === 'PER_GRADE') {

					queryFilter.level = this.classGrade.level;
					queryFilter.gradeId = this.classGrade.gradeId;
				}

				if (filter.recipientGroup === 'PER_CLASS') {

					queryFilter.level = this.getClass.schoolClassLevel;
					queryFilter.gradeId = this.getClass.schoolClassGrade.gradeId;
					queryFilter.schoolClassId = this.getClass.schoolClassId;
				}

				return this.getMealMenu({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(function () {

					_this.mealMenuClone = (0, _lodash.cloneDeep)(_this.mealMenu).map(function (value) {

						value.clonedDate = value.date;
						value.date = null;

						delete value.id;

						return value;
					});
				});
			}
		},
		addItem: function addItem(index) {

			this.mealMenuClone[index].times.push({
				beverage: '',
				meal: '',
				time: '',
				type: ''
			});

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeItem: function removeItem(mealIndex, timesIndex) {

			this.mealMenuClone[mealIndex].times.splice(timesIndex, 1);

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeMealDay: function removeMealDay(index) {

			this.mealMenuClone[index].times = [];
		},
		save: function save() {
			var _this2 = this;

			if (this.formIsValid()) {

				this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));

				var payload = (0, _lodash.cloneDeep)(this.mealMenu).map(function (value) {

					_this2.startDate = _this2.currentWeek.startDate;
					_this2.endDate = _this2.currentWeek.endDate;

					if (_this2.recipientGroup === 'PER_LEVEL') {
						value.level = _this2.classLevel;
					}

					if (_this2.recipientGroup === 'PER_GRADE') {

						value.grade = {
							level: _this2.classGrade.level,
							gradeId: _this2.classGrade.gradeId
						};
					}

					if (_this2.recipientGroup === 'PER_CLASS') {

						value.schoolClass = {
							level: _this2.getClass.schoolClassId,
							gradeId: _this2.getClass.schoolClassId,
							schoolClassId: _this2.getClass.schoolClassId
						};
					}

					if (value.id) {
						delete value.id;
					}

					value.times = value.times.map(function (time) {

						if (time.time && time.time.length === 5) {
							time.time = time.time + ':00';
						} else {
							time.time = null;
						}

						return time;
					});

					return value;
				});

				this.putMealMenu({
					userId: this.getLoggedUser.id,
					data: payload
				}).then(function () {

					_toastr2.default.success(_this2.$gettext('Cardápio duplicado com sucesso!'));

					var query = {};

					query.startDate = _this2.currentWeek.startDate;
					query.endDate = _this2.currentWeek.endDate;
					query.recipientGroup = _this2.recipientGroup;

					if (_this2.recipientGroup === 'PER_LEVEL') {
						query.level = _this2.classLevel;
					}

					if (_this2.recipientGroup === 'PER_GRADE') {

						query.grade = {
							level: _this2.classGrade.level,
							gradeId: _this2.classGrade.gradeId
						};
					}

					if (_this2.recipientGroup === 'PER_CLASS') {

						query.schoolClass = (0, _stringify2.default)({
							level: _this2.getClass.schoolClassId,
							gradeId: _this2.getClass.schoolClassId,
							schoolClassId: _this2.getClass.schoolClassId
						});
					}

					_this2.$router.push({
						name: 'MealMenu',
						query: query
					});
				});
			}
		},
		dateDiff: function dateDiff(input) {
			var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
			var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days';

			return (0, _moment2.default)(value).diff(input, units);
		}
	}),
	created: function created() {

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}, {
			text: this.$gettext('Duplicar')
		}]);

		this.params = this.$route.params;
		_eventBus.EventBus.$emit('classLevelSelected', this.classLevel);

		if ((0, _lodash.isEmpty)(this.params)) {

			this.$router.push({
				name: 'MealMenu'
			});
		}

		this.getSchoolMealMenu(this.params);
		this.recipientGroup = this.params.recipientGroup;

		this.year = this.params.year;
		this.month = this.params.month;
	},
	mounted: function mounted() {
		var _this3 = this;

		_eventBus.EventBus.$on('recipientGroupSelected', function (payload) {
			_this3.recipientGroup = payload;
		});

		_eventBus.EventBus.$on('classLevelSelected', function () {
			_this3.updateWeek();
		});

		_eventBus.EventBus.$on('classGradeSelected', function () {
			_this3.updateWeek();
		});

		_eventBus.EventBus.$on('classChanged', function () {
			_this3.updateWeek();
		});

		_eventBus.EventBus.$on('yearChanged', function (payload) {

			_this3.year = payload;

			_this3.updateMonth();
			_this3.updateWeek();
		});

		_eventBus.EventBus.$on('monthChanged', function (payload) {

			_this3.month = payload;

			_this3.updateWeek();
		});

		_eventBus.EventBus.$on('weekChanged', function (payload) {

			var initialDate = (0, _moment2.default)(payload.startDate);

			_this3.week = payload;

			_this3.mealMenuClone.map(function (value) {

				value.date = (0, _lodash.cloneDeep)(initialDate).format('YYYY-MM-DD');
				value.isBefore = (0, _lodash.cloneDeep)(initialDate).add(1, 'day').isBefore();

				initialDate.add(1, 'd');

				return value;
			});
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('recipientGroupSelected');
		_eventBus.EventBus.$off('classLevelSelected');
		_eventBus.EventBus.$off('classGradeSelected');
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('yearChanged');
		_eventBus.EventBus.$off('monthChanged');
		_eventBus.EventBus.$off('weekChanged');
	}
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _tooltip = __webpack_require__(272);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _tooltip3 = __webpack_require__(264);

var _tooltip4 = _interopRequireDefault(_tooltip3);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(172);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(171);

var _main4 = _interopRequireDefault(_main3);

var _main5 = __webpack_require__(119);

var _main6 = _interopRequireDefault(_main5);

var _main7 = __webpack_require__(28);

var _main8 = _interopRequireDefault(_main7);

var _main9 = __webpack_require__(88);

var _main10 = _interopRequireDefault(_main9);

var _main11 = __webpack_require__(116);

var _main12 = _interopRequireDefault(_main11);

var _main13 = __webpack_require__(117);

var _main14 = _interopRequireDefault(_main13);

var _actions = __webpack_require__(188);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(190);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(189);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(191);

var _state2 = _interopRequireDefault(_state);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'meal-menu',
	data: function data() {
		return {
			recipientGroup: '',
			year: '',
			month: '',
			week: '',
			mealMenuClone: [],
			isEditMode: false
		};
	},
	components: {
		Tooltip: _tooltip4.default,
		PageBar: _pageBar2.default,
		RecipientsGroup: _main2.default,
		ClassLevel: _main4.default,
		ClassGrade: _main6.default,
		SchoolClass: _main8.default,
		Year: _main10.default,
		Month: _main12.default,
		Week: _main14.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'getLoggedUser', 'currentYear', 'currentMonth', 'currentWeek', 'classLevel', 'classGrade', 'mealMenu', 'getClass', 'weeks'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMealMenu', 'putMealMenu', 'updateMealMenu', 'putCurrentMonth', 'putCurrentWeek', 'putWeekList', 'removeMeal']), {
		editMode: function editMode() {
			var _editMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this.isEditMode = _editMode;
		},
		updateState: function updateState(data) {
			return this.updateMealMenu(data);
		},
		updateMonth: function updateMonth() {

			this.month = '';
			this.putCurrentMonth({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		updateWeek: function updateWeek() {

			this.week = '';
			this.putCurrentWeek({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		getSchoolMealMenu: function getSchoolMealMenu(startDate, endDate) {
			var _this = this;

			if (this.currentYear && this.currentMonth && !(0, _lodash.isEmpty)(this.currentWeek)) {

				this.isEditMode = false;

				var queryFilter = {
					startDate: startDate || this.currentWeek.startDate,
					endDate: endDate || this.currentWeek.endDate
				};

				if (this.recipientGroup === 'PER_LEVEL') {

					if (this.classLevel) {
						queryFilter.level = this.classLevel;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}
				}

				if (this.recipientGroup === 'PER_GRADE') {

					if (this.classGrade.level) {
						queryFilter.level = this.classGrade.level;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}

					if (this.classGrade.gradeId) {
						queryFilter.gradeId = this.classGrade.gradeId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o ano de ensino (série)'));
					}
				}

				if (this.recipientGroup === 'PER_CLASS') {

					if (this.getClass.schoolClassLevel) {
						queryFilter.level = this.getClass.schoolClassLevel;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}

					if (this.getClass.schoolClassGrade && this.getClass.schoolClassGrade.gradeId) {
						queryFilter.gradeId = this.getClass.schoolClassGrade.gradeId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o ano de ensino (série)'));
					}

					if (this.getClass.schoolClassId) {
						queryFilter.schoolClassId = this.getClass.schoolClassId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione a turma'));
					}
				}

				return this.getMealMenu({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(function () {

					_this.mealMenuClone = (0, _lodash.cloneDeep)(_this.mealMenu);
				});
			}
		},
		addItem: function addItem(index) {

			this.mealMenuClone[index].times.push({
				beverage: '',
				meal: '',
				time: '',
				type: ''
			});

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeItem: function removeItem(mealIndex, timesIndex) {

			this.mealMenuClone[mealIndex].times.splice(timesIndex, 1);

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeMealDay: function removeMealDay(itemId) {
			var _this2 = this;

			this.removeMeal({
				userId: this.getLoggedUser.id,
				mealId: itemId
			}).then(function () {

				_toastr2.default.success(_this2.$gettext('Item removido com sucesso!'));
				_this2.getSchoolMealMenu();
			});
		},
		save: function save() {
			var _this3 = this;

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));

			var payload = (0, _lodash.cloneDeep)(this.mealMenu).map(function (value) {

				if (_this3.recipientGroup === 'PER_LEVEL') {
					value.level = _this3.classLevel;
					value.grade = null;
					value.schoolClass = null;
				}

				if (_this3.recipientGroup === 'PER_GRADE') {

					value.level = null;
					value.grade = {
						level: _this3.classGrade.level,
						gradeId: _this3.classGrade.gradeId
					};
					value.schoolClass = null;
				}

				if (_this3.recipientGroup === 'PER_CLASS') {

					value.level = _this3.getClass.schoolClassLevel;
					value.grade = {
						gradeId: _this3.getClass.schoolClassGrade.gradeId
					};
					value.schoolClass = {
						level: _this3.getClass.schoolClassLevel,
						gradeId: _this3.getClass.schoolClassGrade.gradeId,
						schoolClassId: _this3.getClass.schoolClassId
					};
				}

				if (value.id) {
					value.id = value.id;
				}

				value.times = value.times.map(function (time) {

					if (time.time && time.time.length === 5) {
						time.time = time.time + ':00';
					} else {
						time.time = null;
					}

					return time;
				});

				return value;
			});

			this.putMealMenu({
				userId: this.getLoggedUser.id,
				data: payload
			}).then(function () {

				_this3.isEditMode = false;

				_toastr2.default.success(_this3.$gettext('Cardápio salvo com sucesso!'));
			});
		},
		dateDiff: function dateDiff(input) {
			var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
			var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days';

			return (0, _moment2.default)(value).diff(input, units);
		},
		getFilter: function getFilter() {

			var params = {
				recipientGroup: this.recipientGroup,
				year: this.year,
				month: this.month,
				startDate: this.currentWeek.startDate,
				endDate: this.currentWeek.endDate
			};

			if (this.recipientGroup === 'PER_LEVEL') {
				params.level = this.classLevel;
			}

			if (this.recipientGroup === 'PER_GRADE') {
				params.grade = this.classGrade;
			}

			if (this.recipientGroup === 'PER_CLASS') {

				var klass = (0, _lodash.cloneDeep)(this.getClass);
				delete klass.teachers;

				params.schoolClass = klass;
			}

			return params;
		},
		duplicate: function duplicate() {

			this.$router.push({
				name: 'MealMenuClone',
				params: this.getFilter()
			});
		},
		showMonthly: function showMonthly() {

			var params = this.getFilter();

			params.startDate = this.weeks[0].startDate;
			params.endDate = this.weeks[this.weeks.length - 1].endDate;

			this.$router.push({
				name: 'MealMenuMonthly',
				params: params
			});
		}
	}),
	created: function created() {

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}]);

		this.updateState([]);
	},
	mounted: function mounted() {
		var _this4 = this;

		this.year = this.currentYear;
		this.month = this.currentMonth;
		this.week = this.currentWeek;

		_eventBus.EventBus.$on('recipientGroupSelected', function (payload) {

			_this4.recipientGroup = payload;

			_this4.updateWeek();
			_this4.updateState({});
		});

		_eventBus.EventBus.$on('classLevelSelected', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('classGradeSelected', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('classChanged', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('yearChanged', function (payload) {

			_this4.year = payload;

			_this4.updateMonth();
			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('monthChanged', function (payload) {

			_this4.month = payload;

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('weekChanged', function (payload) {

			_this4.week = payload;

			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('recipientGroupSelected');
		_eventBus.EventBus.$off('classLevelSelected');
		_eventBus.EventBus.$off('classGradeSelected');
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('yearChanged');
		_eventBus.EventBus.$off('monthChanged');
		_eventBus.EventBus.$off('weekChanged');
	}
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDICINE_BASE_PATH = 'v1/student-medicine/';

exports.default = {
	getMedicine: function getMedicine(context, payload) {

		if (payload) {

			var queryString = _string2.default.makeQueryString(payload);

			return _http2.default.get(MEDICINE_BASE_PATH + 'user/' + payload.user + queryString).then(function (response) {

				context.commit('SET_MEDICINE', response.data);
				context.commit('FILTER_STUDENT_MEDICINE', payload.filter.student);
				context.commit('FILTER_DATE_MEDICINE', payload.filter.date);

				return response;
			});
		}
	},
	getMedicineIsTaken: function getMedicineIsTaken(context, payload) {

		if (payload) {

			return (0, _lodash.compact)(context.state.list.map(function (item) {

				if (item.medicinesTaken || item.rejectionReason) {
					return item;
				}
			}));
		} else {

			return (0, _lodash.compact)(context.state.list.map(function (item) {

				if (!item.medicinesTaken && !item.rejectionReason) {

					item.takenHour = '';
					item.reject = false;

					return item;
				}
			}));
		}
	},
	setMedicineHistory: function setMedicineHistory(context, payload) {
		context.commit('SET_MEDICINE_HISTORY', payload);
	},
	setMedicinePending: function setMedicinePending(context, payload) {
		context.commit('SET_MEDICINE_PENDING', payload);
	},
	saveMedicineTaken: function saveMedicineTaken(context, payload) {

		var route = '' + MEDICINE_BASE_PATH + payload.id + '/user/' + payload.userId;

		return _http2.default.post(route, {
			time: payload.time
		}).then(function (response) {
			return response;
		});
	},
	setRejectMedicine: function setRejectMedicine(context, payload) {
		context.commit('SET_REJECT_MEDICINE', payload);
	},
	setRejectionReasonMedicine: function setRejectionReasonMedicine(context, payload) {

		var route = '' + MEDICINE_BASE_PATH + payload.id + '/user/' + payload.userId + '/reject';

		return _http2.default.put(route, {
			rejectionReason: payload.rejectionReason
		}).then(function (response) {
			return response;
		});
	},
	cancelRejectionReasonMedicine: function cancelRejectionReasonMedicine(context, payload) {

		var route = '' + MEDICINE_BASE_PATH + payload.id + '/user/' + payload.userId + '/reject/revert';

		return _http2.default.put(route).then(function (response) {
			return response;
		});
	}
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	medicineList: function medicineList(state) {
		return state.list;
	},
	medicineHistory: function medicineHistory(state) {
		return state.history;
	},
	medicinePending: function medicinePending(state) {
		return state.pending;
	},
	medicineStudent: function medicineStudent(state) {
		return state.filter.student;
	},
	medicineDate: function medicineDate(state) {
		return state.filter.date;
	}
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_MEDICINE: function SET_MEDICINE(state, payload) {
		state.list = payload;
	},
	SET_MEDICINE_HISTORY: function SET_MEDICINE_HISTORY(state, payload) {
		state.history.list = payload;
	},
	SET_MEDICINE_PENDING: function SET_MEDICINE_PENDING(state, payload) {
		state.pending.list = payload;
	},
	FILTER_STUDENT_MEDICINE: function FILTER_STUDENT_MEDICINE(state, payload) {
		state.filter.student = payload;
	},
	FILTER_DATE_MEDICINE: function FILTER_DATE_MEDICINE(state, payload) {
		state.filter.date = payload;
	},
	SET_REJECT_MEDICINE: function SET_REJECT_MEDICINE(state, payload) {
		state.pending.list[payload].reject = !state.pending.list[payload].reject;
	}
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: [],
	history: {
		list: []
	},
	pending: {
		list: []
	},
	filter: {
		date: '',
		student: ''
	}
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _store = __webpack_require__(471);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'sample',
	state: _store.state,
	mutations: _store.mutations,
	actions: _store.actions,
	getters: _store.getters,
	props: {
		// TODO
	},
	data: function data() {
		return {
			dtOption: 'something'
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([
		// TODO
	]), (0, _vuex.mapState)([
		// TODO
	])),
	components: {
		PageBar: _pageBar2.default
	},
	watch: {
		// TODO
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb']
	// TODO
	)),
	beforeCreate: function beforeCreate() {
		// TODO
	},
	created: function created() {
		// TODO
	},
	beforeMount: function beforeMount() {
		// TODO
	},
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Sample'
		}, {
			text: 'A'
		}, {
			text: 'B'
		}, {
			text: 'C'
		}]);

		// TODO
	},
	beforeUpdate: function beforeUpdate() {
		// TODO
	},
	updated: function updated() {
		// TODO
	},
	beforeDestroy: function beforeDestroy() {
		// TODO
	},
	destroyed: function destroyed() {
		// TODO
	}
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

var _string = __webpack_require__(43);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getSomethings: function getSomethings(context, payload) {

		if (payload) {

			var queryString = _string2.default.makeQueryString(payload);

			return _http2.default.get('somethings/' + payload.something + queryString).then(function (response) {

				context.commit('SET_SOMETHINGS', response.data);

				return response;
			});
		}
	}
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	something: function something(state) {
		return state.current;
	},
	somethings: function somethings(state) {
		return state.list;
	}
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _actions = __webpack_require__(469);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(472);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(470);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(473);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	state: _state2.default
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_SOMETHINGS: function SET_SOMETHINGS(state, payload) {
		state.list = payload;
	},
	SET_SOMETHING: function SET_SOMETHING(state, payload) {
		state.current = payload;
	}
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: [],
	current: {}
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vueRangeSlider = __webpack_require__(421);

var _vueRangeSlider2 = _interopRequireDefault(_vueRangeSlider);

__webpack_require__(274);

var _vuex = __webpack_require__(4);

var _actions = __webpack_require__(193);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(195);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(194);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(196);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	actions: _actions2.default,
	getters: _getters2.default,
	state: _state2.default,
	mutations: _mutations2.default,
	name: 'simulator',
	data: function data() {
		return {
			form: {
				schoolName: '',
				contactName: '',
				contactEmailAddress: '',
				mobilePhoneNumber: '',
				studentsQuantity: 500,
				plan: '',
				levels: [],
				voucherNumber: ''
			}
		};
	},

	components: {
		RangeSlider: _vueRangeSlider2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		levelsType: function levelsType(state) {
			return state.ENUM.Levels;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['sendFormLead']), {
		sendForm: function sendForm() {
			var _this = this;

			this.sendFormLead(this.form).then(function () {

				_this.$router.push({
					name: 'SimulatorValues'
				});
			}).catch(function (error) {
				alert(error.response.data.statusDescription);
			});
		}
	})
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'available-languages'
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	setBreadcrumb: function setBreadcrumb(context, payload) {
		context.commit('SET_BREADCRUMB', payload);
	}
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	breadcrumbPages: function breadcrumbPages(state) {
		return state.list;
	}
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_BREADCRUMB: function SET_BREADCRUMB(state, payload) {
		state.list = payload;
	}
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: []
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	putCurrentMonth: function putCurrentMonth(context, payload) {
		context.commit('PUT_CURRENT_MONTH', payload);
	},
	putMonthList: function putMonthList(context, payload) {
		context.commit('PUT_MONTH_LIST', payload);
	}
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	currentMonth: function currentMonth(state) {
		return state.current;
	},
	months: function months(state) {
		return state.list;
	}
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	PUT_CURRENT_MONTH: function PUT_CURRENT_MONTH(state, payload) {
		state.current = payload;
	},
	PUT_MONTH_LIST: function PUT_MONTH_LIST(state, payload) {
		state.list = payload;
	}
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var today = (0, _moment2.default)();

exports.default = {
	current: {
		index: parseInt(today.format('MM')) - 1,
		value: today.format('MMMM').toUpperCase()
	}
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	putCurrentWeek: function putCurrentWeek(context, payload) {
		context.commit('PUT_CURRENT_WEEK', payload);
	},
	putWeekList: function putWeekList(context, payload) {
		context.commit('PUT_WEEK_LIST', payload);
	}
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	currentWeek: function currentWeek(state) {
		return state.current;
	},
	weeks: function weeks(state) {
		return state.list;
	}
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	PUT_CURRENT_WEEK: function PUT_CURRENT_WEEK(state, payload) {
		state.current = payload;
	},
	PUT_WEEK_LIST: function PUT_WEEK_LIST(state, payload) {
		state.list = payload;
	}
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	current: {},
	list: []
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(200);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'year',
	data: function data() {
		return {
			year: ''
		};
	},
	props: {
		name: {
			type: String,
			default: 'year'
		},
		label: {
			type: String,
			default: 'Ano'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		onlyFuture: {
			type: Boolean,
			default: false
		},
		withNextYear: {
			type: Boolean,
			default: false
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentYear', 'years'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putCurrentYear', 'putYearsList', 'pushYear']), {
		changed: function changed() {

			this.putCurrentYear(this.year);
			_eventBus.EventBus.$emit(this.name + 'Changed', this.year);
		},
		makeFullList: function makeFullList(baseYear, currentYear) {

			var list = [];

			for (var year = currentYear; year >= baseYear; year--) {

				list.push({
					id: year,
					value: year.toString()
				});
			}

			return list;
		}
	}),
	mounted: function mounted() {

		this.year = this.currentYear;

		var list = this.makeFullList(2014, (0, _moment2.default)().get('Y'));
		var nextYear = (0, _moment2.default)().add(1, 'y').get('Y');

		if (this.withNextYear) {

			list.unshift({
				id: nextYear,
				value: nextYear.toString()
			});

			this.putYearsList(list);
		}

		if (this.onlyFuture) {

			this.putYearsList([{
				id: this.currentYear,
				value: this.currentYear.toString()
			}, {
				id: nextYear,
				value: nextYear.toString()
			}]);
		}
	}
});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _breadcrumb = __webpack_require__(991);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _availableLanguages = __webpack_require__(990);

var _availableLanguages2 = _interopRequireDefault(_availableLanguages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'page-bar',
	props: {
		pages: {
			type: Array
		},
		languages: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Breadcrumb: _breadcrumb2.default,
		AvailableLanguages: _availableLanguages2.default
	}
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'textarea-counter',
	computed: {
		charactersLeft: function charactersLeft() {
			return this.limit - this.size + ' / ' + this.limit;
		}
	},
	props: {
		size: {
			type: Number,
			required: true
		},
		limit: {
			type: Number,
			default: 1000
		}
	}
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'activities',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		activities: function activities(state) {
			return state.Agenda.agenda.activities;
		},
		ParticipationType: function ParticipationType(state) {
			return state.ENUM.ParticipationType;
		},
		participation: function participation(state) {
			return state.Agenda.agenda.participation;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaActivities', 'putAgendaParticipation']))
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _textareaCounter = __webpack_require__(170);

var _textareaCounter2 = _interopRequireDefault(_textareaCounter);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'observation',
	components: {
		TextareaCounter: _textareaCounter2.default
	},
	data: function data() {
		return {
			notes: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		observation: function observation(state) {
			return state.Agenda.agenda.observation;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaObservation'])),

	mounted: function mounted() {
		var _this = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this.notes = '';
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _popover = __webpack_require__(168);

var _popover2 = _interopRequireDefault(_popover);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _popover3 = __webpack_require__(163);

var _popover4 = _interopRequireDefault(_popover3);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'agenda-editors',
	components: {
		Popover: _popover4.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		agenda: function agenda(state) {
			return state.Agenda.agenda;
		}
	}))
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _popover = __webpack_require__(168);

var _popover2 = _interopRequireDefault(_popover);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _popover3 = __webpack_require__(163);

var _popover4 = _interopRequireDefault(_popover3);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'agenda-viewers',
	components: {
		Popover: _popover4.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		agenda: function agenda(state) {
			return state.Agenda.agenda;
		}
	}))
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(996);

var _main2 = _interopRequireDefault(_main);

var _water = __webpack_require__(997);

var _water2 = _interopRequireDefault(_water);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'alimentation',
	components: {
		StudentMeals: _main2.default,
		StudentWater: _water2.default
	}
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-water',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		quantityType: function quantityType(state) {
			return state.ENUM.QuantityType;
		},
		water: function water(state) {
			return state.Agenda.agenda.water;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaWater']))
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-bath-quantity',
	data: function data() {
		return {
			bathQuantity: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		bathsQuantity: function bathsQuantity(state) {
			return state.Agenda.agenda.bathQuantity;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaBathQuantity'])),
	mounted: function mounted() {
		var _this = this;

		this.bathsQuantity;
		_eventBus.EventBus.$on('setStudent', function () {

			_this.bathQuantity = '';
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-diapers-quantity',
	data: function data() {
		return {
			diaperQuantity: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		diapersQuantity: function diapersQuantity(state) {
			return state.Agenda.agenda.diaperQuantity;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaDiaperQuantity'])),
	mounted: function mounted() {
		var _this = this;

		this.diapersQuantity;
		_eventBus.EventBus.$on('setStudent', function () {

			_this.diaperQuantity = '';
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-evacueted',
	data: function data() {
		return {
			evacuation: {
				shift: '',
				evacuation: '',
				quantity: ''
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		dayShiftType: function dayShiftType(state) {
			return state.ENUM.DayShiftType;
		},
		AgendaEvacuationType: function AgendaEvacuationType(state) {
			return state.ENUM.AgendaEvacuationType;
		},
		evacuations: function evacuations(state) {
			return state.Agenda.agenda.evacuation;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['deleteEvacuationItem', 'postAgendaEvacuationItem', 'putAgendaEvacuationItem', 'putCompletionStatus']), {
		formReset: function formReset() {

			this.evacuation = {
				shift: '',
				evacuation: '',
				quantity: ''
			};

			this.putCompletionStatus({
				key: 'evacuation',
				value: true
			});
		},
		completionStatus: function completionStatus(model) {

			var status = false;

			if ((0, _lodash.isEmpty)(model.shift) && (0, _lodash.isEmpty)(model.quantity) && (0, _lodash.isEmpty)(model.evacuation)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'evacuation',
				value: status
			});
		},
		addEvacuationItem: function addEvacuationItem() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid) {

					_this.evacuations.map(function (value) {

						_this.evacuation.quantity = parseInt(_this.evacuation.quantity);

						var valueClone = (0, _lodash.cloneDeep)(value);
						delete valueClone.quantity;

						var modelClone = (0, _lodash.cloneDeep)(_this.evacuation);
						delete modelClone.quantity;

						if ((0, _lodash.isEqual)(valueClone, modelClone)) {

							_this.evacuation.index = _this.evacuations.indexOf(value);
							_this.evacuation.quantity = parseInt(_this.evacuation.quantity) + parseInt(value.quantity);
						}
					});

					if (_this.evacuation.index !== undefined && _this.evacuation.index >= 0) {
						_this.putAgendaEvacuationItem((0, _lodash.cloneDeep)(_this.evacuation));
					} else {
						_this.postAgendaEvacuationItem((0, _lodash.cloneDeep)(_this.evacuation));
					}

					_this.evacuation = {
						shift: '',
						evacuation: '',
						quantity: ''
					};

					_this.completionStatus(true);
				} else {
					_toastr2.default.warning('Por favor informar todos os campos relacionados a evacuação');
				}
			});
		},
		editEvacuationItem: function editEvacuationItem(index) {

			this.evacuation = (0, _lodash.cloneDeep)(this.evacuations[index]);
			this.evacuation.index = index;
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this2.evacuation = {
				shift: '',
				evacuation: '',
				quantity: ''
			};
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _textareaCounter = __webpack_require__(170);

var _textareaCounter2 = _interopRequireDefault(_textareaCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-eventual-medicine',
	components: {
		TextareaCounter: _textareaCounter2.default
	},
	data: function data() {
		return {
			medicine: {
				reason: '',
				time: '',
				medicine: '',
				dosage: ''
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		eventualMedicines: function eventualMedicines(state) {
			return state.Agenda.agenda.eventualMedicines;
		}
	}), (0, _vuex.mapGetters)({
		date: 'getAgendaDate'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['deleteEventualMedicineItem', 'postAgendaEventualMedicineItem', 'putAgendaEventualMedicineItem', 'putCompletionStatus']), {
		completionStatus: function completionStatus(model) {

			var status = false;

			if ((0, _lodash.isEmpty)(model.time) && (0, _lodash.isEmpty)(model.medicine) && (0, _lodash.isEmpty)(model.dosage) && (0, _lodash.isEmpty)(model.reason)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'eventualMedicine',
				value: status
			});
		},
		addEventualMedicineItem: function addEventualMedicineItem() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid && _this.getTimeDiff(_this.medicine.time) > 0 && _this.getTimeDiff(_this.medicine.time) > 0) {

					_this.medicine.time = _this.medicine.time + ':00';

					if (_this.medicine.index !== undefined && _this.medicine.index >= 0) {
						_this.putAgendaEventualMedicineItem((0, _lodash.cloneDeep)(_this.medicine));
					} else {
						_this.postAgendaEventualMedicineItem((0, _lodash.cloneDeep)(_this.medicine));
					}

					_this.medicine = {
						reason: '',
						time: '',
						medicine: '',
						dosage: ''
					};

					_this.completionStatus(true);
				} else if (_this.getTimeDiff(_this.medicine.time) <= 0) {
					_toastr2.default.warning('O horário da medicação não pode ser uma data futura.');
				} else {
					_toastr2.default.warning('Por favor, informe todos os campos relacionados a soneca.');
				}
			});
		},
		editEventualMedicineItem: function editEventualMedicineItem(index) {

			this.medicine = (0, _lodash.cloneDeep)(this.eventualMedicines[index]);
			this.medicine.index = index;
		},
		getTimeDiff: function getTimeDiff(time) {

			if (time) {
				var _date$split = this.date.split('-'),
				    _date$split2 = (0, _slicedToArray3.default)(_date$split, 3),
				    year = _date$split2[0],
				    month = _date$split2[1],
				    date = _date$split2[2];

				var _time$split = time.split(':'),
				    _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
				    hour = _time$split2[0],
				    minute = _time$split2[1];

				return (0, _moment2.default)().diff((0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: hour,
					minute: minute,
					second: 0
				}));
			}
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this2.medicine = {
				reason: '',
				time: '',
				medicine: '',
				dosage: ''
			};
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-nap',
	data: function data() {
		return {
			nap: {
				endTime: '',
				startTime: ''
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		}
	}), (0, _vuex.mapGetters)({
		naps: 'getAgendaSleepy',
		date: 'getAgendaDate'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['deleteNapItem', 'postAgendaNapsItem', 'putAgendaNapsItem', 'putCompletionStatus']), {
		completionStatus: function completionStatus(value) {

			this.putCompletionStatus({
				key: 'nap',
				value: value
			});
		},
		addNapItem: function addNapItem() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid && _this.getTimeDiff(_this.nap.startTime) > 0 && _this.getTimeDiff(_this.nap.endTime) > 0) {

					if (_this.nap.index !== undefined && _this.nap.index >= 0) {
						_this.putAgendaNapsItem(_.clone(_this.nap));
					} else {
						_this.postAgendaNapsItem(_.clone(_this.nap));
					}

					_this.nap = {
						endTime: '',
						startTime: ''
					};

					_this.completionStatus(true);
				} else if (_this.getTimeDiff(_this.nap.startTime) <= 0) {
					_toastr2.default.warning('O horário de início da soneca não pode ser uma data futura.');
				} else if (_this.getTimeDiff(_this.nap.endTime) <= 0) {
					_toastr2.default.warning('O horário de fim da soneca não pode ser uma data futura.');
				} else {
					_toastr2.default.warning('Por favor, informe todos os campos relacionados a soneca.');
				}
			});
		},
		editNapsItem: function editNapsItem(index) {

			this.nap = _.clone(this.naps[index]);
			this.nap.index = index;
		},
		getTimeDiff: function getTimeDiff(time) {

			if (time) {
				var _date$split = this.date.split('-'),
				    _date$split2 = (0, _slicedToArray3.default)(_date$split, 3),
				    year = _date$split2[0],
				    month = _date$split2[1],
				    date = _date$split2[2];

				var _time$split = time.split(':'),
				    _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
				    hour = _time$split2[0],
				    minute = _time$split2[1];

				return (0, _moment2.default)().diff((0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: hour,
					minute: minute,
					second: 0
				}));
			}
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this2.nap = {
				endTime: '',
				startTime: ''
			};
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'scheduled-medicine',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		regularMedicines: 'getAgendaRegularMedicines',
		agendaDate: 'getAgendaDate'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaScheduledMedicine']), {
		getTimeDiff: function getTimeDiff(time) {

			if (time) {
				var _agendaDate$split = this.agendaDate.split('-'),
				    _agendaDate$split2 = (0, _slicedToArray3.default)(_agendaDate$split, 3),
				    year = _agendaDate$split2[0],
				    month = _agendaDate$split2[1],
				    date = _agendaDate$split2[2];

				var _time$split = time.split(':'),
				    _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
				    hour = _time$split2[0],
				    minute = _time$split2[1];

				return (0, _moment2.default)().diff((0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: hour,
					minute: minute,
					second: 0
				}));
			}
		}
	})

};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-urine-quantity',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		piss: function piss(state) {
			return state.Agenda.agenda.piss;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaUrine']))
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(1006);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(1007);

var _main4 = _interopRequireDefault(_main3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'highlight',
	components: {
		StudentMessages: _main2.default,
		StudentPresenceTheme: _main4.default
	}
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-highlight-messages',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		messagesGroups: function messagesGroups(state) {
			return state.Inbox.inboxAgenda;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMessages']), {
		replyMessage: function replyMessage(messageGroup) {

			this.$router.push({
				name: 'ReplyMessage',
				params: {
					id: messageGroup
				}
			});
		}
	}),
	mounted: function mounted() {

		this.getMessages();
	}
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-presence-themes',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		}
	}))
};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-humor',
	DatePicker: _datePicker4.default,
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		humor: function humor(state) {
			return state.Agenda.agenda.humor;
		},
		humorTypes: function humorTypes(state) {
			return state.ENUM.HumorTypes;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaHumor']))
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-presence',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		presence: function presence(state) {
			return state.ENUM.Presence;
		},
		stdPresence: function stdPresence(state) {
			return state.Agenda.agenda.presence;
		}
	})),

	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaPresence']))
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-question',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		stdQuestions: function stdQuestions(state) {
			return state.Agenda.agenda.questions;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaQuestions']))
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _http = __webpack_require__(20);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	getHomeworkBySchoolClass: function getHomeworkBySchoolClass(context, payload) {

		if (payload && payload.userId && payload.schoolClassId && payload.agendaDate) {
			var userId = payload.userId,
			    agendaDate = payload.agendaDate,
			    schoolClassId = payload.schoolClassId;


			var route = 'v2/homework/school-class/' + schoolClassId + '/user/' + userId + '?date=' + agendaDate;

			return _http2.default.get(route).then(function (response) {
				return response.data;
			});
		}
	},
	setHomeworkList: function setHomeworkList(context, payload) {

		context.commit('SET_HOMEWORK_LIST', payload);
	},
	saveHomeworkBySchoolClass: function saveHomeworkBySchoolClass(context, payload) {

		if (payload) {

			var route = 'v2/homework/user/' + context.getters.getLoggedUser.id;
			var payloadClone = (0, _lodash.cloneDeep)(payload);

			payloadClone.themes.map(function (value) {

				if (value.dueDate) {
					value.dueDate = (0, _moment2.default)(value.dueDate).format('YYYY-MM-DD');
				}

				return value;
			});

			return _http2.default.post(route, payloadClone).then(function (response) {

				response.data.themes.map(function (value) {

					if (value.dueDate) {
						value.dueDate = (0, _moment2.default)(value.dueDate).toISOString();
					}

					return value;
				});

				context.commit('SET_HOMEWORK_LIST', response.data);

				return response;
			});
		}
	},
	publishHomeworkBySchoolClass: function publishHomeworkBySchoolClass(context, payload) {

		if (payload) {

			var route = 'v2/homework/' + payload.homeworkId + '/theme/' + payload.themeId + '/user/' + payload.user;

			return _http2.default.post(route).then(function (response) {

				response.data.themes.map(function (value) {

					if (value.dueDate) {
						value.dueDate = (0, _moment2.default)(value.dueDate).toISOString();
					}

					return value;
				});
				context.commit('SET_HOMEWORK_LIST', response.data);

				return response;
			});
		}
	},
	publishAllHomeworkBySchoolClass: function publishAllHomeworkBySchoolClass(context, payload) {

		if (payload) {
			return _http2.default.post('v2/homework/' + payload.id + '/user/' + payload.userId);
		}
	},
	putHomeworkItemByKey: function putHomeworkItemByKey(context, payload) {

		if (payload) {
			context.commit('PUT_HOMEWORK_ITEM_BY_KEY', (0, _lodash.cloneDeep)(payload));
		}
	},
	putExclusiveHomeworkItemByKey: function putExclusiveHomeworkItemByKey(context, payload) {
		if (payload) {
			context.commit('PUT_EXCLUSIVE_HOMEWORK', (0, _lodash.cloneDeep)(payload));
		}
	}
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getHomeworkList: function getHomeworkList(state) {
		return state.list;
	},
	getHomeworkId: function getHomeworkId(state) {
		return state.id;
	}
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _state = __webpack_require__(514);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(510);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(513);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(511);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	actions: _actions2.default,
	name: 'homework'
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_HOMEWORK_LIST: function SET_HOMEWORK_LIST(state, payload) {
		state.list = payload.themes;
		state.id = payload.id;
		state.date = payload.date;
	},
	PUT_HOMEWORK_ITEM_BY_KEY: function PUT_HOMEWORK_ITEM_BY_KEY(state, payload) {
		var index = payload.index,
		    theme = payload.theme;


		state.list[index] = theme;
	}
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	list: [],
	date: '',
	id: ''
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _emojiMartVue = __webpack_require__(270);

var _vueSelect = __webpack_require__(90);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _students = __webpack_require__(89);

var _students2 = _interopRequireDefault(_students);

var _i18nEmoji = __webpack_require__(423);

var _i18nEmoji2 = _interopRequireDefault(_i18nEmoji);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'message-new',
	data: function data() {
		return {
			selected: null,
			responsible: [],
			member: [],
			subject: '',
			message: '',
			emojiPickerVisible: false,
			i18n: _i18nEmoji2.default['pt_BR']
		};
	},
	components: {
		Emoji: _emojiMartVue.Emoji,
		Picker: _emojiMartVue.Picker,
		vSelect: _vueSelect2.default,
		SchoolClassList: _main2.default,
		Students: _students2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		studentName: function studentName(state) {
			return state.Student.selected.name;
		},
		className: function className(state) {
			return state.Class.selected.description;
		},
		recipient: function recipient(state) {
			return state.Inbox.list;
		},
		studentId: function studentId(state) {
			return state.Student.selected.studentId;
		},
		userId: function userId(state) {
			return state.Logged.user.id;
		}
	}), (0, _vuex.mapGetters)({
		responsibles: 'getInboxResponsibles',
		schoolmembers: 'getInboxSchoolMembers'
	})),

	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMessageRecipient', 'sendMessageNew', 'putMessageSubject', 'putMessageMessage', 'putMessageRecipientSelected', 'setRecipients', 'getMessageGroup']), {
		insertAtCaret: function insertAtCaret(text) {
			var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'textarea';


			// https://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery#answer-28353499

			var textarea = document.querySelector(element);
			var caretPosition = textarea.selectionStart;
			var front = textarea.value.substring(0, caretPosition);
			var back = textarea.value.substring(textarea.selectionEnd, textarea.value.length);

			this.message = front + text + back;
		},
		addEmoji: function addEmoji(emoji) {
			this.insertAtCaret(emoji.native);
		},
		sendNewMessage: function sendNewMessage() {
			var _this = this;

			var usersArray = [];

			this.responsible.forEach(function (user) {

				usersArray.push({
					user: {
						userId: user.userId
					}
				});
			});

			this.member.forEach(function (user) {

				usersArray.push({
					user: {
						userId: user.userId
					}
				});
			});

			this.sendMessageNew({
				from: {
					userId: this.userId
				},
				student: {
					studentId: this.studentId
				},
				subject: this.subject,
				message: this.message,
				users: usersArray
			}).then(function (response) {

				_this.getMessageGroup(response.data.messageGroup);

				_this.$router.push({
					name: 'ReplyMessage',
					params: {
						id: response.data.messageGroup
					}
				});

				_toastr2.default.success('Mensagem enviada com sucesso!');
			});
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this2.responsible = [];
			_this2.schoolmembers = [];
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(416);

var _main2 = _interopRequireDefault(_main);

var _list = __webpack_require__(1015);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'message-received',
	components: {
		FilterInbox: _main2.default,
		ReceivedMessages: _list2.default
	}
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _pagination = __webpack_require__(167);

var _pagination2 = _interopRequireDefault(_pagination);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _pagination3 = __webpack_require__(162);

var _pagination4 = _interopRequireDefault(_pagination3);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'received-messages',
	components: {
		Pagination: _pagination4.default
	},
	data: function data() {
		return {
			payloadFilter: {}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		settings: 'settings',
		loggedUser: 'getLoggedUser',
		receivedMessages: 'getReceivedMessageList',
		inboxReceivedFilter: 'inboxReceivedFilter'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getReceivedMessages']), {
		handleCurrentChange: function handleCurrentChange(page) {

			this.payloadFilter.pagination = {
				quantity: this.settings.Pagination.pageSize,
				page: page - 1
			};

			this.getReceivedMessages(this.payloadFilter);
		}
	}),
	mounted: function mounted() {

		this.payloadFilter = {
			data: this.loggedUser,
			filter: (0, _lodash.cloneDeep)(this.inboxReceivedFilter),
			pagination: {
				quantity: this.settings.Pagination.pageSize,
				page: 0
			}
		};

		this.getReceivedMessages(this.payloadFilter);
	}
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _popover = __webpack_require__(168);

var _popover2 = _interopRequireDefault(_popover);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _popover3 = __webpack_require__(163);

var _popover4 = _interopRequireDefault(_popover3);

var _vuex = __webpack_require__(4);

var _emojiMartVue = __webpack_require__(270);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _new = __webpack_require__(1018);

var _new2 = _interopRequireDefault(_new);

var _main = __webpack_require__(1021);

var _main2 = _interopRequireDefault(_main);

var _i18nEmoji = __webpack_require__(423);

var _i18nEmoji2 = _interopRequireDefault(_i18nEmoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import $ from 'jquery';

exports.default = {
	name: 'message-reply',
	components: {
		Emoji: _emojiMartVue.Emoji,
		Picker: _emojiMartVue.Picker,
		New: _new2.default,
		MessageUsers: _main2.default,
		Popover: _popover4.default
	},
	data: function data() {
		return {
			message: '',
			emojiPickerVisible: false,
			i18n: _i18nEmoji2.default['pt_BR']
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		messageGroup: function messageGroup(state) {
			return state.Inbox.messageGroup;
		},
		messages: function messages(state) {
			return state.Inbox.messageGroup.messages;
		},
		messageGroupUsers: function messageGroupUsers(state) {
			return state.Inbox.messageGroup.users;
		},
		loggedUserId: function loggedUserId(state) {
			return state.Logged.user.id;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMessageGroup', 'sendMessageChat']), {
		insertAtCaret: function insertAtCaret(text) {
			var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'textarea';


			// https://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery#answer-28353499

			var textarea = document.querySelector(element);
			var caretPosition = textarea.selectionStart;
			var front = textarea.value.substring(0, caretPosition);
			var back = textarea.value.substring(textarea.selectionEnd, textarea.value.length);

			this.message = front + text + back;
		},
		addEmoji: function addEmoji(emoji) {
			this.insertAtCaret(emoji.native);
		},
		send: function send() {
			var _this = this;

			this.sendMessageChat({
				from: {
					userId: this.loggedUserId
				},
				message: this.message
			}).then(function () {

				_this.getMessageGroup(_this.$router.history.current.params.id).then(function () {
					_this.scrollToBottom();
				});

				_toastr2.default.success('Mensagem enviada com sucesso!');
				_this.message = '';
			});
		},
		scrollToBottom: function scrollToBottom() {

			/*$('html, body').animate({
   	scrollTop: $(document).height()
   }, 1000);*/

		}
	}),
	created: function created() {

		this.getMessageGroup(this.$router.history.current.params.id);
	}
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(416);

var _main2 = _interopRequireDefault(_main);

var _list = __webpack_require__(1019);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'message-send',
	components: {
		FilterInbox: _main2.default,
		List: _list2.default
	}
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _pagination = __webpack_require__(167);

var _pagination2 = _interopRequireDefault(_pagination);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _pagination3 = __webpack_require__(162);

var _pagination4 = _interopRequireDefault(_pagination3);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'sent-messages',
	components: {
		Pagination: _pagination4.default
	},
	data: function data() {
		return {
			payloadFilter: {}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		settings: 'settings',
		loggedUser: 'getLoggedUser',
		sentMessages: 'getSentMessageList',
		inboxSentFilter: 'inboxSentFilter'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSentMessages']), {
		handleCurrentChange: function handleCurrentChange(page) {

			this.payloadFilter.pagination = {
				quantity: this.settings.Pagination.pageSize,
				page: page - 1
			};

			this.getSentMessages(this.payloadFilter);
		}
	}),
	mounted: function mounted() {

		this.payloadFilter = {
			data: this.loggedUser
		};

		this.payloadFilter.filter = (0, _lodash.cloneDeep)(this.inboxSentFilter);

		this.getSentMessages(this.payloadFilter);
	}
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'message-users',
	props: {
		users: {
			type: Array
		}
	},
	data: function data() {
		return {
			participantsList: [],
			participants: {
				responsibles: {
					title: 'Pais/Responsáveis',
					list: []
				},
				schoolMembers: {
					title: 'Membros da escola',
					list: []
				}
			},
			newParticipant: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser',
		messageGroup: 'messageGroup',
		responsibles: 'getInboxResponsibles',
		schoolMembers: 'getInboxSchoolMembers'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMessageRecipient', 'putMessageRecipients', 'getMessageRecipientIsResponsible', 'setMessageRecipientResponsible', 'setMessageRecipientSchoolMembers', 'getMessageGroup']), {
		retrieveMessageRecipients: function retrieveMessageRecipients() {
			var _this = this;

			return this.getMessageRecipient({
				userId: this.user.id,
				studentId: this.messageGroup.student.studentId
			}).then(function (response) {

				_this.getMessageRecipientIsResponsible(true).then(function (response) {

					_this.setMessageRecipientResponsible(response);
					_this.participants.responsibles.list = response;
				});

				_this.getMessageRecipientIsResponsible(false).then(function (response) {

					_this.setMessageRecipientSchoolMembers(response);
					_this.participants.schoolMembers.list = response;
				});

				return response;
			});
		},
		onSubmit: function onSubmit() {
			var _this2 = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid) {

					return _this2.putMessageRecipients({
						messageGroup: _this2.messageGroup.messageGroup,
						userId: _this2.user.id,
						newUserId: _this2.newParticipant
					}).then(function (response) {

						_this2.getMessageGroup(_this2.$router.history.current.params.id);

						_toastr2.default.success('Participante adicionado com sucesso!');

						return response;
					});
				} else {
					_toastr2.default.warning('Participante não informado');
				}
			});
		}
	}),
	mounted: function mounted() {
		var _this3 = this;

		this.$store.watch(function (state) {
			return state.Inbox.messageGroup;
		}, function () {
			_this3.retrieveMessageRecipients();
		});
	}
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'inbox-sidebar-menu',
	data: function data() {
		return {};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)([])),
	mounted: function mounted() {

		// TODO - get unread messages from `top.`

	}
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	putLogged: function putLogged(context, payload) {
		context.commit('PUT_LOGGED', payload);
	},
	putUserId: function putUserId(context, payload) {

		window.sessionStorage.setItem('Schoolastic/Portal/User', payload);
		context.commit('PUT_USER_ID', payload);
	}
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	getLoggedSchool: function getLoggedSchool(state) {
		return state.school;
	},
	getLoggedUser: function getLoggedUser(state) {
		return state.user;
	}
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _state = __webpack_require__(527);

var _state2 = _interopRequireDefault(_state);

var _getters = __webpack_require__(524);

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__(523);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(526);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'logged',
	state: _state2.default,
	getters: _getters2.default,
	actions: _actions2.default,
	mutations: _mutations2.default
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	PUT_LOGGED: function PUT_LOGGED(state, payload) {
		state = payload;
	},
	PUT_USER_ID: function PUT_USER_ID(state, payload) {
		state.user.id = payload;
	}
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
function hasQueryParams(locationHash) {
	return locationHash.indexOf('?') !== -1;
}

function getUserIdParam(locationHash) {
	return parseInt(locationHash.split('?')[1].replace('userId=', ''));
}

function getUserId(locationHash) {
	return hasQueryParams(locationHash) ? getUserIdParam(locationHash) : 0;
}

var userId = getUserId(window.location.hash);
var userIdSession = parseInt(window.sessionStorage.getItem('Schoolastic/Portal/User'));

if (!userIdSession && userId) {
	window.sessionStorage.setItem('Schoolastic/Portal/User', userId);
} else if (userIdSession && userId && userId !== userIdSession) {
	window.sessionStorage.setItem('Schoolastic/Portal/User', userId);
} else {

	if (!userId && !userIdSession) {

		window.parent.postMessage({
			schoolastic: {
				logoff: true
			}
		}, '*');
	}
}

exports.default = {
	user: {
		id: parseInt(window.sessionStorage.getItem('Schoolastic/Portal/User')),
		language: 'pt_BR',
		name: null,
		email: null,
		profile: null,
		photo: null
	},
	school: {
		id: null,
		name: null
	}
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'medicine-filters',
	components: {
		DatePicker: _datePicker4.default
	},
	data: function data() {
		return {
			datepicker: {
				today: new Date(),
				selected: new Date()
			},
			student: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putFilterSearchMedicine', 'getMedicine', 'getMedicineIsTaken', 'setMedicineHistory', 'setMedicinePending']), {
		filter: function filter() {
			var _this = this;

			return this.getMedicine({
				user: this.user.id,
				filter: {
					date: (0, _moment2.default)(this.datepicker.selected).format('YYYY-MM-DD'),
					studentName: this.student
				}
			}).then(function (response) {

				_this.getMedicineIsTaken(true).then(function (response) {
					_this.setMedicineHistory(response);
				});

				_this.getMedicineIsTaken(false).then(function (response) {
					_this.setMedicinePending(response);
				});

				return response;
			});
		}
	})
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'medicine-history',
	data: function data() {
		return {
			historyList: {
				list: []
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		medicineHistory: 'medicineHistory',
		getLoggedUser: 'getLoggedUser'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['cancelRejectionReasonMedicine', 'getMedicineIsTaken', 'setMedicineHistory', 'setMedicinePending']), {
		cancelRejectionMedicine: function cancelRejectionMedicine(id) {

			this.cancelRejectionReasonMedicine({
				id: id,
				userId: this.getLoggedUser.id
			}).then(function () {
				_eventBus.EventBus.$emit('medicineListChange');
				_toastr2.default.success('Rejeição cancelada com sucesso!');
			});
		}
	}),
	mounted: function mounted() {

		this.historyList = this.medicineHistory;
	}
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'medicine-labels',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		date: 'medicineDate'
	}))
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'medicine-pending',
	data: function data() {
		return {
			pendingList: {
				list: []
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		getLoggedUser: 'getLoggedUser',
		medicineDate: 'medicineDate',
		medicinePending: 'medicinePending'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['saveMedicineTaken', 'setRejectMedicine', 'setRejectionReasonMedicine']), {
		saveMedicineHour: function saveMedicineHour(id, takenHour) {

			if (this.getTimeDiff(takenHour) > 0) {

				this.saveMedicineTaken({
					id: id,
					userId: this.getLoggedUser.id,
					time: takenHour.length === 5 ? takenHour + ':00' : takenHour
				}).then(function () {
					_eventBus.EventBus.$emit('medicineListChange');
					_toastr2.default.success('Medicação ministrada com sucesso!');
				});
			} else if (this.getTimeDiff(takenHour) <= 0) {
				_toastr2.default.warning('O horário da medicação não pode ser uma data futura.');
			} else {
				_toastr2.default.warning('Por favor, verifique o horário da medicação.');
			}
		},
		setReject: function setReject(index) {

			this.setRejectMedicine(index);
			this.pendingList = (0, _lodash.cloneDeep)(this.medicinePending);
		},
		rejectionMedicine: function rejectionMedicine(id, reason, index) {
			var _this = this;

			this.setRejectionReasonMedicine({
				id: id,
				userId: this.getLoggedUser.id,
				rejectionReason: reason
			}).then(function () {

				_this.pendingList.list.splice(index, 1);
				_eventBus.EventBus.$emit('medicineListChange');
				_toastr2.default.success('Medicação rejeitada com sucesso!');
			});
		},
		getTimeDiff: function getTimeDiff(time) {

			if (time) {
				var _medicineDate$split = this.medicineDate.split('-'),
				    _medicineDate$split2 = (0, _slicedToArray3.default)(_medicineDate$split, 3),
				    year = _medicineDate$split2[0],
				    month = _medicineDate$split2[1],
				    date = _medicineDate$split2[2];

				var _time$split = time.split(':'),
				    _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
				    hour = _time$split2[0],
				    minute = _time$split2[1];

				return (0, _moment2.default)().diff((0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: hour,
					minute: minute,
					second: 0
				}));
			}
		},
		getTakenHourInputName: function getTakenHourInputName(index) {
			return 'medicine-takenHour-' + index;
		},
		isBeforeDate: function isBeforeDate() {
			return (0, _moment2.default)().diff(this.medicineDate, 'days') > 0;
		}
	}),
	mounted: function mounted() {

		this.pendingList = this.medicinePending;
	}
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(201);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'class-grade',
	props: {
		label: {
			type: String,
			default: 'Ano de ensino'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		onlySelect: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			classGradeModel: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'classGrade', 'classGradeList'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getClassGrade', 'setSelectedClassGrade']), {
		changed: function changed() {

			this.setSelectedClassGrade(this.classGradeModel);
			_eventBus.EventBus.$emit('classGradeSelected', this.classGradeModel);
		}
	}),
	mounted: function mounted() {

		this.classGradeModel = this.classGrade;

		if (this.selected) {
			this.classGradeModel = this.selected;
		}

		return this.getClassGrade({
			userId: this.getLoggedUser.id
		});
	}
});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	setSelectedClassLevel: function setSelectedClassLevel(context, payload) {
		context.commit('SET_SELECTED_CLASS_LEVEL', payload);
	}
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	classLevel: function classLevel(state) {
		return state.selected;
	}
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	SET_SELECTED_CLASS_LEVEL: function SET_SELECTED_CLASS_LEVEL(state, payload) {
		state.selected = payload;
	}
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	selected: {}
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _vueSelect = __webpack_require__(90);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _store = __webpack_require__(203);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'school-class-list',
	props: {
		context: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'Class'
		},
		multiple: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		group: {
			type: Boolean,
			default: true
		},
		withStudents: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		onlySelect: {
			type: Boolean,
			default: false
		},
		byTheme: {
			type: Boolean,
			default: false
		},
		scope: {
			type: String,
			default: 'global' // global, local
		},
		filter: {
			type: String,
			default: '' // '' all / 1 extracurricular / 0 regular
		}
	},
	components: {
		vSelect: _vueSelect2.default
	},
	data: function data() {
		return {
			schoolClass: [],
			classList: '',
			selected: {},
			list: []
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classes: function classes(state) {
			return state.Class;
		},
		user: function user(state) {
			return state.Logged.user;
		},
		students: function students(state) {
			return state.Student.list;
		}
	}), (0, _vuex.mapGetters)(['getLoggedUser', 'classGrade', 'classGradeList', 'getClass', 'album', 'currentTheme'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setSelectedClass', 'setStudent', 'getClassByUser', 'getStudents']), {
		changed: function changed() {

			if (!this.multiple) {

				if (this.scope === 'local') {
					this.selected = this.classList;
				} else {

					this.setStudent({});
					this.setSelectedClass(this.classList);
				}
			} else {
				this.setSelectedClass(this.schoolClass);
			}

			_eventBus.EventBus.$emit('classChanged', {
				context: this.context,
				data: this.scope === 'local' ? this.selected : this.getClass
			});
		},
		defaultResponse: function defaultResponse(response) {

			if (this.scope === 'local') {
				this.list = response.data.object;
			}
		}
	}),
	mounted: function mounted() {
		var _this = this;

		if (this.scope === 'global') {
			this.list = this.classes.list;
		}

		if (this.context === 'gallery' && this.multiple) {
			this.schoolClass = this.album.schoolClasses;
			this.setSelectedClass(this.schoolClass);
		}

		if (this.context === 'gallery' && !this.multiple) {
			this.classList = this.album.schoolClasses;
		}

		if (!(0, _lodash.isEmpty)(this.getClass)) {
			this.classList = this.getClass;
		}

		_eventBus.EventBus.$on('classGradeSelected', function (payload) {

			_this.getClassByUser({
				userId: _this.getLoggedUser.id,
				scope: _this.scope,
				filter: {
					gradeId: payload.gradeId
				}
			}).then(_this.defaultResponse);
		});

		if (this.byTheme) {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				filter: {
					themeId: this.currentTheme.schoolThemeId
				}
			}).then(this.defaultResponse);

			_eventBus.EventBus.$on('themeSelected', function (theme) {

				_this.getClassByUser({
					userId: _this.getLoggedUser.id,
					scope: _this.scope,
					filter: {
						themeId: theme.schoolThemeId
					}
				}).then(_this.defaultResponse);
			});
		} else {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				extracurricular: this.filter
			}).then(this.defaultResponse);
		}

		this.$store.watch(function (state) {
			return state.Class.list;
		}, function (newClassList) {
			_this.list = newClassList;
		});

		this.$store.watch(function (state) {
			return state.Class.selected;
		}, function (newClass) {

			if (_this.withStudents && newClass !== undefined) {

				_this.getStudents({
					userId: _this.getLoggedUser.id,
					schoolClassId: newClass.schoolClassId,
					scope: _this.scope
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('classGradeSelected');
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('themeSelected');
	}
});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'recipients-group',
	props: {
		label: {
			type: String,
			default: 'Grupo de destinatários'
		},
		required: {
			type: Boolean,
			default: false
		},
		selected: {
			type: String,
			default: ''
		}
	},
	data: function data() {
		return {
			recipientGroup: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setSelectedRecipientGroup', 'setSelectedClassGrade', 'setSelectedClassLevel']), {
		changed: function changed() {

			this.setSelectedClassLevel('');
			this.setSelectedClassGrade('');

			_eventBus.EventBus.$emit('recipientGroupSelected', this.recipientGroup);
		}
	}),
	created: function created() {

		if (this.selected) {
			this.recipientGroup = this.selected;
		}
	}
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(204);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'SchoolTheme',
	props: {
		label: {
			type: String,
			default: 'Disciplina'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			themeModel: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser',
		themes: 'themes'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSchoolThemes', 'setTheme']), {
		changed: function changed() {

			this.setTheme(this.themeModel);
			_eventBus.EventBus.$emit('themeSelected', this.themeModel);
		}
	}),
	mounted: function mounted() {

		this.getSchoolThemes(this.user);
	}
});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _vueSelect = __webpack_require__(90);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(208);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(205);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(206);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(207);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	name: 'students',
	components: {
		vSelect: _vueSelect2.default
	},
	data: function data() {
		return {
			student: [],
			studentList: []
		};
	},
	props: {
		context: {
			type: String,
			default: ''
		},
		className: {
			type: String,
			default: ''
		},
		imglist: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classes: function classes(state) {
			return state.Class;
		},
		students: function students(state) {
			return state.Student.list;
		},
		agenda: function agenda(state) {
			return state.Agenda;
		}
	}), (0, _vuex.mapGetters)({
		currentStudent: 'getStudent',
		user: 'getLoggedUser',
		class: 'getClass',
		album: 'album'
	})),
	filters: {
		agendaStatus: function agendaStatus(value) {

			return {
				NOT_CREATED: 'Não criada',
				CREATED: 'Criada',
				IN_APPROVAL: 'Em aprovação',
				IN_REVISION: 'Em revisão',
				PROCESSING: 'Processando',
				REPROCESS: '',
				APPROVED: 'Publicada',
				SENT: 'Enviada',
				READED: 'Lida'
			}[value];
		}
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getStudents', 'setStudent', 'getAgenda', 'getAgendaStatus', 'getMessages', 'getPresence', 'getMessageRecipient', 'getMessageRecipientIsResponsible', 'setMessageRecipientResponsible', 'setMessageRecipientList', 'setMessageRecipientSchoolMembers', 'setSchoolMembers', 'setResponsibles', 'updateStudentList']), {
		setCurrentStudent: function setCurrentStudent(student) {
			var _this = this;

			_eventBus.EventBus.$emit('setStudent');

			this.setStudent(student);

			if (this.context === 'agenda') {

				this.getAgenda({
					userId: this.user.id,
					studentId: student.studentId,
					date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
				}).then(function () {
					_eventBus.EventBus.$emit('setAgenda');
				});

				this.getMessages({
					userId: this.user.id,
					studentId: student.studentId
				});
			}

			if (this.context === 'newmessage') {

				this.getMessageRecipient({
					userId: this.user.id,
					studentId: student.studentId
				}).then(function () {

					_this.getMessageRecipientIsResponsible(true).then(function (response) {
						_this.setMessageRecipientResponsible(response);
					});

					_this.getMessageRecipientIsResponsible(false).then(function (response) {
						_this.setMessageRecipientSchoolMembers(response);
					});
				});
			}

			if (this.context === 'gallery') {
				this.student = this.album.students;
			}
		},
		getStatusLabelColor: function getStatusLabelColor(status) {

			var redClass = 'bg-red-flamingo bg-font-red-flamingo';
			var yellowClass = 'bg-yellow-lemon bg-font-yellow-lemon';
			var grayClass = 'bg-grey-salsa bg-font-grey-salsa';
			var greenClass = 'bg-green-jungle bg-font-green-jungle';

			return {
				'NOT_CREATED': redClass,
				'CREATED': yellowClass,
				'IN_APPROVAL': yellowClass,
				'IN_REVISION': redClass,
				'PROCESSING': grayClass,
				'REPROCESS': yellowClass,
				'APPROVED': greenClass,
				'SENT': greenClass,
				'READED': greenClass
			}[status];
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('studentAssigned', function (studentsAssigned) {
			_this2.student = studentsAssigned;
		});

		_eventBus.EventBus.$on('classChanged', function (klass) {

			_this2.student = [];

			if (klass && klass.data && klass.data.schoolClassId) {

				_this2.getStudents({
					userId: _this2.user.id,
					schoolClassId: _this2.class.schoolClassId
				}).then(function () {

					if (_this2.context === 'agenda') {

						_this2.getAgendaStatus({
							userId: _this2.user.id,
							schoolClassId: klass.data.schoolClassId,
							date: (0, _moment2.default)(_this2.agenda.date).format('YYYY-MM-DD')
						});
					}
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('classChanged');
	}
};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-name',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		student: 'getStudent'
	}))
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (value) {
	var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';
	var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;


	var digitsRE = /(\d{3})(?=\d)/g;

	value = parseFloat(value);

	if (!isFinite(value) || !value && value !== 0) {
		return '';
	}

	var stringified = Math.abs(value).toFixed(decimals);
	var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	var i = _int.length % 3;
	var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
	var _float = decimals ? stringified.slice(-1 - decimals) : '';
	var sign = value < 0 ? '-' : '';

	return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value, format, isHour) {

	if (isHour) {
		var _value$split = value.split(':'),
		    _value$split2 = (0, _slicedToArray3.default)(_value$split, 3),
		    hours = _value$split2[0],
		    minutes = _value$split2[1],
		    seconds = _value$split2[2];

		var instance = (0, _moment2.default)().hours(hours).minutes(minutes);

		if (seconds) {
			instance.seconds(seconds);
		}

		return instance.format(format);
	}

	return (0, _moment2.default)(value).format(format);
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(209);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value, type) {
  return _store2.default.getters.ENUM[type][value];
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _enum = __webpack_require__(545);

var _enum2 = _interopRequireDefault(_enum);

var _now = __webpack_require__(548);

var _now2 = _interopRequireDefault(_now);

var _date = __webpack_require__(544);

var _date2 = _interopRequireDefault(_date);

var _truncate = __webpack_require__(550);

var _truncate2 = _interopRequireDefault(_truncate);

var _size = __webpack_require__(549);

var _size2 = _interopRequireDefault(_size);

var _capitalize = __webpack_require__(542);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _linebreak = __webpack_require__(547);

var _linebreak2 = _interopRequireDefault(_linebreak);

var _ucwords = __webpack_require__(551);

var _ucwords2 = _interopRequireDefault(_ucwords);

var _currency = __webpack_require__(543);

var _currency2 = _interopRequireDefault(_currency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	storeENUM: _enum2.default,
	now: _now2.default,
	date: _date2.default,
	truncate: _truncate2.default,
	size: _size2.default,
	capitalize: _capitalize2.default,
	linebreak: _linebreak2.default,
	ucwords: _ucwords2.default,
	currency: _currency2.default
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var character = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<br>';
  return value.replace(/\n/g, character);
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (value) {
  return (0, _moment2.default)(value).fromNow();
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.length;
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

exports.default = function (value, n, c) {

	if (n === 0) {
		return value;
	}

	var str = (0, _lodash.trim)(value);
	c = c || '...';

	var ext = /&[^;\s]*;/g;
	if (str.match(ext)) {
		for (var i = 0; i < str.match(ext).length; i++) {
			n = n + (str.match(ext)[i].length - 1);
		}
	}

	if (str.length <= n) {
		return str;
	}

	str = str.substr(0, n + 1);
	var p1 = str.lastIndexOf(' '),
	    p2 = str.lastIndexOf('\n'),
	    p3 = str.lastIndexOf('\t'),
	    p4 = str.lastIndexOf('\s'),
	    // eslint-disable-line
	pos = Math.max(p1, p2, p3, p4);

	if (pos > 0) {
		str = str.substr(0, pos);
	}

	str = (0, _lodash.trim)(str);

	return str + c;
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.replace(/(?:^|\s)\S/g, function (letter) {
    return letter.toUpperCase();
  });
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1120);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(553);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://router.vuejs.org/en/
_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
	routes: _routes2.default
});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(987);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(972);

var _main4 = _interopRequireDefault(_main3);

var _agenda = __webpack_require__(971);

var _agenda2 = _interopRequireDefault(_agenda);

var _inbox = __webpack_require__(976);

var _inbox2 = _interopRequireDefault(_inbox);

var _gallery = __webpack_require__(975);

var _gallery2 = _interopRequireDefault(_gallery);

var _album = __webpack_require__(974);

var _album2 = _interopRequireDefault(_album);

var _leavingMonitor = __webpack_require__(980);

var _leavingMonitor2 = _interopRequireDefault(_leavingMonitor);

var _medicine = __webpack_require__(986);

var _medicine2 = _interopRequireDefault(_medicine);

var _newMessage = __webpack_require__(977);

var _newMessage2 = _interopRequireDefault(_newMessage);

var _replyMessage = __webpack_require__(978);

var _replyMessage2 = _interopRequireDefault(_replyMessage);

var _sendMessage = __webpack_require__(979);

var _sendMessage2 = _interopRequireDefault(_sendMessage);

var _main5 = __webpack_require__(984);

var _main6 = _interopRequireDefault(_main5);

var _main7 = __webpack_require__(983);

var _main8 = _interopRequireDefault(_main7);

var _main9 = __webpack_require__(985);

var _main10 = _interopRequireDefault(_main9);

var _main11 = __webpack_require__(981);

var _main12 = _interopRequireDefault(_main11);

var _main13 = __webpack_require__(982);

var _main14 = _interopRequireDefault(_main13);

var _main15 = __webpack_require__(973);

var _main16 = _interopRequireDefault(_main15);

var _simulator = __webpack_require__(988);

var _simulator2 = _interopRequireDefault(_simulator);

var _values = __webpack_require__(989);

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
	path: '/',
	name: 'SignIn',
	component: _main2.default
}, {
	path: '/dashboard',
	name: 'Dashboard',
	component: _main4.default
}, {
	path: '/agenda',
	name: 'Agenda',
	component: _agenda2.default
}, {
	path: '/inbox',
	name: 'Inbox',
	component: _inbox2.default
}, {
	path: '/inbox/send-message',
	name: 'SendMessage',
	component: _sendMessage2.default
}, {
	path: '/inbox/new-message',
	name: 'NewMessage',
	component: _newMessage2.default
}, {
	path: '/inbox/reply-message/:id',
	name: 'ReplyMessage',
	component: _replyMessage2.default
}, {
	path: '/get-at-school',
	name: 'LeavingMonitor',
	component: _leavingMonitor2.default
}, {
	path: '/medicine',
	name: 'Medicine',
	component: _medicine2.default
}, {
	path: '/meal-menu',
	name: 'MealMenu',
	component: _main6.default
}, {
	path: '/gallery/album',
	name: 'Album',
	component: _album2.default
}, {
	path: '/gallery/album/:id',
	name: 'AlbumID',
	component: _album2.default
}, {
	path: '/meal-menu/clone',
	name: 'MealMenuClone',
	component: _main8.default
}, {
	path: '/meal-menu/monthly',
	name: 'MealMenuMonthly',
	component: _main10.default
}, {
	path: '/gallery',
	name: 'Gallery',
	component: _gallery2.default
}, {
	path: '/lesson-planning',
	name: 'LessonPlanning',
	component: _main12.default
}, {
	path: '/lesson-planning/report',
	name: 'LessonPlanningReport',
	component: _main14.default
}, {
	path: '/evaluation',
	name: 'Evaluation',
	component: _main16.default
}, {
	path: '/simulator',
	name: 'Simulator',
	component: _simulator2.default
}, {
	path: '/simulator/values',
	name: 'SimulatorValues',
	component: _values2.default
}];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	ENUM: function ENUM(state) {
		return state.ENUM;
	},
	settings: function settings(state) {
		return state.Settings;
	}
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	ENUM: {
		Month: {
			JANUARY: 'Janeiro',
			FEBRUARY: 'Fevereiro',
			MARCH: 'Março',
			APRIL: 'Abril',
			MAY: 'Maio',
			JUNE: 'Junho',
			JULY: 'Julho',
			AUGUST: 'Agosto',
			SEPTEMBER: 'Setembro',
			OCTOBER: 'Outubro',
			NOVEMBER: 'Novembro',
			DECEMBER: 'Dezembro'
		},
		QuantityType: {
			GOOD: 'Bom',
			FEW: 'Pouco',
			NOTHING: 'Recusou',
			NA: 'Não informado'
		},
		QuantityMealsType: {
			REPEATED: 'Repetiu',
			GOOD: 'Bom',
			FEW: 'Pouco',
			NOTHING: 'Recusou',
			NA: 'Não informado'
		},
		Presence: {
			PRESENT: 'Presente',
			LATE: 'Atrasado',
			ABSENT: 'Ausente'
		},
		HumorTypes: {
			HAPPY: 'Feliz',
			NEUTRAL: 'Neutro',
			SLEEPY: 'Sonolento',
			SAD: 'Triste',
			TEARFUL: 'Choroso',
			ANGRY: 'Irritado'
		},
		MealTimeType: {
			BREAKFAST: 'Café da manhã',
			MORNING_SNACK: 'Lanche da manhã',
			LUNCH: 'Almoço',
			AFTERNOON_SNACK: 'Lanche da tarde',
			DINNER: 'Janta'
		},
		AgendaEvacuationType: {
			NORMAL: 'Normal',
			DIARRHEA: 'Diarréia',
			HARD: 'Duro',
			SOFT: 'Mole'
		},
		DayShiftType: {
			MATUTINAL: 'Manhã',
			VESPERTINE: 'Tarde',
			NIGHTLY: 'Noite',
			FULLTIME: 'Integral'
		},
		ParticipationType: {
			LITTLE: 'Pouco participativo',
			PARTICIPATED: 'Participativo',
			MUCH: 'Muito participativo'
		},
		SchoolClassLevelType: {
			'Bercario': 'Berçário',
			'Infantil': 'Infantil',
			'Fundamental_1': 'Fundamental 1',
			'Fundamental_2': 'Fundamental 2',
			'EnsinoMedio': 'Ensino Médio'
			// 'Universitario': 'Universitário'
		},
		StatusType: {
			NOT_CREATED: 'Não criado',
			CREATED: 'Criado',
			IN_APPROVAL: 'Em aprovação',
			IN_REVISION: 'Em revisão',
			PROCESSING: 'Processando',
			REPROCESS: '',
			APPROVED: 'Aprovado',
			SENT: 'Enviado',
			READED: 'Lido'
		},
		MessageStatusType: {
			READ: 'Visualizada por todos',
			NOT_READ: 'Não lida',
			PARTIAL_READ: 'Parcialmente visualizada'
		},
		RecipientsGroupType: {
			ALL_SCHOOL: 'Toda a escola',
			PER_LEVEL: 'Por nível de ensino',
			PER_GRADE: 'Por ano de ensino (série)',
			PER_CLASS: 'Por turma'
		},
		viewersGalleryType: {
			ALL: 'Toda a escola',
			SCHOOL_CLASS: 'Por turma',
			STUDENT: 'Por alunos'
		},
		StatusScheduledHomework: {
			ND: 'Não informado',
			COMPLETE: 'Sim',
			INCOMPLETE: 'Parcial',
			UNDELIVERED: 'Não'
		},
		Levels: {
			BERCARIO: 'Berçário',
			INFANTIL: 'Infantil',
			FUNDAMENTAL_1: 'Fundamental 1',
			FUNDAMENTAL_2: 'Fundamental 2',
			ENSINOMEDIO: 'Ensino médio',
			CURSOLIVRE: 'Curso livre'
		},
		Plans: {
			BASIC: 'Pro',
			PREMIUM: 'Business'
		},
		QuestionType: {
			MULTIPLE_INTELLIGENCES: 'Múltiplas Inteligências',
			SOCIOEMOTIONAL: 'Socioemocional',
			LEARNING_APTITUDE: 'Aptidão para aprendizagem'
		}
	},
	Settings: {
		Pagination: {
			layout: 'prev, next',
			pageSize: 25
		}
	}
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mapFilters = mapFilters;
// https://github.com/vuejs/Discussion/issues/405#issuecomment-287371191
function mapFilters(filters) {

	return filters.reduce(function (result, filter) {

		result[filter] = function () {
			var _$options$filters;

			return (_$options$filters = this.$options.filters)[filter].apply(_$options$filters, arguments);
		};

		return result;
	}, {});
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cnpj = __webpack_require__(562);

var _cnpj2 = _interopRequireDefault(_cnpj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = {
	getMessage: function getMessage() {
		// field, args
		return 'Invalid CNPJ';
	},
	validate: function validate(value) {
		// args
		return (0, _cnpj2.default)(value);
	}
};

exports.default = validator;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cpf = __webpack_require__(563);

var _cpf2 = _interopRequireDefault(_cpf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = {
	getMessage: function getMessage() {
		// field, args
		return 'Invalid CPF';
	},
	validate: function validate(value) {
		// args
		return (0, _cpf2.default)(value);
	}
};

exports.default = validator;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var dictionary = {
	'pt_BR': {
		messages: {
			cnpj: function cnpj() {
				return 'CNPJ inválido';
			},
			cpf: function cpf() {
				return 'CPF inválido';
			},
			required: function required(field) {
				return 'O campo ' + field + ' \xE9 obrigat\xF3rio.';
			}
		}
	}
};

exports.default = dictionary;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cpf_cnpj = __webpack_require__(262);

var validate = function validate(value) {
	return _cpf_cnpj.CNPJ.isValid(_cpf_cnpj.CNPJ.strip(value));
};

exports.default = validate;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cpf_cnpj = __webpack_require__(262);

var validate = function validate(value) {
	return _cpf_cnpj.CPF.isValid(_cpf_cnpj.CPF.strip(value));
};

exports.default = validate;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
//
//
//
//
//
//
//
//
//
//
//

function padZero(number) {
  if (number < 10) {
    return '0' + number;
  }
  return number;
}

function getDate() {
  return new Date();
}

function getSeconds() {
  return padZero(getDate().getSeconds());
}

function getMinutes() {
  return padZero(getDate().getMinutes());
}

function getHour() {
  return padZero(getDate().getHours());
}

module.exports = {
  name: 'clock',

  props: ['blink', 'displaySeconds'],

  data: function data() {
    return {
      ticker: null,
      minutes: getMinutes(),
      hours: getHour(),
      seconds: getSeconds()
    };
  },

  created: function created() {
    var _this = this;

    this.ticker = setInterval(function ticker() {
      _this.minutes = getMinutes();
      _this.hours = getHour();
      _this.seconds = getSeconds();
    }, 1000);
  },

  destroyed: function destroyed() {
    clearInterval(this.ticker);
  }

};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(184);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(185);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(186);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(453);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(454);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(455);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(187);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(462);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(192);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(475);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(197);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(198);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(199);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(489);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(490);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(491);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(492);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(493);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(494);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(495);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(496);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _studentBathQuantity = __webpack_require__(497);

var _studentBathQuantity2 = _interopRequireDefault(_studentBathQuantity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _studentBathQuantity2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _studentDiapersQuantity = __webpack_require__(498);

var _studentDiapersQuantity2 = _interopRequireDefault(_studentDiapersQuantity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _studentDiapersQuantity2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(499);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(500);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(501);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(502);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(503);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(504);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(505);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(506);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(507);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _studentPresence = __webpack_require__(508);

var _studentPresence2 = _interopRequireDefault(_studentPresence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _studentPresence2.default; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(509);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(515);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(517);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(516);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(518);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(520);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(519);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(521);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(522);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(528);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(529);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(530);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(531);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(202);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(538);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(541);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _2.default; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

var _vueStrap = __webpack_require__(173);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(182);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(179);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(181);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(180);

var _getters2 = _interopRequireDefault(_getters);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(419);

var _main4 = _interopRequireDefault(_main3);

var _themes = __webpack_require__(415);

var _themes2 = _interopRequireDefault(_themes);

var _create = __webpack_require__(414);

var _create2 = _interopRequireDefault(_create);

var _students = __webpack_require__(89);

var _students2 = _interopRequireDefault(_students);

var _agendaViewers = __webpack_require__(403);

var _agendaViewers2 = _interopRequireDefault(_agendaViewers);

var _agendaEditors = __webpack_require__(402);

var _agendaEditors2 = _interopRequireDefault(_agendaEditors);

var _name = __webpack_require__(420);

var _name2 = _interopRequireDefault(_name);

var _StudentPresence = __webpack_require__(410);

var _StudentPresence2 = _interopRequireDefault(_StudentPresence);

var _humor = __webpack_require__(407);

var _humor2 = _interopRequireDefault(_humor);

var _alimentation = __webpack_require__(404);

var _alimentation2 = _interopRequireDefault(_alimentation);

var _activities = __webpack_require__(401);

var _activities2 = _interopRequireDefault(_activities);

var _main5 = __webpack_require__(406);

var _main6 = _interopRequireDefault(_main5);

var _health = __webpack_require__(405);

var _health2 = _interopRequireDefault(_health);

var _questions = __webpack_require__(411);

var _questions2 = _interopRequireDefault(_questions);

var _main7 = __webpack_require__(408);

var _main8 = _interopRequireDefault(_main7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'agenda',
	components: {
		PageBar: _pageBar2.default,
		ClassName: _main4.default,
		CreateHomeworkButton: _create2.default,
		CreateHomeworkTheme: _themes2.default,
		Students: _students2.default,
		StudentName: _name2.default,
		StudentPresence: _StudentPresence2.default,
		StudentHumor: _humor2.default,
		AgendaViewers: _agendaViewers2.default,
		AgendaEditors: _agendaEditors2.default,
		SchoolClassList: _main2.default,
		tab: _vueStrap.tab,
		tabs: _vueStrap.tabs,
		tabGroup: _vueStrap.tabGroup,
		DatePicker: _datePicker4.default,
		Alimentation: _alimentation2.default,
		Activities: _activities2.default,
		Health: _health2.default,
		Highlight: _main6.default,
		Questions: _questions2.default,
		Others: _main8.default
	},
	data: function data() {
		return {
			homeworkVisible: false,
			datepicker: {
				today: new Date(),
				selected: new Date()
			},
			activeTabs: 0
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		agenda: function agenda(state) {
			return state.Agenda;
		},
		classes: function classes(state) {
			return state.Class;
		},
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		presence: function presence(state) {
			return state.Agenda.agenda.presence;
		}
	}), (0, _vuex.mapGetters)({
		klass: 'getClass',
		user: 'getLoggedUser',
		student: 'getStudent'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getAgenda', 'saveAgenda', 'setBreadcrumb', 'putAgendaDate', 'getStudents', 'getMessages', 'publishAgenda', 'publishAllAgendas', 'setStudent', 'getAgendaStatus', 'setSelectedClass']), {
		getStatus: function getStatus() {

			this.getAgendaStatus({
				userId: this.user.id,
				schoolClassId: this.klass.schoolClassId,
				date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
			});
		},
		setAgendaDate: function setAgendaDate(currentDate) {

			if (currentDate) {
				var _currentDate$split = currentDate.split('/'),
				    _currentDate$split2 = (0, _slicedToArray3.default)(_currentDate$split, 3),
				    date = _currentDate$split2[0],
				    month = _currentDate$split2[1],
				    year = _currentDate$split2[2];

				currentDate = (0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: 0,
					minute: 0,
					second: 0
				});

				this.putAgendaDate((0, _moment2.default)(currentDate).format('YYYY-MM-DD'));

				if (this.student && this.student.studentId) {

					this.getAgenda({
						userId: this.user.id,
						studentId: this.student.studentId,
						date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
					}).then(function () {
						_eventBus.EventBus.$emit('setAgenda');
					});
				}

				if (this.klass && this.klass.schoolClassId) {
					this.getStatus();
				}
			}
		},
		resetStudent: function resetStudent() {

			this.setStudent({});
			this.getStudents();
		},
		save: function save() {
			var _this = this;

			this.saveAgenda().then(function () {
				_this.getStatus();
			});
		},
		publish: function publish() {
			var _this2 = this;

			this.publishAgenda().then(function () {

				_this2.resetStudent();
				_this2.getStatus();
			});
		},
		publishAll: function publishAll() {
			var _this3 = this;

			this.publishAllAgendas().then(function () {

				_this3.resetStudent();
				_this3.getStatus();
			});
		}
	}),
	created: function created() {

		this.setSelectedClass({});

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Preparar Agenda'
		}]);
	},
	mounted: function mounted() {
		var _this4 = this;

		_eventBus.EventBus.$on('toggleHomework', function () {
			_this4.homeworkVisible = !_this4.homeworkVisible;
		});

		_eventBus.EventBus.$on('setStudent', function () {
			_this4.activeTabs = 0;
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('toggleHomework');
		_eventBus.EventBus.$off('setStudent');
	}
};

// import $ from 'jquery';

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'dashboard',
	components: {
		PageBar: _pageBar2.default
	},
	data: function data() {
		return {
			userId: 1
		};
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'putUserId']), {
		updateUserId: function updateUserId() {
			return this.putUserId(parseInt(this.userId));
		}
	}),
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser'])),
	mounted: function mounted() {

		this.setBreadcrumb([{
			text: 'Dashboard'
		}]);

		this.userId = this.getLoggedUser.id;
	}
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _store = __webpack_require__(183);

var _store2 = _interopRequireDefault(_store);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(412);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(413);

var _main4 = _interopRequireDefault(_main3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'EvaluationPage',
	data: function data() {
		return {
			// TODO
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'evaluationQuestions', 'evaluationStudentsQuestions'])),
	components: {
		PageBar: _pageBar2.default,
		EvaluationQuestionsFilter: _main2.default,
		EvaluationQuestions: _main4.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getEvaluationQuestion'])),
	created: function created() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Indicadores'
		}]);
	}
});

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(417);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(418);

var _main4 = _interopRequireDefault(_main3);

var _store = __webpack_require__(121);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'LessonPlanningPage',
	data: function data() {
		return {
			onlyPending: false
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['schoolClassLessonPlan'])),
	components: {
		PageBar: _pageBar2.default,
		PlanningFilter: _main2.default,
		Planning: _main4.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'putSchoolClassLessonPlan'])),
	created: function created() {

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Planejamento de aula'
		}]);
	}
});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _store = __webpack_require__(121);

var _store2 = _interopRequireDefault(_store);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(88);

var _main4 = _interopRequireDefault(_main3);

var _main5 = __webpack_require__(116);

var _main6 = _interopRequireDefault(_main5);

var _main7 = __webpack_require__(117);

var _main8 = _interopRequireDefault(_main7);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'LessonPlanningReportPage',
	data: function data() {
		return {
			year: '',
			month: '',
			week: ''
		};
	},
	components: {
		PageBar: _pageBar2.default,
		SchoolClass: _main2.default,
		Year: _main4.default,
		Month: _main6.default,
		Week: _main8.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'getLoggedUser', 'currentYear', 'currentMonth', 'currentWeek', 'getClass', 'weeks'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'putCurrentMonth', 'putCurrentWeek', 'putWeekList', 'getLessonReport']), {
		updateMonth: function updateMonth() {
			this.month = '';
			this.putCurrentMonth({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		updateWeek: function updateWeek() {
			this.week = '';
			this.putCurrentWeek({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		dateDiff: function dateDiff(input) {
			var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
			var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days';

			return moment(value).diff(input, units);
		},
		generateReport: function generateReport() {

			if (this.currentYear && this.currentMonth && !(0, _lodash.isEmpty)(this.currentWeek) && this.getClass) {

				var queryFilter = {
					startDate: this.currentWeek.startDate,
					endDate: this.currentWeek.endDate,
					schoolClassId: this.getClass.schoolClassId
				};

				return this.getLessonReport({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(function () {});
			}
		}
	}),
	created: function created() {

		this.setBreadcrumb([{
			text: this.$gettext('Relatórios')
		}, {
			text: this.$gettext('Planejamento de aula')
		}]);
	},
	mounted: function mounted() {
		var _this = this;

		this.year = this.currentYear;
		this.month = this.currentMonth;
		this.week = this.currentWeek;
		this.schoolClass = this.schoolClass;

		_eventBus.EventBus.$on('yearChanged', function (payload) {
			_this.year = payload;

			_this.updateMonth();
			_this.updateWeek();
		});

		_eventBus.EventBus.$on('monthChanged', function (payload) {
			_this.month = payload;

			_this.updateWeek();
		});

		_eventBus.EventBus.$on('weekChanged', function (payload) {
			_this.week = payload;
		});

		_eventBus.EventBus.$on('classChanged', function () {
			_this.generateReport();
		});
	},
	beforeDestroy: function beforeDestroy() {
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('yearChanged');
		_eventBus.EventBus.$off('monthChanged');
		_eventBus.EventBus.$off('weekChanged');
	}
});

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _tooltip = __webpack_require__(272);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _tooltip3 = __webpack_require__(264);

var _tooltip4 = _interopRequireDefault(_tooltip3);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(172);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(171);

var _main4 = _interopRequireDefault(_main3);

var _main5 = __webpack_require__(119);

var _main6 = _interopRequireDefault(_main5);

var _main7 = __webpack_require__(28);

var _main8 = _interopRequireDefault(_main7);

var _main9 = __webpack_require__(88);

var _main10 = _interopRequireDefault(_main9);

var _main11 = __webpack_require__(116);

var _main12 = _interopRequireDefault(_main11);

var _main13 = __webpack_require__(117);

var _main14 = _interopRequireDefault(_main13);

var _actions = __webpack_require__(188);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(190);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(189);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(191);

var _state2 = _interopRequireDefault(_state);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	mutations: _mutations2.default,
	getters: _getters2.default,
	name: 'meal-menu',
	data: function data() {
		return {
			recipientGroup: '',
			year: '',
			month: '',
			week: '',
			mealMenuClone: [],
			isEditMode: false
		};
	},
	components: {
		Tooltip: _tooltip4.default,
		PageBar: _pageBar2.default,
		RecipientsGroup: _main2.default,
		ClassLevel: _main4.default,
		ClassGrade: _main6.default,
		SchoolClass: _main8.default,
		Year: _main10.default,
		Month: _main12.default,
		Week: _main14.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['ENUM', 'getLoggedUser', 'currentYear', 'currentMonth', 'currentWeek', 'classLevel', 'classGrade', 'mealMenu', 'getClass', 'weeks'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMealMenu', 'putMealMenu', 'updateMealMenu', 'putCurrentMonth', 'putCurrentWeek', 'putWeekList', 'removeMeal']), {
		editMode: function editMode() {
			var _editMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this.isEditMode = _editMode;
		},
		updateState: function updateState(data) {
			return this.updateMealMenu(data);
		},
		updateMonth: function updateMonth() {

			this.month = '';
			this.putCurrentMonth({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		updateWeek: function updateWeek() {

			this.week = '';
			this.putCurrentWeek({});

			_eventBus.EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		getSchoolMealMenu: function getSchoolMealMenu(startDate, endDate) {
			var _this = this;

			if (this.currentYear && this.currentMonth && !(0, _lodash.isEmpty)(this.currentWeek)) {

				this.isEditMode = false;

				var queryFilter = {
					startDate: startDate || this.currentWeek.startDate,
					endDate: endDate || this.currentWeek.endDate
				};

				if (this.recipientGroup === 'PER_LEVEL') {

					if (this.classLevel) {
						queryFilter.level = this.classLevel;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}
				}

				if (this.recipientGroup === 'PER_GRADE') {

					if (this.classGrade.level) {
						queryFilter.level = this.classGrade.level;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}

					if (this.classGrade.gradeId) {
						queryFilter.gradeId = this.classGrade.gradeId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o ano de ensino (série)'));
					}
				}

				if (this.recipientGroup === 'PER_CLASS') {

					if (this.getClass.schoolClassLevel) {
						queryFilter.level = this.getClass.schoolClassLevel;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o nível de ensino'));
					}

					if (this.getClass.schoolClassGrade && this.getClass.schoolClassGrade.gradeId) {
						queryFilter.gradeId = this.getClass.schoolClassGrade.gradeId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione o ano de ensino (série)'));
					}

					if (this.getClass.schoolClassId) {
						queryFilter.schoolClassId = this.getClass.schoolClassId;
					} else {
						return _toastr2.default.success(this.$gettext('Selecione a turma'));
					}
				}

				return this.getMealMenu({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(function () {

					_this.mealMenuClone = (0, _lodash.cloneDeep)(_this.mealMenu);
				});
			}
		},
		addItem: function addItem(index) {

			this.mealMenuClone[index].times.push({
				beverage: '',
				meal: '',
				time: '',
				type: ''
			});

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeItem: function removeItem(mealIndex, timesIndex) {

			this.mealMenuClone[mealIndex].times.splice(timesIndex, 1);

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));
		},
		removeMealDay: function removeMealDay(itemId) {
			var _this2 = this;

			this.removeMeal({
				userId: this.getLoggedUser.id,
				mealId: itemId
			}).then(function () {

				_toastr2.default.success(_this2.$gettext('Item removido com sucesso!'));
				_this2.getSchoolMealMenu();
			});
		},
		save: function save() {
			var _this3 = this;

			this.updateState((0, _lodash.cloneDeep)(this.mealMenuClone));

			var payload = (0, _lodash.cloneDeep)(this.mealMenu).map(function (value) {

				if (_this3.recipientGroup === 'PER_LEVEL') {
					value.level = _this3.classLevel;
					value.grade = null;
					value.schoolClass = null;
				}

				if (_this3.recipientGroup === 'PER_GRADE') {

					value.level = null;
					value.grade = {
						level: _this3.classGrade.level,
						gradeId: _this3.classGrade.gradeId
					};
					value.schoolClass = null;
				}

				if (_this3.recipientGroup === 'PER_CLASS') {

					value.level = _this3.getClass.schoolClassLevel;
					value.grade = {
						gradeId: _this3.getClass.schoolClassGrade.gradeId
					};
					value.schoolClass = {
						level: _this3.getClass.schoolClassLevel,
						gradeId: _this3.getClass.schoolClassGrade.gradeId,
						schoolClassId: _this3.getClass.schoolClassId
					};
				}

				if (value.id) {
					value.id = value.id;
				}

				value.times = value.times.map(function (time) {

					if (time.time && time.time.length === 5) {
						time.time = time.time + ':00';
					} else {
						time.time = null;
					}

					return time;
				});

				return value;
			});

			this.putMealMenu({
				userId: this.getLoggedUser.id,
				data: payload
			}).then(function () {

				_this3.isEditMode = false;

				_toastr2.default.success(_this3.$gettext('Cardápio salvo com sucesso!'));
			});
		},
		dateDiff: function dateDiff(input) {
			var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
			var units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'days';

			return (0, _moment2.default)(value).diff(input, units);
		},
		getFilter: function getFilter() {

			var params = {
				recipientGroup: this.recipientGroup,
				year: this.year,
				month: this.month,
				startDate: this.currentWeek.startDate,
				endDate: this.currentWeek.endDate
			};

			if (this.recipientGroup === 'PER_LEVEL') {
				params.level = this.classLevel;
			}

			if (this.recipientGroup === 'PER_GRADE') {
				params.grade = this.classGrade;
			}

			if (this.recipientGroup === 'PER_CLASS') {

				var klass = (0, _lodash.cloneDeep)(this.getClass);
				delete klass.teachers;

				params.schoolClass = klass;
			}

			return params;
		},
		duplicate: function duplicate() {

			this.$router.push({
				name: 'MealMenuClone',
				params: this.getFilter()
			});
		},
		showMonthly: function showMonthly() {

			var params = this.getFilter();

			params.startDate = this.weeks[0].startDate;
			params.endDate = this.weeks[this.weeks.length - 1].endDate;

			this.$router.push({
				name: 'MealMenuMonthly',
				params: params
			});
		}
	}),
	created: function created() {

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}]);

		this.updateState([]);
	},
	mounted: function mounted() {
		var _this4 = this;

		this.year = this.currentYear;
		this.month = this.currentMonth;
		this.week = this.currentWeek;

		_eventBus.EventBus.$on('recipientGroupSelected', function (payload) {

			_this4.recipientGroup = payload;

			_this4.updateWeek();
			_this4.updateState({});
		});

		_eventBus.EventBus.$on('classLevelSelected', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('classGradeSelected', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('classChanged', function () {

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('yearChanged', function (payload) {

			_this4.year = payload;

			_this4.updateMonth();
			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('monthChanged', function (payload) {

			_this4.month = payload;

			_this4.updateWeek();
			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});

		_eventBus.EventBus.$on('weekChanged', function (payload) {

			_this4.week = payload;

			_this4.updateState({});
			_this4.getSchoolMealMenu();
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('recipientGroupSelected');
		_eventBus.EventBus.$off('classLevelSelected');
		_eventBus.EventBus.$off('classGradeSelected');
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('yearChanged');
		_eventBus.EventBus.$off('monthChanged');
		_eventBus.EventBus.$off('weekChanged');
	}
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _jQuery = __webpack_require__(958);

var _jQuery2 = _interopRequireDefault(_jQuery);

var _pageBar = __webpack_require__(17);

var _pageBar2 = _interopRequireDefault(_pageBar);

var _main = __webpack_require__(992);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
exports.default = {
	name: 'meal-menu-monthly',
	data: function data() {
		return {
			mealMenuClone: {},
			params: {},
			events: [],
			calendarConfig: {
				defaultDate: new Date()
			}
		};
	},
	components: {
		PageBar: _pageBar2.default,
		FullCalendar: _main2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser',
		mealMenu: 'mealMenu'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setBreadcrumb', 'getMealMenu']), {
		print: function print(target) {

			$.print(target, {
				iframe: true,
				mediaPrint: true,
				title: 'Cardápio'
			});
		}
	}),
	created: function created() {

		this.params = this.$route.params;

		if ((0, _lodash.isEmpty)(this.params)) {

			return this.$router.push({
				name: 'MealMenu'
			});
		}

		this.calendarConfig = {
			defaultDate: this.params.year + '-' + (this.params.month.index < 10 ? '0' : '') + (this.params.month.index + 1) + '-15 00:00:00'
		};

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}, {
			text: this.$gettext('Mensal')
		}]);
	},
	mounted: function mounted() {
		var _this = this;

		this.getMealMenu({
			userId: this.user.id,
			filter: {
				recipientGroup: this.params.recipientGroup,
				startDate: this.params.startDate,
				endDate: this.params.endDate
			}
		}).then(function () {

			_this.mealMenuClone = (0, _lodash.cloneDeep)(_this.mealMenu).map(function (value) {

				value.clonedDate = value.date;
				value.date = null;

				delete value.id;

				return value;
			});

			_this.mealMenuClone.forEach(function (value) {

				if (value.times && value.times.length) {

					value.times.forEach(function (item) {

						_this.events.push({
							title: item.meal + '. ' + item.beverage,
							start: value.clonedDate + 'T' + item.time
						});
					});
				}
			});
		});
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(115)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'sign-in',
	data: function data() {
		return {
			password: ''
		};
	},
	computed: {
		defaultPassword: {
			get: function get() {
				return 'Schoolastic@2018';
			}
		},
		konamiCodePattern: {
			get: function get() {
				return '38,38,40,40,37,39,37,39,66,65';
			}
		}
	},
	methods: {
		signIn: function signIn() {

			if (this.password === this.defaultPassword) {

				this.$router.push({
					name: 'Dashboard'
				});
			}
		},
		konamiCode: function konamiCode() {
			var _this = this;

			var keys = [];

			window.addEventListener('keydown', function (event) {

				keys.push(event.keyCode);

				if (keys.toString().indexOf(_this.konamiCodePattern) >= 0) {

					_this.$router.push({
						name: 'Dashboard'
					});

					keys = [];
				}
			}, true);
		}
	},
	created: function created() {

		this.konamiCode();
	}
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vueRangeSlider = __webpack_require__(421);

var _vueRangeSlider2 = _interopRequireDefault(_vueRangeSlider);

__webpack_require__(274);

var _vuex = __webpack_require__(4);

var _actions = __webpack_require__(193);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(195);

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__(194);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(196);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	actions: _actions2.default,
	getters: _getters2.default,
	state: _state2.default,
	mutations: _mutations2.default,
	name: 'simulator',
	data: function data() {
		return {
			form: {
				schoolName: '',
				contactName: '',
				contactEmailAddress: '',
				mobilePhoneNumber: '',
				studentsQuantity: 500,
				plan: '',
				levels: [],
				voucherNumber: ''
			}
		};
	},

	components: {
		RangeSlider: _vueRangeSlider2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		levelsType: function levelsType(state) {
			return state.ENUM.Levels;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['sendFormLead']), {
		sendForm: function sendForm() {
			var _this = this;

			this.sendFormLead(this.form).then(function () {

				_this.$router.push({
					name: 'SimulatorValues'
				});
			}).catch(function (error) {
				alert(error.response.data.statusDescription);
			});
		}
	})
};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _upload = __webpack_require__(273);

var _upload2 = _interopRequireDefault(_upload);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _upload3 = __webpack_require__(265);

var _upload4 = _interopRequireDefault(_upload3);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'simulator-business',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		lead: 'getLead'
	})),
	data: function data() {
		return {
			form: {
				leadId: '',
				studentsQuantity: 0,
				plan: '',
				companyName: '',
				name: '',
				contactName: '',
				contactEmailAddress: '',
				document: '',
				contactPhoneNumber: '',
				contactDocument: '',
				mobilePhoneNumber: '',
				fullAddress: '',
				zipcode: '',
				city: '',
				neighborhood: '',
				state: '',
				country: '',
				logo: '',
				termsOfServiceAgreement: ''
			}
		};
	},

	components: {
		Upload: _upload4.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['sendForm', 'updateLead']), {
		send: function send() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {
				if (valid) {
					_this.sendForm(_this.form).then(function () {
						alert(_this.$gettext('Formulário enviado com sucesso!'));
					}).catch(function (error) {
						alert(error.response.data.statusDescription);
					});
				}
			});
		},
		update: function update() {

			this.updateLead({
				id: this.lead.id,
				schoolName: this.lead.schoolName,
				contactName: this.lead.contactName,
				contactEmailAddress: this.lead.contactEmailAddress,
				mobilePhoneNumber: this.lead.mobilePhoneNumber,
				studentsQuantity: this.form.studentsQuantity,
				plan: this.form.plan,
				levels: this.lead.levels,
				voucherNumber: this.lead.voucherNumber
			}).then(function () {}).catch(function (error) {
				alert(error.response.data.statusDescription);
			});
		}
	}),
	created: function created() {
		this.form.leadId = this.lead.id;
		this.form.studentsQuantity = this.lead.studentsQuantity;
		this.form.plan = this.lead.plan;
		this.form.name = this.lead.schoolName;
		this.form.contactName = this.lead.contactName;
		this.form.contactEmailAddress = this.lead.contactEmailAddress;
		this.form.mobilePhoneNumber = this.lead.mobilePhoneNumber;
	}
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _lodash = __webpack_require__(9);

var _jquery = __webpack_require__(115);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(275);

__webpack_require__(956);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: {
		events: {
			default: function _default() {
				return [];
			}
		},
		eventSources: {
			default: function _default() {
				return [];
			}
		},
		editable: {
			default: function _default() {
				return true;
			}
		},
		selectable: {
			default: function _default() {
				return true;
			}
		},
		selectHelper: {
			default: function _default() {
				return true;
			}
		},
		header: {
			default: function _default() {

				return {
					left: 'prev,next today',
					center: 'title',
					right: 'month,agendaWeek,agendaDay'
				};
			}
		},
		defaultView: {
			default: function _default() {
				return 'month';
			}
		},
		sync: {
			default: function _default() {
				return false;
			}
		},
		config: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		lang: {
			default: function _default() {
				return 'pt-br';
			}
		}
	},
	computed: {
		defaultConfig: function defaultConfig() {

			var self = this;

			return {
				header: this.header,
				defaultView: this.defaultView,
				editable: this.editable,
				selectable: this.selectable,
				selectHelper: this.selectHelper,
				aspectRatio: 2,
				timeFormat: 'HH:mm',
				events: this.events,
				eventSources: this.eventSources,
				eventRender: function eventRender() {

					if (this.sync) {
						self.events = (0, _jquery2.default)(this.$el).fullCalendar('clientEvents');
					}

					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					self.$emit.apply(self, ['event-render'].concat(args));
				},
				eventDestroy: function eventDestroy() {

					if (this.sync) {
						self.events = (0, _jquery2.default)(this.$el).fullCalendar('clientEvents');
					}
				},
				eventClick: function eventClick() {
					for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
						args[_key2] = arguments[_key2];
					}

					self.$emit.apply(self, ['event-selected'].concat(args));
				},
				eventDrop: function eventDrop() {
					for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
						args[_key3] = arguments[_key3];
					}

					self.$emit.apply(self, ['event-drop'].concat(args));
				},
				eventResize: function eventResize() {
					for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
						args[_key4] = arguments[_key4];
					}

					self.$emit.apply(self, ['event-resize'].concat(args));
				},
				dayClick: function dayClick() {
					for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
						args[_key5] = arguments[_key5];
					}

					self.$emit.apply(self, ['day-click'].concat(args));
				},
				select: function select(start, end, jsEvent, view, resource) {

					self.$emit('event-created', {
						start: start,
						end: end,
						allDay: !start.hasTime() && !end.hasTime(),
						view: view,
						resource: resource
					});
				}
			};
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.$on('remove-event', function (event) {

			if (event && event.hasOwnProperty('id')) {
				(0, _jquery2.default)(_this.$el).fullCalendar('removeEvents', event.id);
			} else {
				(0, _jquery2.default)(_this.$el).fullCalendar('removeEvents', event);
			}
		});

		this.$on('rerender-events', function () {
			(0, _jquery2.default)(_this.$el).fullCalendar('rerenderEvents');
		});

		this.$on('refetch-events', function () {
			(0, _jquery2.default)(_this.$el).fullCalendar('refetchEvents');
		});

		this.$on('render-event', function (event) {
			(0, _jquery2.default)(_this.$el).fullCalendar('renderEvent', event);
		});

		this.$on('reload-events', function () {

			(0, _jquery2.default)(_this.$el).fullCalendar('removeEvents');
			(0, _jquery2.default)(_this.$el).fullCalendar('addEventSource', _this.events);
		});

		this.$on('rebuild-sources', function () {

			(0, _jquery2.default)(_this.$el).fullCalendar('removeEvents');

			_this.eventSources.map(function (event) {
				(0, _jquery2.default)(_this.$el).fullCalendar('addEventSource', event);
			});
		});

		(0, _jquery2.default)(this.$el).fullCalendar((0, _lodash.defaultsDeep)(this.config, this.defaultConfig));
	},

	methods: {
		fireMethod: function fireMethod() {
			var _$;

			return (_$ = (0, _jquery2.default)(this.$el)).fullCalendar.apply(_$, arguments);
		}
	},
	watch: {
		events: {
			deep: true,
			handler: function handler() {

				(0, _jquery2.default)(this.$el).fullCalendar('removeEvents');
				(0, _jquery2.default)(this.$el).fullCalendar('addEventSource', this.events);
			}
		},
		eventSources: {
			deep: true,
			handler: function handler() {
				this.$emit('rebuild-sources');
			}
		}
	},
	beforeDestroy: function beforeDestroy() {

		this.$off('remove-event');
		this.$off('rerender-events');
		this.$off('refetch-events');
		this.$off('render-event');
		this.$off('reload-events');
		this.$off('rebuild-sourcs');
	}
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(200);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'year',
	data: function data() {
		return {
			year: ''
		};
	},
	props: {
		name: {
			type: String,
			default: 'year'
		},
		label: {
			type: String,
			default: 'Ano'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		onlyFuture: {
			type: Boolean,
			default: false
		},
		withNextYear: {
			type: Boolean,
			default: false
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentYear', 'years'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putCurrentYear', 'putYearsList', 'pushYear']), {
		changed: function changed() {

			this.putCurrentYear(this.year);
			_eventBus.EventBus.$emit(this.name + 'Changed', this.year);
		},
		makeFullList: function makeFullList(baseYear, currentYear) {

			var list = [];

			for (var year = currentYear; year >= baseYear; year--) {

				list.push({
					id: year,
					value: year.toString()
				});
			}

			return list;
		}
	}),
	mounted: function mounted() {

		this.year = this.currentYear;

		var list = this.makeFullList(2014, (0, _moment2.default)().get('Y'));
		var nextYear = (0, _moment2.default)().add(1, 'y').get('Y');

		if (this.withNextYear) {

			list.unshift({
				id: nextYear,
				value: nextYear.toString()
			});

			this.putYearsList(list);
		}

		if (this.onlyFuture) {

			this.putYearsList([{
				id: this.currentYear,
				value: this.currentYear.toString()
			}, {
				id: nextYear,
				value: nextYear.toString()
			}]);
		}
	}
});

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'homework-scheduled',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		statusScheduledHomework: function statusScheduledHomework(state) {
			return state.ENUM.StatusScheduledHomework;
		}
	}), (0, _vuex.mapGetters)({
		scheduledHomework: 'getAgendaScheduledHomework'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaScheduledHomework']))
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _activities = __webpack_require__(993);

var _activities2 = _interopRequireDefault(_activities);

var _homeworkScheduled = __webpack_require__(994);

var _homeworkScheduled2 = _interopRequireDefault(_homeworkScheduled);

var _main = __webpack_require__(409);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-activities',
	components: {
		Activities: _activities2.default,
		HomeworkScheduled: _homeworkScheduled2.default,
		Restocking: _main2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		scheduledHomework: 'getAgendaScheduledHomework'
	}))
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(47);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _timeSelect = __webpack_require__(921);

var _timeSelect2 = _interopRequireDefault(_timeSelect);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _timeSelect3 = __webpack_require__(915);

var _timeSelect4 = _interopRequireDefault(_timeSelect3);

var _vuex = __webpack_require__(4);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _lodash = __webpack_require__(9);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-meals',
	components: {
		TimeSelect: _timeSelect4.default
	},
	data: function data() {
		return {
			additionalMeal: {
				meal: '',
				portion: '',
				time: ''
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		meals: function meals(state) {
			return state.Agenda.agenda.meals;
		},
		quantityTypes: function quantityTypes(state) {
			return state.ENUM.QuantityMealsType;
		}
	}), (0, _vuex.mapGetters)({
		additionals: 'getAdditionalMeals',
		date: 'getAgendaDate'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaMealPortion', 'putAgendaBeveragePortion', 'postAgendaAdditionalMealsItem', 'putAgendaAdditionalMealsItem', 'deleteAdditionalMealsItem', 'putCompletionStatus']), {
		completionStatus: function completionStatus(model) {

			var status = false;

			if ((0, _lodash.isEmpty)(model.time) && (0, _lodash.isEmpty)(model.meal) && (0, _lodash.isEmpty)(model.portion)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'additionalMeal',
				value: status
			});
		},
		addAdditionalMealsItem: function addAdditionalMealsItem() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid && _this.getTimeDiff(_this.additionalMeal.time) > 0) {

					if (_this.additionalMeal.index !== undefined && _this.additionalMeal.index >= 0) {
						_this.putAgendaAdditionalMealsItem((0, _lodash.cloneDeep)(_this.additionalMeal));
					} else {
						_this.postAgendaAdditionalMealsItem((0, _lodash.cloneDeep)(_this.additionalMeal));
					}

					_this.additionalMeal = {
						meal: '',
						portion: '',
						time: ''
					};

					_this.completionStatus(true);
				} else if (_this.getTimeDiff(_this.additionalMeal.time) <= 0) {
					_toastr2.default.warning('O horário da alimentação adicional não pode ser uma data futura.');
				} else {
					_toastr2.default.warning('Por favor informar todos os campos relacionados a alimetação adicionais');
				}
			});
		},
		editAdditionalMealsItem: function editAdditionalMealsItem(index) {

			this.additionalMeal = (0, _lodash.cloneDeep)(this.additionals[index]);
			this.additionalMeal.index = index;
		},
		getTimeDiff: function getTimeDiff(time) {

			if (time) {
				var _date$split = this.date.split('-'),
				    _date$split2 = (0, _slicedToArray3.default)(_date$split, 3),
				    year = _date$split2[0],
				    month = _date$split2[1],
				    date = _date$split2[2];

				var _time$split = time.split(':'),
				    _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
				    hour = _time$split2[0],
				    minute = _time$split2[1];

				return (0, _moment2.default)().diff((0, _moment2.default)().set({
					year: year,
					month: month - 1,
					date: date,
					hour: hour,
					minute: minute,
					second: 0
				}));
			}
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {

			_this2.additionalMeal = {
				meal: '',
				portion: '',
				time: ''
			};
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _scheduledMedicine = __webpack_require__(1003);

var _scheduledMedicine2 = _interopRequireDefault(_scheduledMedicine);

var _main = __webpack_require__(1002);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(1000);

var _main4 = _interopRequireDefault(_main3);

var _urineQuantity = __webpack_require__(1005);

var _urineQuantity2 = _interopRequireDefault(_urineQuantity);

var _main5 = __webpack_require__(1004);

var _main6 = _interopRequireDefault(_main5);

var _StudentBathQuantity = __webpack_require__(998);

var _StudentBathQuantity2 = _interopRequireDefault(_StudentBathQuantity);

var _StudentDiapersQuantity = __webpack_require__(999);

var _StudentDiapersQuantity2 = _interopRequireDefault(_StudentDiapersQuantity);

var _main7 = __webpack_require__(1001);

var _main8 = _interopRequireDefault(_main7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'health',
	components: {
		ScheduledMedicine: _scheduledMedicine2.default,
		StudentNap: _main2.default,
		StudentEvacueted: _main4.default,
		StudentUrineQuantity: _urineQuantity2.default,
		StudentToothBrushing: _main6.default,
		StudentBathQuantity: _StudentBathQuantity2.default,
		StudentDiapersQuantity: _StudentDiapersQuantity2.default,
		StudentEventualMedicine: _main8.default
	}
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'student-tooth-brushing',
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classLevel: function classLevel(state) {
			return state.Class.selected.schoolClassLevel;
		},
		brush: function brush(state) {
			return state.Agenda.agenda.brush;
		}
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putAgendaBrush']))
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _main = __webpack_require__(409);

var _main2 = _interopRequireDefault(_main);

var _observation = __webpack_require__(995);

var _observation2 = _interopRequireDefault(_observation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'agenda-others',
	components: {
		Restocking: _main2.default,
		Observation: _observation2.default
	},
	data: function data() {
		return {};
	}
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'restocking',
	components: {
		DatePicker: _datePicker4.default
	},
	data: function data() {
		return {
			model: {
				product: '',
				quantity: '',
				dueDate: ''
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		klass: 'getClass',
		replacementItens: 'getReplacementItens'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putReplacementItem', 'pushReplacementItem', 'removeReplacementItem']), {
		clearModel: function clearModel() {

			this.model = {
				product: '',
				quantity: '',
				dueDate: ''
			};
		},
		addReplacementItem: function addReplacementItem() {
			var _this = this;

			this.$validator.validateAll().then(function (valid) {

				if (valid) {

					if (_this.model.index !== undefined && _this.model.index >= 0) {

						_this.putReplacementItem({
							index: _this.model.index,
							value: _this.model
						});
					} else {
						_this.pushReplacementItem(_this.model);
					}

					_this.model = {
						product: '',
						quantity: '',
						dueDate: ''
					};
				} else {
					_toastr2.default.warning('Por favor informar todos os campos relacionados aos itens de reposição');
				}
			});
		},
		editReplacementItem: function editReplacementItem(index) {

			this.model = (0, _lodash.cloneDeep)(this.replacementItens[index]);
			this.model.index = index;
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('setStudent', function () {
			_this2.clearModel();
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('setStudent');
	}
};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _StudentQuestion = __webpack_require__(1008);

var _StudentQuestion2 = _interopRequireDefault(_StudentQuestion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'questions',
	components: {
		StudentQuestion: _StudentQuestion2.default
	}
};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'EvaluationQuestionSave',
	props: {
		question: {
			type: Number,
			default: undefined
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'getClass', 'evaluationQuestionsList'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['saveEvaluationQuestion']), {
		saveQuestion: function saveQuestion() {
			var _this = this;

			this.saveEvaluationQuestion({
				userId: this.getLoggedUser.id,
				schoolClassId: this.getClass.schoolClassId,
				data: this.evaluationQuestionsList
			}).then(function (response) {

				_toastr2.default.success(_this.$gettext('Questionário salvo com sucesso!'));
				_eventBus.EventBus.$emit('evaluationQuestionSaved', response.data);
			});
		}
	})
};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'EvaluationQuestionFilter',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getClass', 'getLoggedUser']), {
		formIsValid: function formIsValid() {
			return this.getClass && this.getClass.schoolClassId;
		}
	}),
	components: {
		SchoolClass: _main2.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getEvaluationQuestion']), {
		onSubmit: function onSubmit() {

			if (this.formIsValid) {

				this.getEvaluationQuestion({
					userId: this.getLoggedUser.id,
					schoolClassId: this.getClass.schoolClassId
				}).then(function (response) {
					return _eventBus.EventBus.$emit('evaluationQuestionFetched', response.data);
				});
			}
		}
	})
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _main = __webpack_require__(1009);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'EvaluationQuestions',
	data: function data() {
		return {
			model: {
				questions: [],
				students: []
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['evaluationQuestions', 'evaluationStudentsQuestions'])),
	components: {
		EvaluationQuestionSave: _main2.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setEvaluationQuestionAnswer', 'clearEvaluationQuestion']), {
		onChange: function onChange(student, question, answer) {

			this.setEvaluationQuestionAnswer({
				student: student,
				question: question,
				answer: answer
			});
		}
	}),
	created: function created() {
		var _this = this;

		_eventBus.EventBus.$on('evaluationQuestionFetched', function () {

			_this.model.questions = (0, _lodash.cloneDeep)(_this.evaluationQuestions);
			_this.model.students = (0, _lodash.cloneDeep)(_this.evaluationStudentsQuestions);
		});

		_eventBus.EventBus.$on('classChanged', function () {

			_this.clearEvaluationQuestion();

			_this.model.questions = [];
			_this.model.students = [];
		});
	}
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'copy-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		index: {
			type: Number,
			default: 'false'
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getHomeworkList'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['copyHomeworkbyClass']), {
		copyHomework: function copyHomework(index) {

			this.copyHomeworkbyClass({
				index: index,
				themes: this.getHomeworkList
			}).then(function () {
				_eventBus.EventBus.$emit('setAgenda');
			});
		}
	})
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _eventBus = __webpack_require__(5);

exports.default = {
	name: 'create-homework-button',
	methods: {
		toggleHomework: function toggleHomework() {

			_eventBus.EventBus.$emit('toggleHomework');
		}
	}
};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'publish-all-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getClass', 'getHomeworkList', 'getAgendaDate', 'getLoggedUser', 'getHomeworkId'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['saveHomeworkBySchoolClass', 'publishAllHomeworkBySchoolClass', 'setHomeworkList']), {
		publishAllHomeworks: function publishAllHomeworks() {
			var _this = this;

			this.publishAllHomeworkBySchoolClass({
				id: this.getHomeworkId,
				themes: this.getHomeworkList,
				userId: this.getLoggedUser.id
			}).then(function (response) {

				_eventBus.EventBus.$emit('homeworkPublishedAll');

				_this.setHomeworkList(response.data);

				_toastr2.default.success(_this.$gettext('Lições de casa publicadas com sucesso!'));
			});
		}
	})
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(212);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'publish-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		themeId: ''
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getClass', 'getHomeworkList', 'getAgendaDate', 'getLoggedUser', 'getHomeworkId'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setHomeworkList', 'saveHomeworkBySchoolClass', 'publishHomeworkBySchoolClass']), {
		publishHomeworks: function publishHomeworks() {
			var _this = this;

			this.saveHomeworkBySchoolClass({
				schoolClass: {
					schoolClassId: this.getClass.schoolClassId
				},
				date: ((0, _typeof3.default)(this.getAgendaDate) === 'object' ? this.getAgendaDate.toISOString() : this.getAgendaDate).split('T')[0],
				themes: this.getHomeworkList,
				user: this.getLoggedUser
			}).then(function (response) {

				_this.publishHomeworkBySchoolClass({
					homeworkId: _this.getHomeworkId,
					themeId: _this.themeId,
					user: _this.getLoggedUser.id
				}).then(function (response) {

					_eventBus.EventBus.$emit('homeworkPublished');

					// this.setHomeworkList(response.data);

					_toastr2.default.success(_this.$gettext('Lição de casa publicada com sucesso!'));
				});
			});
		}
	})
};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(212);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'save-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		context: {
			type: String,
			default: ''
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getClass', 'getHomeworkList', 'getAgendaDate'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['saveHomeworkBySchoolClass', 'getLoggedUser', 'setHomeworkList', 'putAgendaExclusiveHomework']), {
		saveHomeworks: function saveHomeworks() {
			var _this = this;

			this.saveHomeworkBySchoolClass({
				schoolClass: {
					schoolClassId: this.getClass.schoolClassId
				},
				date: ((0, _typeof3.default)(this.getAgendaDate) === 'object' ? this.getAgendaDate.toISOString() : this.getAgendaDate).split('T')[0],
				themes: this.getHomeworkList,
				user: this.getLoggedUser
			}).then(function () {

				_eventBus.EventBus.$emit('homeworkSaved');

				_toastr2.default.success(_this.$gettext('Lição de casa salva com sucesso!'));
			});
		},
		addExclusiveHomeworks: function addExclusiveHomeworks() {
			var _this2 = this;

			this.putAgendaExclusiveHomework({
				date: ((0, _typeof3.default)(this.getAgendaDate) === 'object' ? this.getAgendaDate.toISOString() : this.getAgendaDate).split('T')[0],
				themes: this.getHomeworkList,
				user: this.getLoggedUser
			}).then(function () {
				_toastr2.default.success(_this2.$gettext('Lição de casa salva com sucesso!'));
			});
		}
	})
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

var _vueStrap = __webpack_require__(173);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _textareaCounter = __webpack_require__(170);

var _textareaCounter2 = _interopRequireDefault(_textareaCounter);

var _save = __webpack_require__(1013);

var _save2 = _interopRequireDefault(_save);

var _copy = __webpack_require__(1010);

var _copy2 = _interopRequireDefault(_copy);

var _publish = __webpack_require__(1012);

var _publish2 = _interopRequireDefault(_publish);

var _publishAll = __webpack_require__(1011);

var _publishAll2 = _interopRequireDefault(_publishAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'homework-themes',
	components: {
		panel: _vueStrap.panel,
		accordion: _vueStrap.accordion,
		DatePicker: _datePicker4.default,
		HomeworkSave: _save2.default,
		HomeworkPublish: _publish2.default,
		HomeworkPublishAll: _publishAll2.default,
		HomeworkCopy: _copy2.default,
		TextareaCounter: _textareaCounter2.default
	},
	data: function data() {
		return {
			datepicker: {
				today: new Date()
			},
			themes: [],
			exclusiveThemes: []
		};
	},
	props: {
		context: {
			type: String,
			default: ''
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'getAgendaDate', 'getHomeworkList', 'getClass', 'getHomeworkId', 'getAgendaExclusiveHomework'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getHomeworkBySchoolClass', 'setHomeworkList', 'putHomeworkItemByKey', 'saveHomeworkBySchoolClass', 'putExclusiveHomeworkItemByKey']), {
		putHomeworkItem: function putHomeworkItem(index, theme) {
			console.log(index);
			if (this.context === 'exclusiveHomework') {
				this.putExclusiveHomeworkItemByKey({
					index: index,
					theme: theme
				});
			} else {
				this.putHomeworkItemByKey({
					index: index,
					theme: theme
				});
			}
		},
		hasHomework: function hasHomework() {
			var schoolClassLevel = this.getClass.schoolClassLevel;


			return schoolClassLevel === 'Infantil' || schoolClassLevel === 'Fundamental_1' || schoolClassLevel === 'Fundamental_2' || schoolClassLevel === 'EnsinoMedio';
		},
		getHomework: function getHomework(payload) {
			var _this = this;

			this.getHomeworkBySchoolClass(payload).then(function (data) {

				if (data && data.themes) {

					data.themes.forEach(function (value, key) {

						if (!value.title) {
							data.themes[key].title = "";
						}

						if (!value.homework) {
							data.themes[key].homework = "";
						}

						if (!value.dueDate) {
							data.themes[key].dueDate = null;
						}
					});

					_this.setHomeworkList(data);
					_this.themes = (0, _lodash.cloneDeep)(_this.getHomeworkList);

					_this.themes.map(function (theme) {

						theme.dueDate = (0, _moment2.default)(theme.dueDate, 'YYYY-MM-DD').toISOString();

						return theme;
					});
				}
			});
		}
	}),
	directives: {
		altmodel: {
			bind: function bind(el, binding, vnode) {
				el.oninput = function () {
					return vnode.context[binding.expression] = el.value;
				};
			}
		}
	},
	created: function created() {
		var _this2 = this;

		_eventBus.EventBus.$on('homeworkSaved', function () {
			_this2.themes = (0, _lodash.cloneDeep)(_this2.getHomeworkList);
		});

		_eventBus.EventBus.$on('homeworkPublished', function () {
			_this2.themes = (0, _lodash.cloneDeep)(_this2.getHomeworkList);
		});

		_eventBus.EventBus.$on('setAgenda', function () {
			_this2.exclusiveThemes = (0, _lodash.cloneDeep)(_this2.getAgendaExclusiveHomework);
		});
	},
	mounted: function mounted() {
		var _this3 = this;

		this.$store.watch(function (state) {
			return state.Class.selected;
		}, function (newClass) {

			if (newClass && newClass.schoolClassId && _this3.hasHomework()) {

				_this3.getHomework({
					userId: _this3.getLoggedUser.id,
					schoolClassId: newClass.schoolClassId,
					agendaDate: (0, _moment2.default)(_this3.getAgendaDate).format('YYYY-MM-DD')
				});
			}
		});

		this.$store.watch(function (state) {
			return state.Agenda.date;
		}, function (newDate) {

			if (newDate && _this3.getClass.schoolClassId && _this3.hasHomework()) {

				_this3.getHomework({
					userId: _this3.getLoggedUser.id,
					schoolClassId: _this3.getClass.schoolClassId,
					agendaDate: (0, _moment2.default)(_this3.getAgendaDate).format('YYYY-MM-DD')
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('homeworkSaved');
		_eventBus.EventBus.$off('homeworkPublished');
		_eventBus.EventBus.$off('setAgenda');
	}
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _map = __webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'filter-inbox',
	components: {
		DatePicker: _datePicker4.default
	},
	props: {
		context: {
			type: String
		}
	},
	data: function data() {
		return {
			filter: {}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'inboxReceivedFilter', 'inboxSentFilter', 'settings'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setReceivedInboxFilter', 'setSentInboxFilter', 'getReceivedMessages', 'getSentMessages']), (0, _map.mapFilters)(['capitalize']), {
		filterMessage: function filterMessage() {

			var payload = {
				filter: (0, _lodash.cloneDeep)(this.filter),
				data: this.getLoggedUser
			};

			payload.filter.quantity = this.settings.Pagination.pageSize;
			payload.filter.page = 0;

			if (payload.filter.startDate) {
				payload.filter.startDate = (0, _moment2.default)(payload.filter.startDate).format('YYYY-MM-DD');
			}
			if (payload.filter.endDate) {
				payload.filter.endDate = (0, _moment2.default)(payload.filter.endDate).format('YYYY-MM-DD');
			}

			if (payload.filter.onlyNotReadedMessages !== '' && typeof payload.filter.onlyNotReadedMessages === 'number') {
				payload.filter.onlyNotReadedMessages = parseInt(payload.filter.onlyNotReadedMessages);
			}

			this['set' + this.capitalize(this.context) + 'InboxFilter'](payload.filter);
			this['get' + this.capitalize(this.context) + 'Messages'](payload);
		},
		clearFilter: function clearFilter() {

			this.filter = {};

			this['set' + this.capitalize(this.context) + 'InboxFilter']({
				studentName: '',
				memberName: '',
				onlyNotReadedMessages: null,
				startDate: null,
				endDate: null
			});

			this.filterMessage();
		}
	}),
	created: function created() {

		this.filter = (0, _lodash.cloneDeep)(this['inbox' + this.capitalize(this.context) + 'Filter']);

		if (this.filter.startDate) {
			this.filter.startDate = new Date(this.filter.startDate + ' 00:00:00');
		}

		if (this.filter.endDate) {
			this.filter.endDate = new Date(this.filter.endDate + ' 00:00:00');
		}
	}
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'LessonPlanningCopy',
	data: function data() {
		return {
			model: {},
			klass: {}
		};
	},
	props: {
		index: {
			type: Number,
			default: null
		}
	},
	components: {
		SchoolClassList: _main2.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'currentYear', 'currentTheme', 'getClass', 'schoolClassLessonPlan'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['updateSchoolClassLessonPlan', 'putSchoolClassLessonPlan', 'copySchoolClassLessonPlan']), {
		toggleCopy: function toggleCopy(index, status) {

			_eventBus.EventBus.$emit('planning:toggle-copy', index, status);
		},
		onSubmitCopy: function onSubmitCopy() {
			var _this = this;

			this.copySchoolClassLessonPlan({
				data: {
					schoolClassId: this.getClass.schoolClassId,
					newSchoolClassId: this.klass.schoolClassId
				},
				themeId: this.currentTheme.schoolThemeId,
				year: this.currentYear,
				userId: this.getLoggedUser.id
			}).then(function () {

				_this.toggleCopy(_this.index, false);

				_toastr2.default.success(_this.$gettext('Planejamento de aula duplicado com sucesso!'));

				_eventBus.EventBus.$emit('school-class-lesson-plan:copied');
			});
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('classChanged', function (klass) {

			_this2.klass = klass.data;

			if (klass.context !== 'LessonPlanningCopy') {
				_this2.toggleCopy(_this2.index, false);
			}
		});
	}
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _main = __webpack_require__(88);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(1027);

var _main4 = _interopRequireDefault(_main3);

var _main5 = __webpack_require__(28);

var _main6 = _interopRequireDefault(_main5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'LessonPlanningFilter',
	data: function data() {
		return {
			model: {
				onlyPending: false,
				currentClass: {},
				currentTheme: {}
			}
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentYear', 'getLoggedUser']), {
		formIsValid: function formIsValid() {

			return this.currentYear && this.model.currentTheme && this.model.currentTheme.schoolThemeId && this.model.currentClass && this.model.currentClass.schoolClassId;
		}
	}),
	components: {
		Year: _main2.default,
		SchoolTheme: _main4.default,
		SchoolClassList: _main6.default
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSchoolClassLessonPlan', 'clearSchoolClassLessonPlan']), {
		onSubmit: function onSubmit() {

			if (this.formIsValid) {

				this.getSchoolClassLessonPlan({
					onlyPending: this.model.onlyPending,
					year: this.currentYear,
					theme: this.model.currentTheme.schoolThemeId,
					class: this.model.currentClass.schoolClassId,
					userId: this.getLoggedUser.id
				}).then(function (response) {
					return _eventBus.EventBus.$emit('schoolClassLessonPlanFetched', response);
				});
			}
		}
	}),
	created: function created() {
		var _this = this;

		_eventBus.EventBus.$on('themeSelected', function (theme) {

			_this.model.currentTheme = theme;
			_this.clearSchoolClassLessonPlan();
		});

		_eventBus.EventBus.$on('classChanged', function (klass) {

			_this.model.currentClass = klass.data;

			if (klass.context !== 'LessonPlanningCopy') {
				_this.clearSchoolClassLessonPlan();
			}
		});

		_eventBus.EventBus.$on('school-class-lesson-plan:copied', function () {
			_this.onSubmit();
		});
	}
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(211);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _datePicker = __webpack_require__(53);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _base = __webpack_require__(16);

var _base2 = _interopRequireDefault(_base);

var _datePicker3 = __webpack_require__(51);

var _datePicker4 = _interopRequireDefault(_datePicker3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _toastr = __webpack_require__(11);

var _toastr2 = _interopRequireDefault(_toastr);

var _main = __webpack_require__(28);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(1022);

var _main4 = _interopRequireDefault(_main3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'LessonPlanning',
	data: function data() {
		return {
			model: {},
			klass: {}
		};
	},
	components: {
		DatePicker: _datePicker4.default,
		SchoolClassList: _main2.default,
		LessonPlanningCopy: _main4.default
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'currentYear', 'currentTheme', 'getClass', 'schoolClassLessonPlan'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['updateSchoolClassLessonPlan', 'putSchoolClassLessonPlan', 'copySchoolClassLessonPlan']), {
		setPlanDate: function setPlanDate(date, lessonPlanIndex, plan, planIndex) {

			var payload = {
				index: planIndex,
				parentIndex: lessonPlanIndex,
				value: (0, _lodash.cloneDeep)(plan)
			};

			payload.value.date = payload.value.date ? (0, _moment2.default)(date).format('YYYY-MM-DD') : null;

			this.updateSchoolClassLessonPlan(payload);
		},
		savePlanning: function savePlanning(lessonPlanIndex) {
			var _this = this;

			var payload = {
				userId: this.getLoggedUser.id,
				schoolClassId: this.schoolClassLessonPlan[lessonPlanIndex].schoolClass.schoolClassId,
				themeId: this.currentTheme.schoolThemeId,
				year: this.currentYear,
				data: this.schoolClassLessonPlan[lessonPlanIndex].plans.filter(function (plan) {
					return plan.date;
				})
			};

			payload.data = payload.data.map(function (item) {
				var planId = item.planId,
				    date = item.date;


				return {
					planId: planId,
					date: date
				};
			});

			if (payload.data && payload.data.length) {

				return this.putSchoolClassLessonPlan(payload).then(function () {
					_toastr2.default.success(_this.$gettext('Planejamento de aula salvo com sucesso!'));
				});
			}

			return _toastr2.default.warning(this.$gettext('Nenhuma data informada.'));
		},
		toggleCopy: function toggleCopy(index, status) {

			this.model.forEach(function (item) {
				item.copyIsVisible = false;
			});

			if (status) {
				this.model[index].copyIsVisible = !this.model[index].copyIsVisible;
			}
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('classChanged', function (klass) {
			_this2[klass.context] = klass.data;
		});

		_eventBus.EventBus.$on('planning:toggle-copy', function (index, status) {
			_this2.toggleCopy(index, status);
		});

		_eventBus.EventBus.$on('schoolClassLessonPlanFetched', function () {

			var clone = (0, _lodash.cloneDeep)(_this2.schoolClassLessonPlan);

			_this2.model = (0, _assign2.default)(clone.map(function (value) {

				value.copyIsVisible = false;

				return value;
			}), _this2.options);
		});
	}
};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(201);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'class-grade',
	props: {
		label: {
			type: String,
			default: 'Ano de ensino'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		onlySelect: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			classGradeModel: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getLoggedUser', 'classGrade', 'classGradeList'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getClassGrade', 'setSelectedClassGrade']), {
		changed: function changed() {

			this.setSelectedClassGrade(this.classGradeModel);
			_eventBus.EventBus.$emit('classGradeSelected', this.classGradeModel);
		}
	}),
	mounted: function mounted() {

		this.classGradeModel = this.classGrade;

		if (this.selected) {
			this.classGradeModel = this.selected;
		}

		return this.getClassGrade({
			userId: this.getLoggedUser.id
		});
	}
});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _lodash = __webpack_require__(9);

var _eventBus = __webpack_require__(5);

var _vueSelect = __webpack_require__(90);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _store = __webpack_require__(203);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'school-class-list',
	props: {
		context: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'Class'
		},
		multiple: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		group: {
			type: Boolean,
			default: true
		},
		withStudents: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		onlySelect: {
			type: Boolean,
			default: false
		},
		byTheme: {
			type: Boolean,
			default: false
		},
		scope: {
			type: String,
			default: 'global' // global, local
		},
		filter: {
			type: String,
			default: '' // '' all / 1 extracurricular / 0 regular
		}
	},
	components: {
		vSelect: _vueSelect2.default
	},
	data: function data() {
		return {
			schoolClass: [],
			classList: '',
			selected: {},
			list: []
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classes: function classes(state) {
			return state.Class;
		},
		user: function user(state) {
			return state.Logged.user;
		},
		students: function students(state) {
			return state.Student.list;
		}
	}), (0, _vuex.mapGetters)(['getLoggedUser', 'classGrade', 'classGradeList', 'getClass', 'album', 'currentTheme'])),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setSelectedClass', 'setStudent', 'getClassByUser', 'getStudents']), {
		changed: function changed() {

			if (!this.multiple) {

				if (this.scope === 'local') {
					this.selected = this.classList;
				} else {

					this.setStudent({});
					this.setSelectedClass(this.classList);
				}
			} else {
				this.setSelectedClass(this.schoolClass);
			}

			_eventBus.EventBus.$emit('classChanged', {
				context: this.context,
				data: this.scope === 'local' ? this.selected : this.getClass
			});
		},
		defaultResponse: function defaultResponse(response) {

			if (this.scope === 'local') {
				this.list = response.data.object;
			}
		}
	}),
	mounted: function mounted() {
		var _this = this;

		if (this.scope === 'global') {
			this.list = this.classes.list;
		}

		if (this.context === 'gallery' && this.multiple) {
			this.schoolClass = this.album.schoolClasses;
			this.setSelectedClass(this.schoolClass);
		}

		if (this.context === 'gallery' && !this.multiple) {
			this.classList = this.album.schoolClasses;
		}

		if (!(0, _lodash.isEmpty)(this.getClass)) {
			this.classList = this.getClass;
		}

		_eventBus.EventBus.$on('classGradeSelected', function (payload) {

			_this.getClassByUser({
				userId: _this.getLoggedUser.id,
				scope: _this.scope,
				filter: {
					gradeId: payload.gradeId
				}
			}).then(_this.defaultResponse);
		});

		if (this.byTheme) {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				filter: {
					themeId: this.currentTheme.schoolThemeId
				}
			}).then(this.defaultResponse);

			_eventBus.EventBus.$on('themeSelected', function (theme) {

				_this.getClassByUser({
					userId: _this.getLoggedUser.id,
					scope: _this.scope,
					filter: {
						themeId: theme.schoolThemeId
					}
				}).then(_this.defaultResponse);
			});
		} else {

			this.getClassByUser({
				userId: this.getLoggedUser.id,
				scope: this.scope,
				extracurricular: this.filter
			}).then(this.defaultResponse);
		}

		this.$store.watch(function (state) {
			return state.Class.list;
		}, function (newClassList) {
			_this.list = newClassList;
		});

		this.$store.watch(function (state) {
			return state.Class.selected;
		}, function (newClass) {

			if (_this.withStudents && newClass !== undefined) {

				_this.getStudents({
					userId: _this.getLoggedUser.id,
					schoolClassId: newClass.schoolClassId,
					scope: _this.scope
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('classGradeSelected');
		_eventBus.EventBus.$off('classChanged');
		_eventBus.EventBus.$off('themeSelected');
	}
});

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'class-name',
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		agendaDate: 'getAgendaDate',
		klass: 'getClass'
	}))
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _eventBus = __webpack_require__(5);

var _store = __webpack_require__(204);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _extends3.default)({}, _store2.default, {
	name: 'SchoolTheme',
	props: {
		label: {
			type: String,
			default: 'Disciplina'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data: function data() {
		return {
			themeModel: ''
		};
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
		user: 'getLoggedUser',
		themes: 'themes'
	})),
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSchoolThemes', 'setTheme']), {
		changed: function changed() {

			this.setTheme(this.themeModel);
			_eventBus.EventBus.$emit('themeSelected', this.themeModel);
		}
	}),
	mounted: function mounted() {

		this.getSchoolThemes(this.user);
	}
});

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _vueSelect = __webpack_require__(90);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _eventBus = __webpack_require__(5);

var _state = __webpack_require__(208);

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__(205);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(206);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(207);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	state: _state2.default,
	actions: _actions2.default,
	getters: _getters2.default,
	mutations: _mutations2.default,
	name: 'students',
	components: {
		vSelect: _vueSelect2.default
	},
	data: function data() {
		return {
			student: [],
			studentList: []
		};
	},
	props: {
		context: {
			type: String,
			default: ''
		},
		className: {
			type: String,
			default: ''
		},
		imglist: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
		classes: function classes(state) {
			return state.Class;
		},
		students: function students(state) {
			return state.Student.list;
		},
		agenda: function agenda(state) {
			return state.Agenda;
		}
	}), (0, _vuex.mapGetters)({
		currentStudent: 'getStudent',
		user: 'getLoggedUser',
		class: 'getClass',
		album: 'album'
	})),
	filters: {
		agendaStatus: function agendaStatus(value) {

			return {
				NOT_CREATED: 'Não criada',
				CREATED: 'Criada',
				IN_APPROVAL: 'Em aprovação',
				IN_REVISION: 'Em revisão',
				PROCESSING: 'Processando',
				REPROCESS: '',
				APPROVED: 'Publicada',
				SENT: 'Enviada',
				READED: 'Lida'
			}[value];
		}
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getStudents', 'setStudent', 'getAgenda', 'getAgendaStatus', 'getMessages', 'getPresence', 'getMessageRecipient', 'getMessageRecipientIsResponsible', 'setMessageRecipientResponsible', 'setMessageRecipientList', 'setMessageRecipientSchoolMembers', 'setSchoolMembers', 'setResponsibles', 'updateStudentList']), {
		setCurrentStudent: function setCurrentStudent(student) {
			var _this = this;

			_eventBus.EventBus.$emit('setStudent');

			this.setStudent(student);

			if (this.context === 'agenda') {

				this.getAgenda({
					userId: this.user.id,
					studentId: student.studentId,
					date: (0, _moment2.default)(this.agenda.date).format('YYYY-MM-DD')
				}).then(function () {
					_eventBus.EventBus.$emit('setAgenda');
				});

				this.getMessages({
					userId: this.user.id,
					studentId: student.studentId
				});
			}

			if (this.context === 'newmessage') {

				this.getMessageRecipient({
					userId: this.user.id,
					studentId: student.studentId
				}).then(function () {

					_this.getMessageRecipientIsResponsible(true).then(function (response) {
						_this.setMessageRecipientResponsible(response);
					});

					_this.getMessageRecipientIsResponsible(false).then(function (response) {
						_this.setMessageRecipientSchoolMembers(response);
					});
				});
			}

			if (this.context === 'gallery') {
				this.student = this.album.students;
			}
		},
		getStatusLabelColor: function getStatusLabelColor(status) {

			var redClass = 'bg-red-flamingo bg-font-red-flamingo';
			var yellowClass = 'bg-yellow-lemon bg-font-yellow-lemon';
			var grayClass = 'bg-grey-salsa bg-font-grey-salsa';
			var greenClass = 'bg-green-jungle bg-font-green-jungle';

			return {
				'NOT_CREATED': redClass,
				'CREATED': yellowClass,
				'IN_APPROVAL': yellowClass,
				'IN_REVISION': redClass,
				'PROCESSING': grayClass,
				'REPROCESS': yellowClass,
				'APPROVED': greenClass,
				'SENT': greenClass,
				'READED': greenClass
			}[status];
		}
	}),
	mounted: function mounted() {
		var _this2 = this;

		_eventBus.EventBus.$on('studentAssigned', function (studentsAssigned) {
			_this2.student = studentsAssigned;
		});

		_eventBus.EventBus.$on('classChanged', function (klass) {

			_this2.student = [];

			if (klass && klass.data && klass.data.schoolClassId) {

				_this2.getStudents({
					userId: _this2.user.id,
					schoolClassId: _this2.class.schoolClassId
				}).then(function () {

					if (_this2.context === 'agenda') {

						_this2.getAgendaStatus({
							userId: _this2.user.id,
							schoolClassId: klass.data.schoolClassId,
							date: (0, _moment2.default)(_this2.agenda.date).format('YYYY-MM-DD')
						});
					}
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {

		_eventBus.EventBus.$off('classChanged');
	}
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(4);

var _logrocket = __webpack_require__(276);

var _logrocket2 = _interopRequireDefault(_logrocket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'schoolastic',
	computed: {
		isIframe: function isIframe() {
			return window.self !== window.top;
		}
	},
	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['putLogged']), {
		sendIframeMessage: function sendIframeMessage(data) {

			return window.parent.postMessage({
				schoolastic: data
			}, '*');
		},
		onElementHeightChange: function onElementHeightChange(element, callback) {
			// https://stackoverflow.com/questions/14866775/detect-document-height-change#answer-14901150

			var lastHeight = element.clientHeight;
			var newHeight = void 0;

			(function run() {

				newHeight = element.clientHeight;

				if (lastHeight !== newHeight) {
					callback();
				}

				lastHeight = newHeight;

				if (element.onElementHeightChangeTimer) {
					clearTimeout(element.onElementHeightChangeTimer);
				}

				element.onElementHeightChangeTimer = setTimeout(run, 200);
			})();
		}
	}),
	created: function created() {

		/*! <iframe /> workaround *********************************************/

		var context = this;
		var body = document.body;
		var html = document.documentElement;
		var iframeHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

		context.sendIframeMessage({
			giveMeUserData: true
		});

		context.sendIframeMessage({
			iframeHeight: iframeHeight,
			locationHash: window.location.hash
		});

		context.onElementHeightChange(document.body, function () {

			context.sendIframeMessage({
				iframeHeight: iframeHeight,
				locationHash: window.location.hash
			});
		});

		window.addEventListener('message', function (event) {

			if (event.data.schoolastic && event.data.schoolastic.user && event.data.schoolastic.school) {

				context.putLogged(event.data.schoolastic);

				var _event$data$schoolast = event.data.schoolastic,
				    user = _event$data$schoolast.user,
				    school = _event$data$schoolast.school;


				if (window.Rollbar) {

					Rollbar.configure({
						payload: {
							person: {
								id: user.id,
								username: user.name,
								email: user.email
							},
							school: school
						}
					});
				}

				if (window.LogRocket) {

					_logrocket2.default.identify(user.id, {
						name: user.name,
						email: user.email,
						School: school,
						Resolution: screen.width + 'x' + screen.height
					});
				}
			}
		}, false);

		/*! End <iframe /> workaround *****************************************/
	}
};

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 277,
	"./af.js": 277,
	"./ar": 284,
	"./ar-dz": 278,
	"./ar-dz.js": 278,
	"./ar-kw": 279,
	"./ar-kw.js": 279,
	"./ar-ly": 280,
	"./ar-ly.js": 280,
	"./ar-ma": 281,
	"./ar-ma.js": 281,
	"./ar-sa": 282,
	"./ar-sa.js": 282,
	"./ar-tn": 283,
	"./ar-tn.js": 283,
	"./ar.js": 284,
	"./az": 285,
	"./az.js": 285,
	"./be": 286,
	"./be.js": 286,
	"./bg": 287,
	"./bg.js": 287,
	"./bm": 288,
	"./bm.js": 288,
	"./bn": 289,
	"./bn.js": 289,
	"./bo": 290,
	"./bo.js": 290,
	"./br": 291,
	"./br.js": 291,
	"./bs": 292,
	"./bs.js": 292,
	"./ca": 293,
	"./ca.js": 293,
	"./cs": 294,
	"./cs.js": 294,
	"./cv": 295,
	"./cv.js": 295,
	"./cy": 296,
	"./cy.js": 296,
	"./da": 297,
	"./da.js": 297,
	"./de": 300,
	"./de-at": 298,
	"./de-at.js": 298,
	"./de-ch": 299,
	"./de-ch.js": 299,
	"./de.js": 300,
	"./dv": 301,
	"./dv.js": 301,
	"./el": 302,
	"./el.js": 302,
	"./en-au": 303,
	"./en-au.js": 303,
	"./en-ca": 304,
	"./en-ca.js": 304,
	"./en-gb": 305,
	"./en-gb.js": 305,
	"./en-ie": 306,
	"./en-ie.js": 306,
	"./en-il": 307,
	"./en-il.js": 307,
	"./en-nz": 308,
	"./en-nz.js": 308,
	"./eo": 309,
	"./eo.js": 309,
	"./es": 312,
	"./es-do": 310,
	"./es-do.js": 310,
	"./es-us": 311,
	"./es-us.js": 311,
	"./es.js": 312,
	"./et": 313,
	"./et.js": 313,
	"./eu": 314,
	"./eu.js": 314,
	"./fa": 315,
	"./fa.js": 315,
	"./fi": 316,
	"./fi.js": 316,
	"./fo": 317,
	"./fo.js": 317,
	"./fr": 320,
	"./fr-ca": 318,
	"./fr-ca.js": 318,
	"./fr-ch": 319,
	"./fr-ch.js": 319,
	"./fr.js": 320,
	"./fy": 321,
	"./fy.js": 321,
	"./gd": 322,
	"./gd.js": 322,
	"./gl": 323,
	"./gl.js": 323,
	"./gom-latn": 324,
	"./gom-latn.js": 324,
	"./gu": 325,
	"./gu.js": 325,
	"./he": 326,
	"./he.js": 326,
	"./hi": 327,
	"./hi.js": 327,
	"./hr": 328,
	"./hr.js": 328,
	"./hu": 329,
	"./hu.js": 329,
	"./hy-am": 330,
	"./hy-am.js": 330,
	"./id": 331,
	"./id.js": 331,
	"./is": 332,
	"./is.js": 332,
	"./it": 333,
	"./it.js": 333,
	"./ja": 334,
	"./ja.js": 334,
	"./jv": 335,
	"./jv.js": 335,
	"./ka": 336,
	"./ka.js": 336,
	"./kk": 337,
	"./kk.js": 337,
	"./km": 338,
	"./km.js": 338,
	"./kn": 339,
	"./kn.js": 339,
	"./ko": 340,
	"./ko.js": 340,
	"./ky": 341,
	"./ky.js": 341,
	"./lb": 342,
	"./lb.js": 342,
	"./lo": 343,
	"./lo.js": 343,
	"./lt": 344,
	"./lt.js": 344,
	"./lv": 345,
	"./lv.js": 345,
	"./me": 346,
	"./me.js": 346,
	"./mi": 347,
	"./mi.js": 347,
	"./mk": 348,
	"./mk.js": 348,
	"./ml": 349,
	"./ml.js": 349,
	"./mn": 350,
	"./mn.js": 350,
	"./mr": 351,
	"./mr.js": 351,
	"./ms": 353,
	"./ms-my": 352,
	"./ms-my.js": 352,
	"./ms.js": 353,
	"./mt": 354,
	"./mt.js": 354,
	"./my": 355,
	"./my.js": 355,
	"./nb": 356,
	"./nb.js": 356,
	"./ne": 357,
	"./ne.js": 357,
	"./nl": 359,
	"./nl-be": 358,
	"./nl-be.js": 358,
	"./nl.js": 359,
	"./nn": 360,
	"./nn.js": 360,
	"./pa-in": 361,
	"./pa-in.js": 361,
	"./pl": 362,
	"./pl.js": 362,
	"./pt": 364,
	"./pt-br": 363,
	"./pt-br.js": 363,
	"./pt.js": 364,
	"./ro": 365,
	"./ro.js": 365,
	"./ru": 366,
	"./ru.js": 366,
	"./sd": 367,
	"./sd.js": 367,
	"./se": 368,
	"./se.js": 368,
	"./si": 369,
	"./si.js": 369,
	"./sk": 370,
	"./sk.js": 370,
	"./sl": 371,
	"./sl.js": 371,
	"./sq": 372,
	"./sq.js": 372,
	"./sr": 374,
	"./sr-cyrl": 373,
	"./sr-cyrl.js": 373,
	"./sr.js": 374,
	"./ss": 375,
	"./ss.js": 375,
	"./sv": 376,
	"./sv.js": 376,
	"./sw": 377,
	"./sw.js": 377,
	"./ta": 378,
	"./ta.js": 378,
	"./te": 379,
	"./te.js": 379,
	"./tet": 380,
	"./tet.js": 380,
	"./tg": 381,
	"./tg.js": 381,
	"./th": 382,
	"./th.js": 382,
	"./tl-ph": 383,
	"./tl-ph.js": 383,
	"./tlh": 384,
	"./tlh.js": 384,
	"./tr": 385,
	"./tr.js": 385,
	"./tzl": 386,
	"./tzl.js": 386,
	"./tzm": 388,
	"./tzm-latn": 387,
	"./tzm-latn.js": 387,
	"./tzm.js": 388,
	"./ug-cn": 389,
	"./ug-cn.js": 389,
	"./uk": 390,
	"./uk.js": 390,
	"./ur": 391,
	"./ur.js": 391,
	"./uz": 393,
	"./uz-latn": 392,
	"./uz-latn.js": 392,
	"./uz.js": 393,
	"./vi": 394,
	"./vi.js": 394,
	"./x-pseudo": 395,
	"./x-pseudo.js": 395,
	"./yo": 396,
	"./yo.js": 396,
	"./zh-cn": 397,
	"./zh-cn.js": 397,
	"./zh-hk": 398,
	"./zh-hk.js": 398,
	"./zh-tw": 399,
	"./zh-tw.js": 399
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;

/***/ }),
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1081),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(944)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1088),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77146de6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1103),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1030),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(940)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1077),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-572a4149",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1031),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-038fcd4c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1068),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1065),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1029),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1055),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ddbfd2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1091),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1041),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19e3e8a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1062),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45ffe4ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1095),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84c2ab10",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d976b98c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1110),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1036),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13d8462c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1035),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12e6ea25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30eaa2d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5657b991",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1052),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1038),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1074),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1098),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1086),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1067),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1090),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a964a64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1080),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c227d40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1094),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1045),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22cbbe7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c2ab7bf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1071),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1034),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1070),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55267278",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1099),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1048),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1056),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1058),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1033),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1089),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1084),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1032),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0731ce82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1109),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1107),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c837d6ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1063),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-468dfdf5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1057),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1066),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1061),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-459be3eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1093),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8047c2cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1072),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e71cb9f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1046),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(955)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eec88d36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1059),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1115),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tCaixa de Entrada\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('sidebar-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('message-send')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicators"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Indicadores")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('evaluation-questions-filter')], 1)]), _vm._v(" "), _c('evaluation-questions')], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meals-calendar"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Galeria")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light "
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Filtrar por:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-6"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.albumName),
      expression: "albumName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome do álbum"
    },
    domProps: {
      "value": (_vm.albumName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.albumName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('class-list', {
    attrs: {
      "label": 'Turmas:',
      "context": 'gallery'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Alunos:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentName),
      expression: "studentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome do aluno"
    },
    domProps: {
      "value": (_vm.studentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-block yellow-gold pull-left m-t-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filter
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Filtrar")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Lista de Álbuns")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 m-t-10 m-b-15"
  }, [_c('router-link', {
    staticClass: "btn red-mint",
    attrs: {
      "to": "/gallery/album"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criar novo álbum")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_c('thead', {
    staticClass: "bg-red-mint bg-font-red-mint"
  }, [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "250px"
    }
  }, [_vm._v("Atribuído para")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "130px"
    }
  }, [_vm._v("Nro de fotos")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("Criado por")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Data de criação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(album, index) {
    return _c('tr', [_c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(album.title))]), _vm._v(" "), (album.scope === 'ALL') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Para todos os alunos da escola.")])]) : _vm._e(), _vm._v(" "), (album.scope === 'SCHOOL_CLASS') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Turmas: ")]), _vm._v(" "), _vm._l((album.schoolClasses), function(klass, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(klass.description)), (album.students) ? _c('span', {
        domProps: {
          "textContent": _vm._s(album.students.length !== index + 1 ? ',' : '.')
        }
      }) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (album.scope === 'STUDENT') ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Alunos: ")]), _vm._v(" "), _vm._l((album.students), function(student, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(student.name)), (album.students.length) ? _c('span', {
        domProps: {
          "textContent": _vm._s(album.students.length !== index + 1 ? ',' : '.')
        }
      }) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "vertical-align-middle"
    }, [_c('i', {
      staticClass: "fa fa-camera",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(album.albumSize) + " fotos")]), _vm._v(" "), (album.creationUser) ? _c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(album.creationUser.name))]) : _vm._e(), _vm._v(" "), (!album.creationUser) ? _c('td', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "vertical-align-middle"
    }, [_vm._v("Não informado")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "vertical-align-middle"
    }, [_vm._v(_vm._s(_vm._f("date")(album.creationDateTime, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('td', [_c('router-link', {
      key: album.id,
      staticClass: "btn btn-block blue m-b-15",
      attrs: {
        "tag": "a",
        "to": {
          path: ("/gallery/album/" + (album.id))
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Editar")])]), _vm._v(" "), (album.status == 'APPROVED') ? _c('button', {
      staticClass: "btn btn-block red-mint",
      attrs: {
        "tag": "a"
      },
      on: {
        "click": function($event) {
          _vm.unpublish(album.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Despublicar")])]) : _vm._e(), _vm._v(" "), (album.status == 'CREATED' || album.status == 'IN_REVISION') ? _c('button', {
      staticClass: "btn btn-block green-jungle",
      attrs: {
        "tag": "a"
      },
      on: {
        "click": function($event) {
          _vm.publish(album.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Publicar")])]) : _vm._e()], 1)])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.list.length > 0) ? _c('pagination', {
    attrs: {
      "layout": "prev, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-body"
  }, [(_vm.studentName) ? _c('div', {
    staticClass: "inbox-header"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.studentName) + "\n\t\t\t"), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.className))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inbox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('school-class-list', {
    attrs: {
      "with-students": true,
      "label": 'Turma:'
    }
  })], 1), _vm._v(" "), (_vm.className) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Selecione o aluno:")]), _vm._v(" "), _c('students', {
    class: 'col-md-12',
    attrs: {
      "context": 'newmessage',
      "imglist": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.studentName) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Responsável:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "responsibles"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "name",
      "options": _vm.responsibles,
      "value": _vm.responsibles,
      "placeholder": "Selecione os responsáveis:"
    },
    model: {
      value: (_vm.responsible),
      callback: function($$v) {
        _vm.responsible = $$v
      },
      expression: "responsible"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.studentName) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Membro da escola:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "schoolMembers"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "formatedName",
      "options": _vm.schoolmembers,
      "value": _vm.schoolmembers,
      "placeholder": "Selecione os membros da escola:"
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Assunto:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group emoji-text relative"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Mensagem:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emojiPickerVisible),
      expression: "emojiPickerVisible"
    }],
    staticClass: "absolute",
    attrs: {
      "exclude": ['flags', 'symbols'],
      "i18n": _vm.i18n,
      "title": "Emoji",
      "set": "apple"
    },
    on: {
      "click": _vm.addEmoji
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-muted text-right"
  }, [_c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para usar "), _c('em', [_vm._v("emojis")]), _vm._v(" clique no botão ao lado.")]), _c('br'), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_c('strong', [_vm._v("Observação:")]), _vm._v(" no navegador os "), _c('em', [_vm._v("emojis")]), _vm._v(" podem aparecer em forma de [], mas ao enviar aparecerá o "), _c('em', [_vm._v("emoji")]), _vm._v(" selecionado.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emojiPickerVisible = !_vm.emojiPickerVisible
      }
    }
  }, [_c('emoji', {
    attrs: {
      "emoji": "grinning",
      "size": 15
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEmojis\n\t\t\t\t\t\t")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn green-jungle",
    on: {
      "click": _vm.sendNewMessage
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEnviar\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon-pencil"
  })])])
}]}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block green-jungle",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.publishAllHomeworks
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\tPublicar todas lições\n")])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Saúde Bucal")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "form-group m-b-0"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label m-b-20"
  }, [_vm._v("O aluno escovou os dentes hoje?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline m-b-0"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "brush",
      "value": "1"
    },
    domProps: {
      "checked": parseInt(_vm.brush) === 1
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.putAgendaBrush($event)
      }
    }
  }), _vm._v("\n\t\t\t\t\tSim\n\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline m-b-0"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "brush",
      "value": "0"
    },
    domProps: {
      "checked": parseInt(_vm.brush) === 0
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.putAgendaBrush($event)
      }
    }
  }), _vm._v("\n\t\t\t\t\tNão\n\t\t\t\t\t"), _c('span')])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Selecione a quantidade de alunos da escola:")]), _vm._v(" "), _c('range-slider', {
    staticClass: "slider",
    attrs: {
      "min": "25",
      "max": "1025",
      "step": "25"
    },
    model: {
      value: (_vm.form.studentsQuantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentsQuantity", $$v)
      },
      expression: "form.studentsQuantity"
    }
  }), _vm._v(" "), (_vm.form.studentsQuantity < 1001) ? _c('span', {
    staticClass: "js-output",
    attrs: {
      "id": "js-output"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.form.studentsQuantity) + " alunos\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form.studentsQuantity > 1000) ? _c('span', {
    staticClass: "js-output",
    attrs: {
      "id": "js-output"
    }
  }, [_vm._v("\n\t\t\t\tMais de 1.000 alunos\n\t\t\t")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Plano: *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan),
      expression: "form.plan"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('plan')
    },
    attrs: {
      "name": "plan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "plan", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FREE"
    }
  }, [_vm._v("Gratuito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("Básico")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PREMIUM"
    }
  }, [_vm._v("Premium")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantidade de Alunos: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.studentsQuantity),
      expression: "form.studentsQuantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.studentsQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "studentsQuantity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Modalidades de ensino:")]), _vm._v(" "), _c('div', {
    staticClass: "mt-checkbox"
  }, _vm._l((_vm.levelsType), function(value, key) {
    return _c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.levels),
        expression: "form.levels"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.form.levels) ? _vm._i(_vm.form.levels, key) > -1 : (_vm.form.levels)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.levels,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "levels", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "levels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "levels", $$c)
          }
        }
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t"), _c('span')])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('schoolName')
    }
  }, [_c('label', [_vm._v("Nome da escola: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.schoolName),
      expression: "form.schoolName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "schoolName"
    },
    domProps: {
      "value": (_vm.form.schoolName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "schoolName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mobilePhoneNumber')
    }
  }, [_c('label', [_vm._v("Telefone celular: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(##)#####-####'),
      expression: "'(##)#####-####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobilePhoneNumber),
      expression: "form.mobilePhoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num",
      "name": "mobilePhoneNumber"
    },
    domProps: {
      "value": (_vm.form.mobilePhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobilePhoneNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', [_vm._v("Nome de Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactName),
      expression: "form.contactName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName"
    },
    domProps: {
      "value": (_vm.form.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmailAddress')
    }
  }, [_c('label', [_vm._v("E-mail Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactEmailAddress),
      expression: "form.contactEmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmailAddress"
    },
    domProps: {
      "value": (_vm.form.contactEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactEmailAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Voucher de desconto:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voucherNumber),
      expression: "form.voucherNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.voucherNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "voucherNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1 pull-right"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('button', {
    staticClass: "btn btn-sucess",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Simular")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Simulador")])])])
}]}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-in"
  }, [_c('div', {
    staticClass: "page-lock"
  }, [_c('div', {
    staticClass: "page-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "lock-head"
  }, [_vm._v("\n\t\t\t\tLocked\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "lock-body"
  }, [_c('div', [_c('div', {
    staticClass: "lock-item lock-item-full"
  }, [_c('form', {
    staticClass: "lock-form",
    attrs: {
      "rule": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn red uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "lock-bottom"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('student-water')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('student-meals')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "calendar",
    attrs: {
      "id": "calendar"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "year"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.group
    }
  }, [(_vm.group) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "year",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione um ano letivo")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('option', {
      domProps: {
        "value": year.id
      }
    }, [_vm._v(_vm._s(year.value))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.student.photoURL
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.student.name))])])
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Relatório :: Plano de aula")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Selecione uma semana para pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false,
      "with-next-year": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('month', {
    attrs: {
      "disabled": !_vm.year,
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('week', {
    attrs: {
      "disabled": !_vm.year || !_vm.month || (_vm.month && _vm.month.index === -1),
      "group": false,
      "showFirst": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('school-class', {
    attrs: {
      "label": 'Selecione uma turma',
      "group": false
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box blue"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v("Planejamento de aula ")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    staticClass: "collapse",
    attrs: {
      "href": "javascript:;",
      "data-original-title": "",
      "title": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "config",
    attrs: {
      "href": "#portlet-config",
      "data-toggle": "modal",
      "data-original-title": "",
      "title": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "reload",
    attrs: {
      "href": "javascript:;",
      "data-original-title": "",
      "title": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "remove",
    attrs: {
      "href": "javascript:;",
      "data-original-title": "",
      "title": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" # ")]), _vm._v(" "), _c('th', [_vm._v(" Domingo ")]), _vm._v(" "), _c('th', [_vm._v(" Segunda-feira ")]), _vm._v(" "), _c('th', [_vm._v(" Terça-feira ")]), _vm._v(" "), _c('th', [_vm._v(" Quarta-feira ")]), _vm._v(" "), _c('th', [_vm._v(" Quinta-feira ")]), _vm._v(" "), _c('th', [_vm._v(" Sexta-feira ")]), _vm._v(" "), _c('th', [_vm._v(" Sábado ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(" 1 ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" 2 ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" 3 ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")]), _vm._v(" "), _c('td', [_vm._v(" Table cell ")])])])])])])])
}]}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "month"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.group
    }
  }, [(_vm.group) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.month),
      expression: "month"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "month",
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Selecione um mês")]), _vm._v(" "), _vm._l((_vm.ENUM.Month), function(month, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(month))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleHomework
    }
  }, [_vm._v("\n\tCadastrar lição de casa para turma\n")])
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('scheduled-medicine')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('student-eventual-medicine')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('student-evacueted')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('student-nap')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-4"
  }, [_c('student-urine-quantity')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-4"
  }, [_c('student-bath-quantity')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-4"
  }, [_c('student-diapers-quantity')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('student-tooth-brushing')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação eventual")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addEventualMedicineItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3 col-xs-3",
    class: {
      'has-error': _vm.errors.has('medicine-time')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-time"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.time),
      expression: "medicine.time"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-time",
      "name": "medicine-time",
      "placeholder": "Exemplo: 16:00"
    },
    domProps: {
      "value": (_vm.medicine.time)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-xs-6",
    class: {
      'has-error': _vm.errors.has('medicine-medicine')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-medicine"
    }
  }, [_vm._v("Medicação")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.medicine),
      expression: "medicine.medicine"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-medicine",
      "name": "medicine-medicine",
      "placeholder": "Medicação"
    },
    domProps: {
      "value": (_vm.medicine.medicine)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "medicine", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-xs-3",
    class: {
      'has-error': _vm.errors.has('medicine-dosage')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-dosage"
    }
  }, [_vm._v("Dosagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.dosage),
      expression: "medicine.dosage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "medicine-dosage",
      "name": "medicine-dosage",
      "placeholder": "Dosagem"
    },
    domProps: {
      "value": (_vm.medicine.dosage)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "dosage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-xs-12",
    class: {
      'has-error': _vm.errors.has('medicine-reason')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "medicine-reason"
    }
  }, [_vm._v("Observações/Justificativas:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicine.reason),
      expression: "medicine.reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "medicine-reason",
      "name": "medicine-reason",
      "rows": "3",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.medicine.reason)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.medicine)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicine, "reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block green btn-add",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("\n\t\t\t\t\t\tAdicionar\n\t\t\t\t\t")])])])]), _vm._v(" "), (_vm.eventualMedicines && _vm.eventualMedicines.length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.eventualMedicines && _vm.eventualMedicines.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Observações")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.eventualMedicines), function(medicine, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.reason))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editEventualMedicineItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteEventualMedicineItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h1', [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Lista de medicações para")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("date")(_vm.date, "DD/MM/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('ul', {
    staticClass: "list-unstyled list-inline text-right"
  }, [_c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle font-red",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação atrasada")])]), _vm._v(" "), _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-check font-green",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação ministrada")])]), _vm._v(" "), _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-ban font-red",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação rejeitada")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.model.questions), function(question, questionIndex) {
    return (_vm.model.questions) ? _c('div', {
      staticClass: "portlet light"
    }, [_c('div', {
      staticClass: "portlet-body"
    }, [_c('blockquote', [_c('p', [_vm._v(_vm._s(question.question))])])]), _vm._v(" "), (_vm.model.students) ? _c('div', {
      staticClass: "portlet-body"
    }, [_c('table', {
      staticClass: "table table-hover table-striped"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', [_c('tr'), _vm._v(" "), _vm._l((_vm.model.students), function(student, studentIndex) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(student.student.name))]), _vm._v(" "), _vm._l(([1, 2, 3, 4, 5]), function(answer) {
        return (student.questions.length > 0) ? _c('td', {
          staticClass: "mt-radio-inline text-center"
        }, [_c('label', {
          staticClass: "mt-radio mt-radio-outline"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (student.questions[questionIndex].answer),
            expression: "student.questions[questionIndex].answer"
          }],
          attrs: {
            "type": "radio",
            "id": question.id + '-' + student.student.studentId + '-' + answer,
            "name": question.id + '-' + student.student.studentId
          },
          domProps: {
            "value": answer,
            "checked": _vm._q(student.questions[questionIndex].answer, answer)
          },
          on: {
            "change": [function($event) {
              _vm.$set(student.questions[questionIndex], "answer", answer)
            }, function($event) {
              _vm.onChange(student.student.studentId, question.id, answer)
            }]
          }
        }), _vm._v(" "), _c('span')])]) : _vm._e()
      }), _vm._v(" "), (student.questions.length == 0) ? _c('td', {
        staticClass: "mt-radio-inline text-center",
        attrs: {
          "colspan": "5"
        }
      }, [(student.status == 'IN_APPROVAL') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período está "), _c('b', [_vm._v("em aprovação")])]) : _vm._e(), _vm._v(" "), (student.status == 'APPROVED') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período está "), _c('b', [_vm._v("aprovado e os resultados já podem ser conferidos na área de desempenho do aluno")])]) : _vm._e(), _vm._v(" "), (student.status == 'REJECTED') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período precisa "), _c('b', [_vm._v("ser revisado")])]) : _vm._e(), _vm._v(" "), (student.status == 'PROCESSING') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período está "), _c('b', [_vm._v("em processamento")])]) : _vm._e(), _vm._v(" "), (student.status == 'SENT') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período já foi "), _c('b', [_vm._v("compartilhado com um ou mais responsáveis")])]) : _vm._e(), _vm._v(" "), (student.status == 'READED') ? _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_vm._v("O indicador de inteligências múltiplas do período já foi "), _c('b', [_vm._v("lido por um ou mais responsáveis")])]) : _vm._e()]) : _vm._e()], 2)
    })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "portlet-footer p-0"
    }, [_c('evaluation-question-save', {
      attrs: {
        "question": question.questionId
      }
    })], 1)]) : _vm._e()
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "first"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("Muito Raramente")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("Raramente")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("Ás Vezes")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("Frequentemente")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('span', [_vm._v("Muito Frequentemente")])])])])
}]}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box yellow-gold"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-line-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Questões para indicadores")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Questão")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Muito Raramente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Raramente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ás Vezes")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Frequentemente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Muito Frequentemente")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.stdQuestions), function(question, index) {
    return _c('tr', {
      staticClass: "form-group"
    }, [_c('td', [_vm._v(_vm._s(question.evaluationSchoolQuestion.question.question))]), _vm._v(" "), _c('td', {
      staticClass: "mt-radio-inline"
    }, [_c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": question.evaluationSchoolQuestion.question.id,
        "data-index": index
      },
      domProps: {
        "value": 1,
        "checked": question.answer === '1'
      },
      on: {
        "change": _vm.putAgendaQuestions
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "mt-radio-inline"
    }, [_c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": question.evaluationSchoolQuestion.question.id,
        "data-index": index
      },
      domProps: {
        "value": 2,
        "checked": question.answer === '2'
      },
      on: {
        "change": _vm.putAgendaQuestions
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "mt-radio-inline"
    }, [_c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": question.evaluationSchoolQuestion.question.id,
        "data-index": index
      },
      domProps: {
        "value": 3,
        "checked": question.answer === '3'
      },
      on: {
        "change": _vm.putAgendaQuestions
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "mt-radio-inline"
    }, [_c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": question.evaluationSchoolQuestion.question.id,
        "data-index": index
      },
      domProps: {
        "value": 4,
        "checked": question.answer === '4'
      },
      on: {
        "change": _vm.putAgendaQuestions
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('td', {
      staticClass: "mt-radio-inline"
    }, [_c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": question.evaluationSchoolQuestion.question.id,
        "data-index": index
      },
      domProps: {
        "value": 5,
        "checked": question.answer === '5'
      },
      on: {
        "change": _vm.putAgendaQuestions
      }
    }), _vm._v(" "), _c('span')])])])
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n\t" + _vm._s(_vm.klass.description) + "\n\t"), _c('small', [_vm._v(_vm._s(_vm._f("date")(_vm.agendaDate, 'DD/MM/YYYY')))])])
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v("Mensalidade")]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.lead.budget.studentFee * _vm.form.studentsQuantity, 'R$')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v("Anuidade")]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.lead.budget.annualFee, 'R$')) + " ")])]), _vm._v(" "), (_vm.form.plan !== 'FREE') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v("Integração")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "anuidade"
    }
  }, [_vm._v(_vm._s(_vm.lead.budget.currency) + " 5.000 por sistema.")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.lead.budget.voucherMessage) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "alert alert-warning text-center"
  }, [_vm._v(_vm._s(_vm.lead.budget.voucherMessage))])]) : _vm._e()]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Plano: *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan),
      expression: "form.plan"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('plan')
    },
    attrs: {
      "name": "plan"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "plan", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.update()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "FREE"
    }
  }, [_vm._v("Gratuito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("Básico")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PREMIUM"
    }
  }, [_vm._v("Premium")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantidade de Alunos: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.studentsQuantity),
      expression: "form.studentsQuantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.studentsQuantity)
    },
    on: {
      "change": function($event) {
        _vm.update()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "studentsQuantity", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('label', [_vm._v("Razão Social: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyName),
      expression: "form.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "companyName"
    },
    domProps: {
      "value": (_vm.form.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', [_vm._v("Nome Fantasia: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', [_vm._v("Nome de Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactName),
      expression: "form.contactName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName"
    },
    domProps: {
      "value": (_vm.form.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactDocument')
    }
  }, [_c('label', [_vm._v("CPF do Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactDocument),
      expression: "form.contactDocument"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          cpf: true
        }
      }),
      expression: "{ rules: { required: true, cpf: true } }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactDocument"
    },
    domProps: {
      "value": (_vm.form.contactDocument)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactDocument", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmailAddress')
    }
  }, [_c('label', [_vm._v("E-mail Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactEmailAddress),
      expression: "form.contactEmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmailAddress"
    },
    domProps: {
      "value": (_vm.form.contactEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactEmailAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('document')
    }
  }, [_c('label', [_vm._v("CNPJ: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##.###.###/####-##'),
      expression: "'##.###.###/####-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.document),
      expression: "form.document"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          cnpj: true
        }
      }),
      expression: "{ rules: { required: true, cnpj: true } }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num",
      "name": "document"
    },
    domProps: {
      "value": (_vm.form.document)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "document", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Telefone fixo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(##)####-####'),
      expression: "'(##)####-####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactPhoneNumber),
      expression: "form.contactPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num"
    },
    domProps: {
      "value": (_vm.form.contactPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactPhoneNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mobilePhoneNumber')
    }
  }, [_c('label', [_vm._v("Telefone celular: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(##)#####-####'),
      expression: "'(##)#####-####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobilePhoneNumber),
      expression: "form.mobilePhoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num",
      "name": "mobilePhoneNumber"
    },
    domProps: {
      "value": (_vm.form.mobilePhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobilePhoneNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('fullAddress')
    }
  }, [_c('label', [_vm._v("Endereço Completo: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fullAddress),
      expression: "form.fullAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fullAddress"
    },
    domProps: {
      "value": (_vm.form.fullAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fullAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('zipcode')
    }
  }, [_c('label', [_vm._v("CEP: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#####-###'),
      expression: "'#####-###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zipcode),
      expression: "form.zipcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num",
      "name": "zipcode",
      "id": "cep"
    },
    domProps: {
      "value": (_vm.form.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "zipcode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('neighborhood')
    }
  }, [_c('label', [_vm._v("Bairro: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.neighborhood),
      expression: "form.neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "neighborhood"
    },
    domProps: {
      "value": (_vm.form.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "neighborhood", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('city')
    }
  }, [_c('label', [_vm._v("Cidade: * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.city),
      expression: "form.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.form.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('state')
    }
  }, [_c('label', [_vm._v("Estado: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "state"
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('country')
    }
  }, [_c('label', [_vm._v("País: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.form.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "country", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logo da Escola:")]), _vm._v(" "), _c('upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*",
      "name": "files",
      "action": ("/api/v1/lead/" + (_vm.lead.id) + "/photo")
    }
  }, [_c('button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Clique para adicionar imagens")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Os logos devem ter 200px de largura e 68px de altura.")])])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('termsOfServiceAgreement')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.termsOfServiceAgreement),
      expression: "form.termsOfServiceAgreement"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "name": "termsOfServiceAgreement"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.termsOfServiceAgreement) ? _vm._i(_vm.form.termsOfServiceAgreement, null) > -1 : (_vm.form.termsOfServiceAgreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.termsOfServiceAgreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "termsOfServiceAgreement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "termsOfServiceAgreement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "termsOfServiceAgreement", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 pull-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("Enviar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Orçamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Declaro que "), _c('b', [_vm._v("li e aceito")]), _vm._v(" os "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("termos de uso e serviço da plataforma Schoolastic")]), _vm._v(".")])
}]}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('activities')], 1)]), _vm._v(" "), (_vm.scheduledHomework) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('homework-scheduled')], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "icon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.pages) ? _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.pages), function(page, index) {
    return _c('li', [(page.link) ? _c('a', {
      attrs: {
        "href": page.link
      }
    }, [_vm._v(_vm._s(page.text))]) : _vm._e(), _vm._v(" "), (!page.link) ? _c('span', [_vm._v(_vm._s(page.text))]) : _vm._e(), _vm._v(" "), (index !== _vm.pages.length - 1) ? _c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "pages": _vm.pages
    }
  }), _vm._v(" "), (_vm.languages) ? _c('available-languages') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "week"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.group
    }
  }, [(_vm.group) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.week),
      expression: "week"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "week",
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.week = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [(_vm.showFirst) ? _c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione uma semana")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.weeks), function(week) {
    return _c('option', {
      domProps: {
        "value": week
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("date")(week.startDate, 'DD/MM/YYYY')) + "\n\t\t\t\t"), _c('span', [_vm._v("à")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("date")(week.endDate, 'DD/MM/YYYY')) + "\n\t\t\t")])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaving-monitor"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Monitor de Saída")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && _vm.paginateCollection.data.length),
      expression: "paginateCollection.data && paginateCollection.data.length"
    }],
    staticClass: "caption-subject bold uppercase pull-left"
  }, [_c('span', [_vm._v("Página " + _vm._s(_vm.paginateCollection.currentPage) + " (")]), _vm._v(" "), (_vm.paginateCollection.total >= 10) ? _c('span', [_vm._v(_vm._s(_vm.paginateCollection.perPage))]) : _vm._e(), _vm._v(" "), (_vm.paginateCollection.total < 10) ? _c('span', [_vm._v(_vm._s(_vm.paginateCollection.total))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("de " + _vm._s(_vm.paginateCollection.total) + " alunos )")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('clock', {
    staticClass: "pull-right clock",
    attrs: {
      "displaySeconds": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && _vm.paginateCollection.data.length),
      expression: "paginateCollection.data && paginateCollection.data.length"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Nome do Aluno")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Quem irá buscar?")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Turma")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Previsão de Chegada")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginateCollection.data), function(student) {
    return _c('tr', {
      staticClass: "has-arrived"
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "25%"
      }
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": student.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(student.student.name))])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "25%"
      }
    }, [(student.delegateToSomeone === false) ? _c('span', [_vm._v(_vm._s(student.responsible.name))]) : _vm._e(), _vm._v(" "), (student.delegateToSomeone === true) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(student.delegatedToName)), _c('br'), _vm._v(" "), _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "text-muted"
    }, [_vm._v("Autorizado por: " + _vm._s(student.responsible.name))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(student.schoolClass.description))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "20%"
      }
    }, [(student.delegatedEstimatedTimeToPickup) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("now")(student.delegatedEstimatedTimeToPickup)))]) : _vm._e(), _vm._v(" "), (student.estimatedArrivedDateTime) ? _c('span', [_vm._v(_vm._s(_vm._f("now")(student.estimatedArrivedDateTime)))]) : _vm._e(), _vm._v(" "), (student.arrivedDateTime) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("CHEGOU")]) : _vm._e(), _vm._v(" "), (!student.delegatedEstimatedTimeToPickup && !student.estimatedArrivedDateTime && !student.arrivedDateTime) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não disponível")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "5%"
      }
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn green-meadow",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeStudentItem(student)
        }
      }
    }, [_vm._v("Aluno liberado")])])])
  }))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && !_vm.paginateCollection.data.length),
      expression: "paginateCollection.data && !paginateCollection.data.length"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info text-center"
  }, [_vm._v("\n\t\t\t\t\t\tAguardando notificação dos pais para liberar saída\n\t\t\t\t\t")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn green-jungle pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveQuestion($event)
      }
    }
  }, [_vm._v("\n\tSalvar\n")])
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mensagem:")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "readMessageContent"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn default btn-xs g pull-left",
    attrs: {
      "href": ""
    }
  }, [_vm._v("1/2000")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-right"
  }, [_c('button', {
    staticClass: "btn green-jungle btn-block",
    attrs: {
      "id": "readMessageSend"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Enviar")])])])
}]}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-block yellow-gold",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.copyHomework(_vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Copiar da turma")])])])
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('theme')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "theme"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.themeModel),
      expression: "themeModel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': _vm.required
      }),
      expression: "{ 'required': required }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "theme",
      "name": "theme",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.themeModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.themes), function(grade) {
    return _c('optgroup', {
      attrs: {
        "label": grade.gradeName
      }
    }, _vm._l((grade.list), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name) + " (" + _vm._s(option.grade.description) + ")")])
    }))
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-2 m-b-0"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false,
      "only-future": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 m-b-0"
  }, [_c('school-theme')], 1), _vm._v(" "), (_vm.model.currentTheme && _vm.model.currentTheme.schoolThemeId) ? _c('div', {
    staticClass: "form-group col-md-3 m-b-0"
  }, [_c('school-class-list', {
    attrs: {
      "label": 'Turma',
      "group": false,
      "by-theme": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 m-b-0"
  }, [_c('div', {
    staticClass: "mt-checkbox-list m-t-20"
  }, [_c('label', {
    staticClass: "mt-checkbox mt-checkbox-outline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.onlyPending),
      expression: "model.onlyPending"
    }],
    attrs: {
      "type": "checkbox",
      "value": "true",
      "name": "onlyPending",
      "id": "onlyPending"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.onlyPending) ? _vm._i(_vm.model.onlyPending, "true") > -1 : (_vm.model.onlyPending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.onlyPending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "onlyPending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "onlyPending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "onlyPending", $$c)
        }
      }
    }
  }), _vm._v("\n\t\t\t\t\tExibir apenas aulas pendentes de planejamento\n\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-md-offset-10 m-b-0"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block yellow-gold m-t-24",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Planejar")])])])])
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-body"
  }, [_c('div', {
    staticClass: "inbox-header"
  }, [_c('h1', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviadas")])]), _vm._v(" "), _c('div', {
    staticClass: "inbox-content"
  }, [_c('filter-inbox', {
    attrs: {
      "context": 'sent'
    }
  }), _vm._v(" "), _c('list')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu-clone"
  }, [_c('page-bar'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Duplicar cardápio")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_vm._v("\n\t\t\t\tVoltar\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [(_vm.mealMenuClone && _vm.mealMenuClone.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "note note-success"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "block"
  }, [_vm._v("Duplicando cardápio")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(_vm.params.recipientGroup, 'RecipientsGroupType')) + "\n\t\t\t\t\t\t\t\t\t"), (_vm.params.recipientGroup !== 'ALL_SCHOOL') ? _c('span', [(_vm.params.recipientGroup === 'PER_LEVEL') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm._f("enum")(_vm.params.level, 'SchoolClassLevelType')) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.params.recipientGroup === 'PER_GRADE') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm._f("enum")(_vm.params.grade.level, 'SchoolClassLevelType')) + " >\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.grade.description) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.params.recipientGroup === 'PER_CLASS') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t(" + _vm._s(_vm.params.schoolClass.schoolClassGrade.description) + " >\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.schoolClass.description) + ")\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t, "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("do periodo de ")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(_vm.params.startDate, 'DD')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("à")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(_vm.params.endDate, 'DD')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(_vm.params.month.value, 'Month')) + "\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.params.year) + "\n\t\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('recipients-group', {
    attrs: {
      "label": 'Selecione a configuração do cardápio',
      "selected": _vm.recipientGroup
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.recipientGroup === 'PER_LEVEL') ? _c('class-level', {
    attrs: {
      "label": 'Selecione um nível de ensino',
      "blacklist": ['Fundamental_2', 'EnsinoMedio']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_GRADE') ? _c('class-grade', {
    attrs: {
      "label": 'Selecione um ano de ensino'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_CLASS') ? _c('school-class', {
    attrs: {
      "label": 'Selecione uma turma',
      "group": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.recipientGroup) ? _c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para qual semana deseja duplicar o cardápio?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('month', {
    attrs: {
      "disabled": !_vm.year,
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('week', {
    attrs: {
      "show-first": false,
      "disabled": !_vm.year || !_vm.month || (_vm.month && _vm.month.index === -1),
      "group": false
    }
  })], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mealMenuClone && _vm.mealMenuClone.length),
      expression: "mealMenuClone && mealMenuClone.length"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-9 col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button",
      "disabled": !_vm.formIsValid()
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])])])])]), _vm._v(" "), (_vm.mealMenuClone && _vm.mealMenuClone.length) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-layout-fixed"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-yellow-gold font-white"
  }, _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(item.clonedDate, 'dddd')) + "\n\t\t\t\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('tr', {
    staticClass: "bg-grey"
  }, _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_c('small', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "f-w-n"
    }, [_vm._v("Duplicar de")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(item.clonedDate, 'DD/MM/YYYY')) + "\n\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.date),
        expression: "item.date"
      }]
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "f-w-n"
    }, [_vm._v("para")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm._f("date")(item.date, 'DD/MM/YYYY')))])])])])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('th', [(item.times.length) ? _c('button', {
      staticClass: "btn btn-xs btn-block red-flamingo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeMealDay($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRemover cardápio\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('td', [_vm._l((item.times), function(meal, index) {
      return _c('div', {
        attrs: {
          "role": "form"
        }
      }, [_c('div', {
        staticClass: "well p-5"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Refeição")])]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.type),
          expression: "meal.type"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "name": "meal-type",
          "disabled": item.isBefore
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(meal, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }],
        attrs: {
          "value": "",
          "selected": ""
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.ENUM.MealTimeType), function(value, index) {
        return _c('option', {
          domProps: {
            "value": index
          }
        }, [_vm._v(_vm._s(value))])
      })], 2)]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Horário")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('##:##'),
          expression: "'##:##'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (meal.time),
          expression: "meal.time"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ({
            rules: {
              required: true,
              regex: /([01]\d|2[0-3]):([0-5]\d)/
            }
          }),
          expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-time",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "time", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Alimento")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.meal),
          expression: "meal.meal"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-meal",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.meal)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "meal", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Bebida e/ou fruta")])]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.beverage),
          expression: "meal.beverage"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-beverage",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.beverage)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "beverage", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group m-b-0"
      }, [_c('button', {
        staticClass: "btn btn-sm btn-block red-mint",
        attrs: {
          "type": "button",
          "disabled": item.isBefore
        },
        on: {
          "click": function($event) {
            _vm.removeItem($index, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Remover refeição")])])])])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isBefore),
        expression: "!item.isBefore"
      }],
      staticClass: "form-group m-b-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-block yellow-gold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Adicionar refeição")])])])], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-9 col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button",
      "disabled": !_vm.formIsValid()
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "portlet light inbox-body"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-bubble font-hide hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-hide bold uppercase"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.messageGroup.subject) + "\n\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.messageGroup.student) ? _c('span', {
    staticClass: "caption-helper"
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno:")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.messageGroup.student.name) + "\n\t\t\t\t\t"), (_vm.messageGroup.student.schoolClass) ? _c('span', [_vm._v("\n\t\t\t\t\t\t(" + _vm._s(_vm.messageGroup.student.schoolClass.description) + ")\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ol', {
    staticClass: "chats"
  }, _vm._l((_vm.messages), function(msg) {
    return _c('li', {
      class: {
        'out': _vm.loggedUserId === msg.from.userId, 'in': _vm.loggedUserId !== msg.from.userId
      }
    }, [_c('img', {
      staticClass: "avatar img-thumbnail",
      attrs: {
        "src": msg.from.photoURL
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(msg.from.name))]), _vm._v(" "), _c('span', {
      staticClass: "datetime"
    }, [_vm._v("às " + _vm._s(_vm._f("date")(msg.sentDateTime, "DD/MM/YYYY HH:mm")))]), _vm._v(" "), _c('strong', {
      staticClass: "body"
    }, [_vm._v(_vm._s(msg.message))]), _vm._v(" "), _c('br'), _vm._v(" "), (msg.usersRead) ? _c('popover', {
      attrs: {
        "placement": "right",
        "title": "Mensagem lida por",
        "width": "350",
        "trigger": "hover"
      }
    }, [_c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "slot": "reference",
        "type": "button"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("enum")(msg.status, 'MessageStatusType')) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
      staticClass: "list-group"
    }, _vm._l((msg.usersRead), function(user, index) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(user.userName) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("em " + _vm._s(_vm._f("date")(user.readDateTime, "DD/MM/YYYY hh:MM:ss")) + ")")])])
    }))]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('form', {
    staticClass: "chat-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-cont emoji-text relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "readMessageContent",
      "placeholder": "Escreva sua mensagem aqui...",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emojiPickerVisible),
      expression: "emojiPickerVisible"
    }],
    staticClass: "absolute",
    attrs: {
      "exclude": ['flags', 'symbols'],
      "i18n": _vm.i18n,
      "title": "Emoji",
      "set": "apple"
    },
    on: {
      "click": _vm.addEmoji
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-cont"
  }, [_c('button', {
    staticClass: "btn green-jungle icn-only",
    attrs: {
      "type": "submit",
      "id": "readMessageSend"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviar")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn green m-t-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.emojiPickerVisible = !_vm.emojiPickerVisible
      }
    }
  }, [_c('emoji', {
    attrs: {
      "emoji": "grinning",
      "size": 15
    }
  }), _vm._v("\n\t\t\t\t\t\t\tEmojis\n\t\t\t\t\t\t")], 1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para usar "), _c('em', [_vm._v("emojis")]), _vm._v(" clique no botão acima.")]), _c('br'), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_c('strong', [_vm._v("Observação:")]), _vm._v(" no navegador os "), _c('em', [_vm._v("emojis")]), _vm._v(" podem aparecer em forma de [], mas ao enviar aparecerá o "), _c('em', [_vm._v("emoji")]), _vm._v(" selecionado.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.messageGroupUsers) ? _c('message-users', {
    attrs: {
      "users": _vm.messageGroupUsers
    }
  }) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.model), function(lessonPlan, lessonPlanIndex) {
    return (_vm.model.length) ? _c('div', {
      staticClass: "portlet box blue-hoki"
    }, [_c('div', {
      staticClass: "portlet-title"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('span', {
      staticClass: "caption-subject bold uppercase"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(lessonPlan.schoolClass.description) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "caption-helper"
    }, [_vm._v(_vm._s(_vm._f("enum")(lessonPlan.schoolClass.level, 'SchoolClassLevelType')))])]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(!_vm.model[lessonPlanIndex].copyIsVisible) ? _c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn white btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleCopy(lessonPlanIndex, true)
        }
      }
    }, [_vm._v("\n\t\t\t\t\tCopiar\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), (_vm.model[lessonPlanIndex].copyIsVisible) ? _c('div', {
      staticClass: "portlet-body"
    }, [_c('lesson-planning-copy', {
      attrs: {
        "index": lessonPlanIndex
      }
    })], 1) : _c('div', {
      staticClass: "portlet-body"
    }, [_c('div', {
      staticClass: "mt-actions"
    }, [_vm._l((lessonPlan.plans), function(plan, planIndex) {
      return (lessonPlan.plans.length) ? _c('div', {
        staticClass: "mt-action"
      }, [_c('div', {
        staticClass: "mt-action-body"
      }, [_c('div', {
        staticClass: "mt-action-row"
      }, [_c('div', {
        staticClass: "mt-action-info"
      }, [_c('div', {
        staticClass: "mt-action-details"
      }, [_c('span', {
        staticClass: "mt-action-author"
      }, [_vm._v(_vm._s(plan.title))]), _vm._v(" "), _c('p', {
        staticClass: "mt-action-desc"
      }, [_vm._v(_vm._s(plan.description))])])]), _vm._v(" "), _c('div', {
        staticClass: "mt-action-buttons"
      }, [_c('div', {
        staticClass: "input-group"
      }, [_c('date-picker', {
        attrs: {
          "type": "date",
          "editable": false,
          "format": "dd/MM/yyyy",
          "clearable": true
        },
        on: {
          "change": function($event) {
            _vm.setPlanDate(plan.date, lessonPlanIndex, plan, planIndex)
          }
        },
        model: {
          value: (plan.date),
          callback: function($$v) {
            _vm.$set(plan, "date", $$v)
          },
          expression: "plan.date"
        }
      })], 1)])])])]) : _vm._e()
    }), _vm._v(" "), (!lessonPlan.plans.length) ? _c('div', {
      staticClass: "mt-action"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Nenhum item cadastrado no plano de aula para esta disciplina.")])]) : _vm._e()], 2)]), _vm._v(" "), (!_vm.model[lessonPlanIndex].copyIsVisible) ? _c('div', {
      staticClass: "portlet-footer with-top-border bg-white p-15"
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-primary green-jungle pull-right",
      attrs: {
        "type": "button",
        "disabled": !lessonPlan.plans || !lessonPlan.plans.length
      },
      on: {
        "click": function($event) {
          _vm.savePlanning(lessonPlanIndex)
        }
      }
    }, [_vm._v("Salvar")])]) : _vm._e()]) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tCaixa de Entrada\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('sidebar-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('message-reply')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno (turma)")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Assunto")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Participantes")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-right"
  }, [_vm._v("Data de envio")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sentMessages), function(message) {
    return _c('router-link', {
      key: message.messageGroup,
      class: {
        'active': message.notRead === 0, 'bold': message.notRead === 1
      },
      attrs: {
        "tag": "tr",
        "to": {
          path: ("/inbox/reply-message/" + (message.messageGroup))
        }
      }
    }, [_c('td', {
      staticClass: "view-message align-middle hidden-xs"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(message.student.name)), _c('br'), _vm._v(" "), (message.student.schoolClass && message.student.schoolClass.description) ? _c('small', [_vm._v("\n\t\t\t\t\t\t\t\tTurma: " + _vm._s(message.student.schoolClass.description) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.subject))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.members))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle text-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(message.dateTime, 'DD/MM/YYYY HH:mm')) + "\n\t\t\t\t\t\t")])])
  })), _vm._v(" "), (_vm.sentMessages.length === 0) ? _c('tfoot', [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNenhuma mensagem enviada\n\t\t\t\t\t\t")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.sentMessages.length > 0) ? _c('pagination', {
    attrs: {
      "layout": "prev, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box blue"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-coffee",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Água e/ou suco")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body text-center p-b-0"
  }, [_c('div', {
    staticClass: "mt-radio-inline"
  }, _vm._l((_vm.quantityType), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "water-quantity"
      },
      domProps: {
        "value": key,
        "checked": key === _vm.water
      },
      on: {
        "change": _vm.putAgendaWater
      }
    }), _vm._v("\n\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t"), _c('span')])
  }))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tCaixa de Entrada\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('sidebar-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('message-received')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "StudentQuestion"
    }
  }, [_c('student-question')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-male",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Urina")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("O aluno urinou hoje?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "urine",
      "value": "1"
    },
    domProps: {
      "checked": _vm.piss == '1'
    },
    on: {
      "change": _vm.putAgendaUrine
    }
  }), _vm._v("\n\t\t\t\t\tSim\n\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "urine",
      "value": "0"
    },
    domProps: {
      "checked": _vm.piss == '0'
    },
    on: {
      "change": _vm.putAgendaUrine
    }
  }), _vm._v("\n\t\t\t\t\tNão\n\t\t\t\t\t"), _c('span')])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.regularMedicines && _vm.regularMedicines.length <= 0) ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação programada")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body tasks-widget"
  }, [_c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center m-b-0"
  }, [_vm._v("Não há medicação programada para o aluno(a) cadastrada pelos responsáveis.")])])]) : _vm._e(), _vm._v(" "), (_vm.regularMedicines && _vm.regularMedicines.length) ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação programada")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body tasks-widget"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.regularMedicines), function(medicine, index) {
    return _c('tr', {
      staticClass: "font-grey-cascade"
    }, [(medicine.isTaken == 1) ? _c('td', [_c('i', {
      staticClass: "fa fa-check font-green",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Ministrada")]) : _vm._e(), _vm._v(" "), (medicine.isTaken == 0 && _vm.getTimeDiff(medicine.time) > 0) ? _c('td', [_c('i', {
      staticClass: "fa fa-exclamation-triangle font-red",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Atrasada - " + _vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), (medicine.isTaken == 0 && _vm.getTimeDiff(medicine.time) <= 0) ? _c('td', [_c('i', {
      staticClass: "fa fa-calendar-minus-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Programada para " + _vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))])])
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn btn-circle btn-default",
    attrs: {
      "href": "#/medicine"
    }
  }, [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v("\n\t\t\t\tIr para Medicações\n\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Medicação - Dosagem")])])])
}]}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-7"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Filtrar pelo aluno:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student),
      expression: "student"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nome do aluno",
      "type": "text"
    },
    domProps: {
      "value": (_vm.student)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.student = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Filtrar por data:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "format": "dd/MM/yyyy",
      "clearable": false
    },
    model: {
      value: (_vm.datepicker.selected),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "selected", $$v)
      },
      expression: "datepicker.selected"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn yellow-gold btn-block m-t-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filter
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Filtrar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
}]}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.context !== 'exclusiveHomework') ? _c('section', [_c('accordion', {
    attrs: {
      "type": "info"
    }
  }, _vm._l((_vm.themes), function(theme, index) {
    return _c('panel', {
      key: theme.id,
      attrs: {
        "type": "default"
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "bold font-green uppercase"
    }, [_vm._v(_vm._s(theme.theme.name))]), _vm._v(" "), (theme.dueDate && theme.title) ? _c('span', {
      staticClass: "font-grey-cascade pull-right"
    }, [_vm._v("Data de entrega: " + _vm._s(_vm._f("date")(theme.dueDate, 'DD/MM/YYYY')))]) : _vm._e()]), _vm._v(" "), _c('form', {
      attrs: {
        "role": "form",
        "autocomplete": "off"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-title"
      }
    }, [_vm._v("Título:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (theme.title),
        expression: "theme.title"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "theme-title",
        "name": "theme-title",
        "disabled": theme.readOnly === 1
      },
      domProps: {
        "value": (theme.title)
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(theme, "title", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-duedate"
      }
    }, [_vm._v("Data de entrega:")]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    })]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "type": "date",
        "id": "theme-duedate",
        "name": "theme-duedate",
        "editable": false,
        "format": "dd/MM/yyyy",
        "clearable": false,
        "disabled": theme.readOnly === 1
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        }
      },
      model: {
        value: (theme.dueDate),
        callback: function($$v) {
          _vm.$set(theme, "dueDate", $$v)
        },
        expression: "theme.dueDate"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-8"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-homework"
      }
    }, [_vm._v("Descrição:")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (theme.homework),
        expression: "theme.homework"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "theme-homework",
        "name": "theme-homework",
        "rows": "5",
        "maxlength": "1000",
        "disabled": theme.readOnly === 1
      },
      domProps: {
        "value": (theme.homework)
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(theme, "homework", $event.target.value)
        }
      }
    }), _vm._v(" "), (theme.publishedDateTime) ? _c('small', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Publicada às")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(theme.publishedDateTime, 'DD/MM/YYYY HH:mm')) + "\n\n\t\t\t\t\t\t\t\t"), (theme.publishedUser && theme.publishedUser.name) ? _c('span', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("por")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(theme.publishedUser.name) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('homework-save', {
      staticClass: "m-t-24",
      attrs: {
        "disabled": theme.readOnly === 1 || _vm.errors.items.length > 0
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('homework-publish', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.getHomeworkId && theme.creationDateTime && !theme.publishedDateTime),
        expression: "getHomeworkId && theme.creationDateTime && !theme.publishedDateTime"
      }],
      staticClass: "m-t-24",
      attrs: {
        "disabled": theme.readOnly === 1 || _vm.errors.items.length > 0,
        "themeId": theme.theme.schoolThemeId
      }
    })], 1)])])])
  })), _vm._v(" "), (_vm.getHomeworkId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('homework-publish-all')], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.context === 'exclusiveHomework') ? _c('section', [_c('accordion', {
    attrs: {
      "type": "info"
    }
  }, _vm._l((_vm.exclusiveThemes.themes), function(theme, index) {
    return _c('panel', {
      key: theme.id,
      attrs: {
        "type": "default"
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "bold font-green uppercase"
    }, [_vm._v(_vm._s(theme.theme.name))]), _vm._v(" "), (theme.dueDate && theme.title) ? _c('span', {
      staticClass: "font-grey-cascade pull-right"
    }, [_vm._v("Data de entrega: " + _vm._s(_vm._f("date")(theme.dueDate, 'DD/MM/YYYY')))]) : _vm._e()]), _vm._v(" "), _c('form', {
      attrs: {
        "role": "form",
        "autocomplete": "off"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-title"
      }
    }, [_vm._v("Título:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (theme.title),
        expression: "theme.title"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "theme-title",
        "name": "theme-title",
        "disabled": theme.readOnly === 1
      },
      domProps: {
        "value": (theme.title)
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(theme, "title", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-duedate"
      }
    }, [_vm._v("Data de entrega:")]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    })]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "type": "date",
        "id": "theme-duedate",
        "name": "theme-duedate",
        "editable": false,
        "format": "dd/MM/yyyy",
        "clearable": false,
        "disabled": theme.readOnly === 1
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        }
      },
      model: {
        value: (theme.dueDate),
        callback: function($$v) {
          _vm.$set(theme, "dueDate", $$v)
        },
        expression: "theme.dueDate"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-8"
    }, [_c('label', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      attrs: {
        "for": "theme-homework"
      }
    }, [_vm._v("Descrição:")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (theme.homework),
        expression: "theme.homework"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "theme-homework",
        "name": "theme-homework",
        "rows": "5",
        "maxlength": "1000",
        "disabled": theme.readOnly === 1
      },
      domProps: {
        "value": (theme.homework)
      },
      on: {
        "change": function($event) {
          _vm.putHomeworkItem(index, theme)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(theme, "homework", $event.target.value)
        }
      }
    }), _vm._v(" "), (theme.publishedDateTime) ? _c('small', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Publicada às")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(theme.publishedDateTime, 'DD/MM/YYYY HH:mm')) + "\n\n\t\t\t\t\t\t\t\t"), (theme.publishedUser && theme.publishedUser.name) ? _c('span', [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("por")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(theme.publishedUser.name) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('homework-copy', {
      staticClass: "m-t-24",
      attrs: {
        "index": index,
        "disabled": theme.readOnly === 1
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('homework-save', {
      staticClass: "m-t-24",
      attrs: {
        "context": 'exclusiveHomework',
        "disabled": theme.readOnly === 1 || _vm.errors.items.length > 0
      }
    })], 1)])])])
  }))], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1'),
      expression: "classLevel === 'Bercario' || classLevel === 'Infantil' || classLevel === 'Fundamental_1'"
    }],
    staticClass: "portlet box purple"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-paint-brush",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Atividades")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.activities && _vm.activities.lenght > 0) ? _c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Atividade")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(activity, index) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(activity.activity))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Classifique a participatividade do aluno na aula hoje:")]), _vm._v(" "), _c('div', {
    staticClass: "mt-radio-inline"
  }, _vm._l((_vm.ParticipationType), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline m-b-0"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "Participation"
      },
      domProps: {
        "value": key,
        "checked": key === _vm.participation
      },
      on: {
        "change": _vm.putAgendaParticipation
      }
    }), _vm._v("\n\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t"), _c('span')])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-toolbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$language.current),
      expression: "$language.current"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$language, "current", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$language.available), function(language, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(language))])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onlySelect) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classList),
      expression: "classList"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "class-list",
      "name": "class-list",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "filter": ''
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.classList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.defaultValueText))]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.description))])
  })], 2) : _c('div', [(!_vm.multiple) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "class-list"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'input-group': _vm.group
    }
  }, [(_vm.group) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classList),
      expression: "classList"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "class-list",
      "name": "class-list",
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.classList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.defaultValueText))]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.description))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.multiple) ? _c('div', [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Turmas:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "label": "description",
      "disabled": _vm.disabled,
      "options": _vm.list,
      "placeholder": "Selecione as turmas:"
    },
    on: {
      "input": _vm.changed
    },
    model: {
      value: (_vm.schoolClass),
      callback: function($$v) {
        _vm.schoolClass = $$v
      },
      expression: "schoolClass"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-upload"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Álbum "), (_vm.dataUpload.title) ? _c('span', [_vm._v("- " + _vm._s(_vm.dataUpload.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "portlet light m-t-24"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm font-grey-cascade",
    attrs: {
      "to": "/gallery"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Voltar")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nome do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataUpload.title),
      expression: "dataUpload.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome do álbum"
    },
    domProps: {
      "value": (_vm.dataUpload.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataUpload, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Descrição do álbum:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataUpload.description),
      expression: "dataUpload.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite a descrição do álbum"
    },
    domProps: {
      "value": (_vm.dataUpload.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataUpload, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "assign-photo"
    }
  }, [_c('h5', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "m-t-20"
  }, [_vm._v("A quem você deseja atribuir o álbum?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Selecione:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewersGalleryType),
      expression: "viewersGalleryType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "viewersGallery",
      "disabled": _vm.album.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.viewersGalleryType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ENUM.viewersGalleryType), function(value, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(value))])
  }))]), _vm._v(" "), (_vm.viewersGalleryType == 'SCHOOL_CLASS') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('class-list', {
    attrs: {
      "multiple": true,
      "label": 'Turmas:',
      "context": 'gallery',
      "disabled": _vm.album.id ? true : false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.viewersGalleryType == 'STUDENT') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('class-list', {
    attrs: {
      "label": 'Turma:',
      "multiple": false,
      "context": 'gallery',
      "disabled": _vm.album.id ? true : false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.viewersGalleryType == 'STUDENT') ? _c('students', {
    class: 'col-md-4',
    attrs: {
      "context": 'gallery',
      "imglist": false,
      "disabled": _vm.album.id ? true : false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!(_vm.album.id)) ? _c('button', {
    staticClass: "btn yellow-gold m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createAlbum(_vm.dataUpload)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criar álbum")])]) : _vm._e(), _vm._v(" "), (_vm.album.id) ? _c('button', {
    staticClass: "btn yellow-gold m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createAlbum(_vm.dataUpload)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar álbum")])]) : _vm._e()]), _vm._v(" "), (_vm.album.id) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.album.status == 'APPROVED') ? _c('button', {
    staticClass: "btn red m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.unpublish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar todas as fotos")])]) : _vm._e(), _vm._v(" "), (_vm.album.status != 'APPROVED') ? _c('button', {
    staticClass: "btn green-jungle m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.publish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas as fotos")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body m-t-24"
  }, [(_vm.album.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": ("/api/v1/gallery/user/" + (_vm.getLoggedUser.id)),
      "data": _vm.dataUploadStringify(),
      "on-success": _vm.upload,
      "name": "files",
      "multiple": "",
      "accept": "image/*"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v("Arraste ou "), _c('em', [_vm._v("clique para adicionar imagens")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Recomendamos que sejam utilizadas imagens menores que 500kb para que não haja lentidão no carregamento.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 pull-left"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Fotos")])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn green-jungle m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar fotos selecionadas")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn red m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unpublishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar fotos selecionadas")])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('a', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade",
    on: {
      "click": _vm.selectAllPhotos
    }
  }, [_vm._v("Selecionar todas as fotos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('a', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade",
    on: {
      "click": _vm.unselectAllPhotos
    }
  }, [_vm._v("Remover seleção das fotos")])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "row",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".item"
    }
  }, _vm._l((_vm.album.photos), function(photo, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "col-md-6 card item"
    }, [_c('card', {
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 mt-element-ribbon m-b-0"
    }, [(!photo.publishedDateTime) ? _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "ribbon ribbon-color-danger"
    }, [_vm._v("NÃO PUBLICADA")]) : _vm._e(), _vm._v(" "), (photo.publishedDateTime) ? _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "ribbon ribbon-color-success"
    }, [_vm._v("Publicada às " + _vm._s(_vm._f("date")(photo.publishedDateTime, "HH:mm - DD/MM/YYYY")))]) : _vm._e(), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "row p-15"
    }, [_c('div', {
      staticClass: "col-md-1 form-group"
    }, [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-single mt-checkbox-outline"
    }, [_c('input', {
      staticClass: "checkboxes",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isChecked(photo.id)
      },
      on: {
        "click": function($event) {
          _vm.selectPhotos($event, photo)
        }
      }
    }), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('a', {
      attrs: {
        "href": photo.fileURL
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": photo.thumbnailURL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7 form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (photo.title),
        expression: "photo.title"
      }],
      staticClass: "form-control m-b-10",
      attrs: {
        "type": "text",
        "placeholder": "Digite o título da foto"
      },
      domProps: {
        "value": (photo.title)
      },
      on: {
        "change": function($event) {
          _vm.changeInfoPhoto(photo.id, photo.title, photo.description)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(photo, "title", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (photo.description),
        expression: "photo.description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Digite a descrição da foto"
      },
      domProps: {
        "value": (photo.description)
      },
      on: {
        "change": function($event) {
          _vm.changeInfoPhoto(photo.id, photo.title, photo.description)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(photo, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('a', {
      attrs: {
        "title": "Excluir foto"
      },
      on: {
        "click": function($event) {
          _vm.deletePhoto(photo.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash font-red",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row m-t-25"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn green-jungle m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar fotos selecionadas")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn red m-b-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.unpublishPhotoItem
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar fotos selecionadas")])])])]) : _vm._e(), _vm._v(" "), (_vm.album.photos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 pull-rigth"
  }, [(_vm.album.status == 'APPROVED') ? _c('button', {
    staticClass: "btn red m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.unpublish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Despublicar todas as fotos")])]) : _vm._e(), _vm._v(" "), (_vm.album.status != 'APPROVED') ? _c('button', {
    staticClass: "btn green-jungle m-t-24 pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.publish(_vm.album.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas as fotos")])]) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('restocking'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('observation')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.agenda.creationUser) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.agenda.creationUser.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("no dia")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("em " + _vm._s(_vm._f("date")(_vm.agenda.creationDateTime, 'DD/MM/YYYY HH:mm:ss')))])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.agenda.updateUserLog) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, _vm._l((_vm.agenda.updateUserLog), function(log) {
    return (log.schoolUser && log.dateTime) ? _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(log.schoolUser.name) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("em " + _vm._s(_vm._f("date")(log.dateTime, 'DD/MM/YYYY HH:mm:ss')))])]) : _vm._e()
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.agenda.publishedUser) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.agenda.publishedUser.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("no dia")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("em " + _vm._s(_vm._f("date")(_vm.agenda.publishedDateTime, 'DD/MM/YYYY HH:mm')))])])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('label', [_vm._v("Quantas fraldas o aluno utilizou hoje?")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "Exemplo: 1"
    },
    domProps: {
      "value": _vm.diapersQuantity
    },
    on: {
      "change": _vm.putAgendaDiaperQuantity
    }
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-tint",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\tFraldas\n\t\t")])])
}]}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'container-fluid': _vm.isIframe, 'container': !_vm.isIframe
    },
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1') ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("O aluno compareceu na escola hoje?")]), _vm._v(" "), _c('div', _vm._l((_vm.presence), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "presence"
      },
      domProps: {
        "value": key,
        "checked": key === _vm.stdPresence
      },
      on: {
        "change": _vm.putAgendaPresence
      }
    }), _vm._v(_vm._s(value) + "\n\t\t\t"), _c('span')])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.onlySelect) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classGradeModel),
      expression: "classGradeModel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': _vm.required
      }),
      expression: "{ 'required': required }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "class-level",
      "name": "class-level",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.classGradeModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.defaultValueText))]), _vm._v(" "), _vm._l((_vm.classGradeList), function(group) {
    return _c('optgroup', {
      attrs: {
        "label": group.gradeName
      }
    }, _vm._l((group.list), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.description))])
    }))
  })], 2) : _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('class-level')
    }
  }, [(_vm.showLabel) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "class-level"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classGradeModel),
      expression: "classGradeModel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': _vm.required
      }),
      expression: "{ 'required': required }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "class-level",
      "name": "class-level",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.classGradeModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.defaultValueText))]), _vm._v(" "), _vm._l((_vm.classGradeList), function(group) {
    return _c('optgroup', {
      attrs: {
        "label": group.gradeName
      }
    }, _vm._l((group.list), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.description))])
    }))
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.context !== 'exclusiveHomework') ? _c('div', [_c('button', {
    staticClass: "btn btn-block green-jungle",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.saveHomeworks
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])]) : _vm._e(), _vm._v(" "), (_vm.context === 'exclusiveHomework') ? _c('div', [_c('button', {
    staticClass: "btn btn-block green-jungle",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addExclusiveHomeworks
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('recipients-group')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "recipients-group"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipientGroup),
      expression: "recipientGroup"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': _vm.required
      }),
      expression: "{ 'required': required }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "recipients-group",
      "name": "recipients-group",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.recipientGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.ENUM.RecipientsGroupType), function(option, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(option))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box purple"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Observações")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body clearfix"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "eventual-medication-notes",
      "name": "eventual-medication-notes",
      "rows": "6",
      "maxlength": "1000"
    },
    domProps: {
      "value": _vm.observation
    },
    on: {
      "change": _vm.putAgendaObservation
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 m-b-0"
  }, [_c('school-class', {
    attrs: {
      "label": 'Turma',
      "group": false,
      "default-value-text": 'Selecione uma turma'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-md-offset-6 m-b-0"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block yellow-gold m-t-24",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Filtrar")])])])])
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda"
  }, [_c('page-bar'), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-8"
  }, [_c('school-class-list', {
    attrs: {
      "label": 'Qual turma irá preparar a agenda?',
      "value": _vm.agenda.class,
      "required": false,
      "filter": '0'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Qual o dia da agenda?")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "format": "dd/MM/yyyy",
      "clearable": false
    },
    on: {
      "change": _vm.setAgendaDate
    },
    model: {
      value: (_vm.datepicker.selected),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "selected", $$v)
      },
      expression: "datepicker.selected"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classes.selected.schoolClassId),
      expression: "classes.selected.schoolClassId"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('class-name', {
    class: 'pull-left'
  }), _vm._v(" "), _c('create-homework-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'),
      expression: "classLevel === 'Infantil' || classLevel === 'Fundamental_1' || classLevel === 'Fundamental_2' || classLevel === 'EnsinoMedio'"
    }],
    class: 'pull-right'
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "portlet light no-margin",
    attrs: {
      "id": "homework-list"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.homeworkVisible),
      expression: "homeworkVisible"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'),
      expression: "classLevel === 'Infantil' || classLevel === 'Fundamental_1' || classLevel === 'Fundamental_2' || classLevel === 'EnsinoMedio'"
    }],
    staticClass: "portlet light no-margin"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cadastro de lições de casa:")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("OBS.: As lições de casa salvas serão replicadas para todos os alunos.")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group"
  }, [_c('create-homework-theme')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-details"
  }, [_c('h4', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Selecione o aluno que deseja preencher a agenda:")]), _vm._v(" "), _c('students', {
    class: 'no-margin',
    attrs: {
      "context": 'agenda',
      "imglist": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "height30"
  }, [(_vm.agenda.agenda.status !== 'NOT_CREATED') ? _c('button', {
    staticClass: "btn green-jungle pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publishAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar todas agendas")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student.studentId),
      expression: "student.studentId"
    }],
    staticClass: "portlet light",
    attrs: {
      "id": "agenda-details"
    }
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('student-name')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6 border-left"
  }, [_c('student-presence')], 1), _vm._v(" "), (_vm.presence !== 'ABSENT') ? _c('div', {
    staticClass: "col-md-6 col-xs-12 text-right"
  }, [_c('student-humor')], 1) : _vm._e()])]), _vm._v(" "), (_vm.presence !== 'ABSENT') ? _c('div', {
    staticClass: "portlet-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('agenda-editors')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('agenda-viewers')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr'), _vm._v(" "), _c('tabs', {
    model: {
      value: (_vm.activeTabs),
      callback: function($$v) {
        _vm.activeTabs = $$v
      },
      expression: "activeTabs"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Saúde"
    }
  }, [_c('health')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Alimentação",
      "disabled": _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'
    }
  }, [_c('alimentation')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Atividades & Lição de casa"
    }
  }, [_c('activities')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Lição de casa exclusiva",
      "disabled": _vm.classLevel === 'Bercario'
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info m-b-20"
  }, [_vm._v("As lições de casa cadastradas abaixo sobrescreverão a lição cadastrada para a turma do aluno.")]), _vm._v(" "), _c('create-homework-theme', {
    attrs: {
      "context": 'exclusiveHomework'
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Questões para Indicadores",
      "disabled": _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio'
    }
  }, [_c('questions')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Outros"
    }
  }, [_c('others')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Mensagens"
    }
  }, [_c('highlight')], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pull-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-save pull-right m-r-100"
  }, [_c('button', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]), _vm._v(" "), (!(_vm.agenda.agenda.status === 'NOT_CREATED' || _vm.agenda.agenda.status === 'READED' || _vm.agenda.agenda.status === 'SENT' || _vm.agenda.agenda.status === 'APPROVED')) ? _c('button', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.publish
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicar")])]) : _vm._e()])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block green-jungle",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.publishHomeworks
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\tPublicar\n\t")])])
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('label', [_vm._v("Quantos banhos o aluno tomou hoje?")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "Exemplo: 1"
    },
    domProps: {
      "value": _vm.bathsQuantity
    },
    on: {
      "change": _vm.putAgendaBathQuantity
    }
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-bath",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\tBanhos\n\t\t")])])
}]}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Planejamento de aula")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('planning-filter')], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.schoolClassLessonPlan.length) ? _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('planning')], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.imglist) ? _c('div', {
    staticClass: "students-list",
    class: _vm.className
  }, [(!_vm.students.length) ? _c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\tEsta turma não possui nenhum aluno\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.students.length) ? _c('ul', {
    staticClass: "general-item-list list-unstyled row"
  }, _vm._l((_vm.students), function(student) {
    return _c('li', {
      key: student.id,
      staticClass: "item col-md-3 col-sm-6 col-xs-6"
    }, [_c('a', {
      staticClass: "btn btn-block btn-link btn-list p-10 relative",
      class: {
        'active': _vm.currentStudent.studentId === student.studentId
      },
      on: {
        "click": function($event) {
          _vm.setCurrentStudent(student)
        }
      }
    }, [_c('img', {
      staticClass: "item-pic rounded student-picture-list",
      attrs: {
        "width": "35px",
        "height": "35px",
        "src": student.photoURL
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "truncate font-grey-gallery"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(student.name.toLowerCase()) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('small', {
      staticClass: "absolute",
      class: _vm.getStatusLabelColor(student.status)
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("agendaStatus")(student.status)) + "\n\t\t\t\t\t")])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.imglist) ? _c('div', [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Alunos:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "disabled": _vm.disabled,
      "label": "name",
      "options": _vm.students,
      "value": _vm.students,
      "placeholder": "Selecione os estudantes:"
    },
    on: {
      "input": function($event) {
        _vm.setCurrentStudent(_vm.student)
      }
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet portlet-participants box grey-cascade"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped m-b-0"
  }, [_c('tbody', _vm._l((_vm.users), function(mgu) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(mgu.user.name))])])
  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group m-b-0"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "for": "participant"
    }
  }, [_vm._v("Adicionar participante")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newParticipant),
      expression: "newParticipant"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "participant",
      "id": "participant",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newParticipant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.participants), function(participant, index) {
    return _c('optgroup', {
      attrs: {
        "label": participant.title
      }
    }, _vm._l((participant.list), function(value) {
      return _c('option', {
        domProps: {
          "value": value.userId
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(value.formatedName) + "\n\t\t\t\t\t\t\t")])
    }))
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdicionar\n\t\t\t\t\t\t")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Participantes")])])
}]}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-male",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Evacuação")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addEvacuationItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 col-xs-6",
    class: {
      'has-error': _vm.errors.has('evacuation-shift')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "evacuation-shift"
    }
  }, [_vm._v("Em qual turno o aluno evacuou?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evacuation.shift),
      expression: "evacuation.shift"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "evacuation-shift",
      "name": "evacuation-shift"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.evacuation, "shift", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.completionStatus(_vm.evacuation)
      }]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dayShiftType), function(value, shift) {
    return _c('option', {
      domProps: {
        "value": shift
      }
    }, [_vm._v(_vm._s(value))])
  }), _vm._v("1\n\t\t\t\t\t")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-xs-6",
    class: {
      'has-error': _vm.errors.has('evacuation-quantity')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "evacuation-quantity"
    }
  }, [_vm._v("Quantas vezes o aluno evacuou?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evacuation.quantity),
      expression: "evacuation.quantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "evacuation-quantity",
      "min": "1",
      "max": "99",
      "name": "evacuation-quantity",
      "placeholder": "Exemplo: 1"
    },
    domProps: {
      "value": (_vm.evacuation.quantity)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.evacuation)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.evacuation, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8 col-xs-12",
    class: {
      'has-error': _vm.errors.has('evacuation-evacuation')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "evacuation-evacuation"
    }
  }, [_vm._v("Qual a consistência da evacuação?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-radio-inline p-0"
  }, _vm._l((_vm.AgendaEvacuationType), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.evacuation.evacuation),
        expression: "evacuation.evacuation"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "id": "evacuation-evacuation",
        "name": "evacuation-evacuation"
      },
      domProps: {
        "value": key,
        "checked": _vm._q(_vm.evacuation.evacuation, key)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.evacuation, "evacuation", key)
        }, function($event) {
          _vm.completionStatus(_vm.evacuation)
        }]
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t"), _c('span')])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-link m-t-15",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.formReset
    }
  }, [_c('small', [_vm._v("Limpar")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn green m-t-15",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAdicionar\n\t\t\t\t\t\t\t")])])])])])]), _vm._v(" "), (_vm.evacuations && _vm.evacuations.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-info p-5"
  }, [_vm._v("\n\t\t\t\t\tInclusões feitas para um mesmo turno e de mesma consistência serão unificadas.\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Turno que evacuou")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Consistência")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Vezes que evacuou")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.evacuations), function(evacuation, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("enum")(evacuation.shift, 'DayShiftType')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("enum")(evacuation.evacuation, 'AgendaEvacuationType')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(evacuation.quantity))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editEvacuationItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteEvacuationItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Cardápio")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cadastro comum para")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('recipients-group', {
    attrs: {
      "label": 'Selecione a configuração do cardápio'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.recipientGroup === 'PER_LEVEL') ? _c('class-level', {
    attrs: {
      "label": 'Selecione o nível de ensino',
      "blacklist": ['Fundamental_2', 'EnsinoMedio']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_GRADE') ? _c('class-grade', {
    attrs: {
      "label": 'Selecione o ano de ensino'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recipientGroup === 'PER_CLASS') ? _c('school-class', {
    attrs: {
      "label": 'Selecione a turma',
      "group": false
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.recipientGroup) ? _c('fieldset', [_c('legend', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Para qual semana será criado o cardápio?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('year', {
    attrs: {
      "label": 'Ano letivo',
      "group": false,
      "with-next-year": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('month', {
    attrs: {
      "disabled": !_vm.year,
      "group": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('week', {
    attrs: {
      "disabled": !_vm.year || !_vm.month || (_vm.month && _vm.month.index === -1),
      "group": false
    }
  })], 1)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mealMenu && _vm.mealMenu.length),
      expression: "mealMenu && mealMenu.length"
    }],
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Os cardápio respeitam a seguinte ordem: Turma > Ano de Ensino > Nível de Ensino > Toda escola.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-block purple",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.duplicate
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Duplicar")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-block yellow-gold",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.showMonthly
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Visão mensal")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "m-t-5 m-b-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [(_vm.isEditMode) ? _c('a', {
    staticClass: "btn red-mint",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.editMode(false)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cancelar")])]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('a', {
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.editMode
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.mealMenu && _vm.mealMenu.length) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-layout-fixed"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-yellow-gold font-white"
  }, _vm._l((_vm.mealMenu), function(item, $index) {
    return _c('th', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "display-block"
    }, [_vm._v(_vm._s(_vm._f("date")(item.date, 'dddd')))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("date")(item.date, 'DD/MM/YYYY')))]), _vm._v(" "), _c('tooltip', {
      attrs: {
        "popper-class": "font-green-jungle",
        "content": "Cardápio disponível na agenda do aluno",
        "placement": "bottom"
      }
    }, [(item.id) ? _c('button', {
      staticClass: "btn btn-xs yellow-gold pull-left",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-check-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])], 1)
  })), _vm._v(" "), (_vm.isEditMode) ? _c('tr', _vm._l((_vm.mealMenu), function(item, $index) {
    return _c('th', [(item.id) ? _c('button', {
      staticClass: "btn btn-xs btn-block red-flamingo",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeMealDay(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tRemover cardápio\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.mealMenuClone), function(item, $index) {
    return _c('td', [_vm._l((item.times), function(meal, index) {
      return _c('div', {
        attrs: {
          "role": "form"
        }
      }, [_c('div', {
        staticClass: "well p-5"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Refeição")])]), _vm._v(" "), (_vm.isEditMode) ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.type),
          expression: "meal.type"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "name": "meal-type",
          "disabled": item.isBefore
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(meal, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }],
        attrs: {
          "value": "",
          "selected": ""
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.ENUM.MealTimeType), function(value, index) {
        return _c('option', {
          domProps: {
            "value": index
          }
        }, [_vm._v(_vm._s(value))])
      })], 2) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(_vm._f("enum")(meal.type, 'MealTimeType') || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Horário")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('##:##'),
          expression: "'##:##'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (meal.time),
          expression: "meal.time"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ({
            rules: {
              required: true,
              regex: /([01]\d|2[0-3]):([0-5]\d)/
            }
          }),
          expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-time",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.time)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "time", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.time || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Alimento")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.meal),
          expression: "meal.meal"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-meal",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.meal)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "meal", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.meal || '-'))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "control-label"
      }, [_c('small', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Bebida e/ou fruta")])]), _vm._v(" "), (_vm.isEditMode) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (meal.beverage),
          expression: "meal.beverage"
        }],
        staticClass: "form-control input-sm",
        attrs: {
          "type": "text",
          "name": "meal-beverage",
          "disabled": item.isBefore
        },
        domProps: {
          "value": (meal.beverage)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(meal, "beverage", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('p', {
        staticClass: "form-control-static"
      }, [_vm._v(_vm._s(meal.beverage || '-'))]) : _vm._e()]), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
        staticClass: "form-group m-b-0"
      }, [_c('button', {
        staticClass: "btn btn-sm btn-block red-mint",
        attrs: {
          "type": "button",
          "disabled": item.isBefore
        },
        on: {
          "click": function($event) {
            _vm.removeItem($index, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }]
      }, [_vm._v("Remover refeição")])])]) : _vm._e()])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEditMode && !item.isBefore),
        expression: "isEditMode && !item.isBefore"
      }],
      staticClass: "form-group m-b-0"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-block yellow-gold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Adicionar refeição")])])])], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-md-offset-9"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [(_vm.isEditMode) ? _c('a', {
    staticClass: "btn red-mint",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.editMode(false)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Cancelar")])]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode) ? _c('a', {
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.editMode
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('a', {
    staticClass: "btn green-jungle",
    attrs: {
      "type": "button",
      "role": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Salvar")])]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\tCardápios de datas passadas não podem ser editados.\n\t\t\t\t\t\t")])
}]}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "portlet light m-b-0"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Filtro")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-circle btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("\n\t\t\t\t\tLimpar filtro\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.studentName),
      expression: "filter.studentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter.studentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "studentName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Participante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.memberName),
      expression: "filter.memberName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter.memberName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "memberName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "format": "dd/MM/yyyy",
      "clearable": false
    },
    model: {
      value: (_vm.filter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.filter, "startDate", $$v)
      },
      expression: "filter.startDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Data final")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "format": "dd/MM/yyyy",
      "clearable": false
    },
    model: {
      value: (_vm.filter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.filter, "endDate", $$v)
      },
      expression: "filter.endDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Assunto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.search),
      expression: "filter.search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 form-group"
  }, [(_vm.context === 'received') ? _c('label', {
    staticClass: "mt-checkbox m-t-24 mt-checkbox-single mt-checkbox-outline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.onlyNotReadedMessages),
      expression: "filter.onlyNotReadedMessages"
    }],
    staticClass: "checkboxes",
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter.onlyNotReadedMessages) ? _vm._i(_vm.filter.onlyNotReadedMessages, null) > -1 : _vm._q(_vm.filter.onlyNotReadedMessages, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filter.onlyNotReadedMessages,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filter, "onlyNotReadedMessages", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filter, "onlyNotReadedMessages", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filter, "onlyNotReadedMessages", $$c)
        }
      }
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\tApenas mensagens não lidas\n\t\t\t\t\t\t\t\t"), _c('span')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 form-group"
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-block yellow-gold m-t-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filterMessage
    }
  }, [_vm._v("Buscar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agenda.acknowledge) ? _c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-block blue-soft",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Visualizado por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, _vm._l((_vm.agenda.acknowledge), function(log) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t" + _vm._s(log.responsible.name) + " (" + _vm._s(_vm._f("date")(log.acknowledgeDateTime, 'DD/MM/YYYY HH:mm')) + ")\n\t\t")])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio') ? _c('div', {
    staticClass: "portlet box purple"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Lições pendentes")]), _vm._v(" "), (_vm.scheduledHomework && _vm.scheduledHomework.date) ? _c('span', [_vm._v("\n\t\t\t\t("), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("até dia")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.scheduledHomework.date, 'DD/MM/YYYY')) + ")\n\t\t\t")]) : _vm._e()])]), _vm._v(" "), (!_vm.scheduledHomework) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center m-b-0"
  }, [_vm._v("Não há lições pendentes de entrega!")])]) : _vm._e(), _vm._v(" "), (_vm.scheduledHomework) ? _c('div', {
    staticClass: "portlet-body p-b-0"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover text-center"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center align-middle"
  }, [_vm._v("Disciplina")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center align-middle"
  }, [_vm._v("Título da lição")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center align-middle"
  }, [_vm._v("Data programada para entrega")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center align-middle"
  }, [_vm._v("Entregue?")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.scheduledHomework), function(homework, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-uppercase",
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(homework.theme.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(homework.title))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_c('span', {
      class: {
        'font-red-flamingo bold': homework.delayed
      }
    }, [_vm._v(" " + _vm._s(_vm._f("date")(homework.dueDate, 'DD/MM/YYYY')))]), _vm._v(" "), (homework.pendingAction) ? _c('span', {
      staticClass: "text"
    }, [_c('br'), _c('i', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "fa fa-warning text-warning"
    }), _vm._v(" Não atualizado")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "35%"
      }
    }, [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.statusScheduledHomework), function(value, key) {
      return _c('label', {
        staticClass: "mt-radio mt-radio-outline"
      }, [_c('input', {
        directives: [{
          name: "translate",
          rawName: "v-translate"
        }],
        attrs: {
          "type": "radio",
          "data-index": index
        },
        domProps: {
          "value": key,
          "checked": homework.status === key
        },
        on: {
          "change": _vm.putAgendaScheduledHomework
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t\t"), _c('span')])
    }))])])
  }))])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box red"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('router-link', {
    staticClass: "btn btn-circle btn-default",
    attrs: {
      "to": "/inbox"
    }
  }, [_c('i', {
    staticClass: "icon-envelope-open"
  }), _vm._v("\n\t\t\t\tIr para Caixa de Entrada\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, _vm._l((_vm.messagesGroups), function(msgGroup) {
    return _c('div', {
      staticClass: "portlet m-b-0"
    }, [_c('div', {
      staticClass: "portlet-title m-b-0"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('i', {
      staticClass: "icon-speech"
    }), _vm._v(" "), _c('span', {
      staticClass: "caption-subject bold uppercase"
    }, [_vm._v("\n\t\t\t\t\t\tAssunto: " + _vm._s(msgGroup.subject) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('button', {
      staticClass: "btn btn-circle btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.replyMessage(msgGroup.messageGroup)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tResponder\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "portlet-body p-t-0"
    }, [_c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-condensed table-striped"
    }, [_c('tbody', _vm._l((msgGroup.messages), function(msg, index) {
      return (index < 3) ? _c('tr', [_c('td', {
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(msg.from.name))]), _vm._v(" "), _c('td', {
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(_vm._f("truncate")(msg.message, 340)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right",
        class: {
          'bold': msgGroup.notRead
        }
      }, [_vm._v(_vm._s(_vm._f("date")(msg.sentDateTime, "DD/MM/YYYY HH:mm")))])]) : _vm._e()
    }))])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-envelope-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\tMensagens não lidas\n\t\t")])
}]}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn btn-xs default"
  }, [_vm._v(_vm._s(_vm.charactersLeft))])
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.klass.schoolClassLevel === 'Bercario' || _vm.klass.schoolClassLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box yellow"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Itens para Reposição")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addReplacementItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-5"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "for": "product"
    }
  }, [_vm._v("Qual o item para reposição?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.product),
      expression: "model.product"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "product",
      "name": "product",
      "placeholder": "Exemplo: Pomadas, fraldas..."
    },
    domProps: {
      "value": (_vm.model.product)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "product", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Qual a quantidade?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.quantity),
      expression: "model.quantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "quantity",
      "name": "quantity",
      "placeholder": "Exemplo: 3 unidades, 1 pacote..."
    },
    domProps: {
      "value": (_vm.model.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "for": "dueDate"
    }
  }, [_vm._v("Qual a data de entrega?")]), _c('br'), _vm._v(" "), _c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "date",
      "editable": false,
      "id": "dueDate",
      "name": "dueDate",
      "format": "dd/MM/yyyy",
      "placeholder": "DD/MM/AAAA",
      "clearable": false
    },
    model: {
      value: (_vm.model.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "dueDate", $$v)
      },
      expression: "model.dueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [(_vm.model.index !== undefined && _vm.model.index >= 0) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-link btn-block m-t-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearModel($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-block yellow m-t-24",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [(_vm.model.index !== undefined && _vm.model.index >= 0) ? _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Atualizar")]) : _vm._e(), _vm._v(" "), (_vm.model.index === undefined) ? _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Adicionar")]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.replacementItens && _vm.replacementItens.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "m-t-20 table table-striped table-bordered table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Data de entrega")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.replacementItens), function(item, $index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.product))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(item.dueDate, "DD/MM/YYYY")))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editReplacementItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeReplacementItem($index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitCopy($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Copiar plano de aula da turma:")]), _vm._v(" "), _c('school-class-list', {
    attrs: {
      "only-select": true,
      "group": false,
      "by-theme": true,
      "scope": 'local',
      "context": 'LessonPlanningCopy'
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": !_vm.klass.schoolClassId
    }
  }, [_vm._v("\n\t\t\tCopiar plano de aula\n\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleCopy(false)
      }
    }
  }, [_vm._v("\n\t\t\tCancelar cópia\n\t\t")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('page-bar', {
    attrs: {
      "languages": true
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tHome "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Seja bem vindo(a) ao portal administrativo")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "userId"
    },
    domProps: {
      "value": (_vm.userId)
    },
    on: {
      "change": _vm.updateUserId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userId = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 blue",
    attrs: {
      "to": "/agenda"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Agenda")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green-jungle",
    attrs: {
      "to": "/inbox"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-inbox",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Caixa de Mensagem")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple",
    attrs: {
      "to": "/get-at-school"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Monitor de Saída")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 yellow-casablanca",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-cutlery",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Cadastro de Cardápio")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green",
    attrs: {
      "to": "/medicine"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Medicações")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 red-mint",
    attrs: {
      "to": "/gallery"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-camera",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Galeria de Fotos")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 green-haze",
    attrs: {
      "to": "/evaluation"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Indicadores")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple-medium",
    attrs: {
      "to": "/lesson-planning"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Plano de aula")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "dashboard-stat dashboard-stat-v2 purple-medium",
    attrs: {
      "to": "/lesson-planning/report"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "desc"
  }, [_vm._v("Relatório Plano de aula")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/simulator"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Simulador site")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t\t#\n\t\t\t\t\t")])])
}]}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Fundamental_1' || _vm.classLevel === 'Fundamental_2' || _vm.classLevel === 'EnsinoMedio') ? _c('div', [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box red text-center"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v("\n\t\t\t\tPresença em aula\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(" Horário ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(" Disciplina ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(" Presença ")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])]), _vm._v(" "), _c('tr', {
    staticClass: "form-group"
  }, [_c('td', [_vm._v(" 07:30 ")]), _vm._v(" "), _c('td', [_vm._v(" Matemática ")]), _vm._v(" "), _c('td', {
    staticClass: "mt-radio-inline"
  }, [_c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente",
      "checked": ""
    }
  }), _vm._v("Presente\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Atrasado\n\t\t\t\t\t\t\t\t\t"), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-radio mt-radio-outline"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "presence",
      "value": "Presente"
    }
  }), _vm._v("Ausente\n\t\t\t\t\t\t\t\t\t"), _c('span')])])])])])])])])
}]}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-bed",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Soneca")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    staticClass: "row",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addNapItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-6",
    class: {
      'has-error': _vm.errors.has('nap-starttime')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "nap-starttime"
    }
  }, [_vm._v("Horário de Início")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nap.startTime),
      expression: "nap.startTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 16:00",
      "id": "nap-starttime",
      "name": "nap-starttime"
    },
    domProps: {
      "value": (_vm.nap.startTime)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nap, "startTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-6",
    class: {
      'has-error': _vm.errors.has('nap-endtime')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "nap-endtime"
    }
  }, [_vm._v("Horário de Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nap.endTime),
      expression: "nap.endTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 16:30",
      "id": "nap-endtime",
      "name": "nap-endtime"
    },
    domProps: {
      "value": (_vm.nap.endTime)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nap, "endTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-xs-12 col-md-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-block btn-add-nap-item green",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Adicionar")])])])]), _vm._v(" "), (_vm.naps && _vm.naps.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário de Início")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário de Fim")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.naps), function(nap, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(nap.startTime, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(nap.endTime, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editNapsItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteNapItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "student-humor"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1'),
      expression: "classLevel === 'Bercario' || classLevel === 'Infantil' || classLevel === 'Fundamental_1'"
    }]
  }, [_c('svg', {
    staticClass: "hide"
  }, [_c('symbol', {
    attrs: {
      "id": "neutral",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 30 60 C 13.458 60 0 46.5421 0 30.0001 C 0 13.458 13.458 0 30 0 C 46.542 0 60 13.458 60 30.0001 C 60 46.5421 46.542 60 30 60 ZM 30 3.7501 C 15.525 3.7501 3.75 15.5251 3.75 30.0001 C 3.75 44.4751 15.525 56.25 30 56.25 C 44.475 56.25 56.25 44.4751 56.25 30.0001 C 56.25 15.5251 44.475 3.7501 30 3.7501 ZM 40.641 43.4893 L 19.3589 43.4893 C 18.4902 43.4893 17.7794 42.7784 17.7794 41.9096 C 17.7794 41.0409 18.4902 40.3301 19.3589 40.3301 L 40.641 40.3301 C 41.5097 40.3301 42.2206 41.0409 42.2206 41.9096 C 42.2206 42.7784 41.5097 43.4893 40.641 43.4893 ZM 35.6416 21.5629 C 35.6416 17.8364 41.2338 17.8364 41.2338 21.5629 C 41.2338 25.2894 35.6416 25.2894 35.6416 21.5629 ZM 18.7828 21.5462 C 18.7828 17.8172 24.375 17.8172 24.375 21.5462 C 24.375 25.2727 18.7828 25.2727 18.7828 21.5462 Z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "sleepy",
      "viewBox": "0 0 62 65"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 31.6534 65 C 15.196 65 1.8068 51.9171 1.8068 35.8365 C 1.8068 19.7557 15.196 6.673 31.6534 6.673 C 48.1108 6.673 61.5 19.7557 61.5 35.8365 C 61.5 51.9171 48.1108 65 31.6534 65 ZM 31.6534 10.3184 C 17.2524 10.3184 5.5376 21.765 5.5376 35.8365 C 5.5376 49.9078 17.2524 61.3544 31.6534 61.3544 C 46.0543 61.3544 57.7692 49.9078 57.7692 35.8365 C 57.7692 21.765 46.0543 10.3184 31.6534 10.3184 ZM 36.8658 32.9883 C 36.3762 32.5103 36.3762 31.7343 36.8658 31.2563 C 37.1107 31.0171 37.4315 30.8975 37.7522 30.8975 C 38.0729 30.8975 38.3936 31.0171 38.6385 31.2563 C 40.3001 32.8799 43.0039 32.8799 44.6655 31.2563 C 45.1552 30.7778 45.9484 30.7778 46.4381 31.2563 C 46.9278 31.7343 46.9278 32.5103 46.4381 32.9883 C 43.7988 35.5672 39.5052 35.5672 36.8658 32.9883 ZM 35.145 48.9494 L 28.5598 48.9494 C 27.6955 48.9494 26.9884 48.2585 26.9884 47.4141 C 26.9884 46.5695 27.6955 45.8785 28.5598 45.8785 L 35.145 45.8785 C 36.0094 45.8785 36.7165 46.5695 36.7165 47.4141 C 36.7165 48.2585 36.0094 48.9494 35.145 48.9494 ZM 17.3163 32.9883 C 16.8267 32.5103 16.8267 31.7343 17.3163 31.2563 C 17.5612 31.0171 17.8819 30.8975 18.2026 30.8975 C 18.5234 30.8975 18.8441 31.0171 19.089 31.2563 C 20.7506 32.8799 23.4544 32.8799 25.1159 31.2563 C 25.6057 30.7778 26.3989 30.7778 26.8886 31.2563 C 27.3782 31.7343 27.3782 32.5103 26.8886 32.9883 C 24.2492 35.5672 19.9556 35.5672 17.3163 32.9883 ZM 14.9925 7.5448 L 15.9622 2.9045 L 13.2988 4.3664 L 12.4535 2.8959 L 17.7295 0 L 18.418 1.1977 L 17.4486 5.8383 L 20.2727 4.2882 L 21.1181 5.7587 L 15.6813 8.7429 L 14.9925 7.5448 ZM 12.8676 7.9166 L 8.4539 10.3392 L 7.8316 9.2568 L 8.5815 6.15 L 6.7385 7.1616 L 5.9404 5.7735 L 10.1848 3.4438 L 10.8071 4.5262 L 10.0574 7.6333 L 12.0697 6.5288 L 12.8676 7.9166 ZM 5.4951 13.9236 L 8.3192 12.3735 L 9.1647 13.844 L 3.7278 16.8281 L 3.0391 15.63 L 4.0087 10.9897 L 1.3454 12.4515 L 0.5 10.981 L 5.776 8.0852 L 6.4646 9.2829 L 5.4951 13.9236 Z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "angry",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 30 60 C 13.458 60 0 46.5421 0 29.9999 C 0 13.458 13.458 0 30 0 C 46.542 0 60 13.458 60 29.9999 C 60 46.5421 46.542 60 30 60 ZM 30 3.7501 C 15.525 3.7501 3.75 15.525 3.75 29.9999 C 3.75 44.4749 15.525 56.2499 30 56.2499 C 44.475 56.2499 56.25 44.4749 56.25 29.9999 C 56.25 15.525 44.475 3.7501 30 3.7501 ZM 41.3687 45.8706 C 40.6524 46.2888 39.7337 46.0414 39.3193 45.325 C 37.3956 42.0007 33.8238 39.936 30.0006 39.936 C 26.1774 39.936 22.6057 42.0006 20.6819 45.325 C 20.2675 46.0432 19.3469 46.2888 18.6325 45.8706 C 17.9144 45.4563 17.6688 44.5376 18.0869 43.8213 C 20.545 39.5764 25.1108 36.9362 30.0005 36.9362 L 30.0007 36.9362 C 34.891 36.9362 39.4562 39.5743 41.9143 43.8213 C 42.3305 44.5376 42.085 45.4563 41.3687 45.8706 ZM 35.6333 21.5629 C 35.6333 17.8363 41.2255 17.8363 41.2255 21.5629 C 41.2255 25.2893 35.6333 25.2893 35.6333 21.5629 ZM 33.4551 20.3376 C 33.1703 20.5881 32.817 20.7112 32.4652 20.7112 C 32.0488 20.7112 31.6346 20.5388 31.3381 20.2016 C 30.7911 19.5797 30.8521 18.6316 31.474 18.0847 L 38.2197 12.153 C 38.841 11.6059 39.7894 11.6669 40.3366 12.2888 C 40.8836 12.9109 40.8227 13.8589 40.2007 14.4059 L 33.4551 20.3376 ZM 24.3667 21.5461 C 24.3667 25.2725 18.7745 25.2725 18.7745 21.5461 C 18.7745 17.8172 24.3667 17.8172 24.3667 21.5461 ZM 27.6575 20.8188 C 27.3056 20.8188 26.9527 20.6959 26.6676 20.4454 L 19.7992 14.4059 C 19.1773 13.8589 19.1163 12.9113 19.6633 12.2888 C 20.2103 11.6669 21.1577 11.6059 21.7803 12.153 L 28.6486 18.1925 C 29.2706 18.7394 29.3315 19.6872 28.7846 20.3095 C 28.4881 20.6466 28.0738 20.8188 27.6575 20.8188 Z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "tearful",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 30 60 C 13.458 60 0 46.5422 0 30.0001 C 0 13.458 13.458 0 30 0 C 46.542 0 60 13.458 60 30.0001 C 60 46.5422 46.542 60 30 60 ZM 30 3.7499 C 15.525 3.7499 3.75 15.525 3.75 30.0001 C 3.75 44.4752 15.525 56.2501 30 56.2501 C 44.475 56.2501 56.25 44.4752 56.25 30.0001 C 56.25 15.525 44.475 3.7499 30 3.7499 ZM 41.3696 45.8707 C 40.6533 46.2889 39.7346 46.0415 39.3202 45.3253 C 37.3965 42.0008 33.8247 39.9363 30.0015 39.9363 C 26.1783 39.9363 22.6066 42.0006 20.6828 45.3253 C 20.2684 46.0433 19.3478 46.2889 18.6334 45.8707 C 17.9153 45.4564 17.6697 44.5377 18.0878 43.8214 C 20.5459 39.5764 25.1117 36.9364 30.0014 36.9364 L 30.0016 36.9364 C 34.8918 36.9364 39.4571 39.5745 41.9152 43.8214 C 42.3314 44.5377 42.0858 45.4564 41.3696 45.8707 ZM 35.6416 21.5627 C 35.6416 17.8362 41.2338 17.8362 41.2338 21.5627 C 41.2338 25.2893 35.6416 25.2893 35.6416 21.5627 ZM 18.7828 21.546 C 18.7828 17.8171 24.375 17.8171 24.375 21.546 C 24.375 25.2726 18.7828 25.2726 18.7828 21.546 ZM 15.0138 34.5303 C 13.8129 34.5303 12.8395 33.5569 12.8395 32.3559 C 12.8395 31.1553 15.0138 29.2122 15.0138 29.2122 C 15.0138 29.2122 17.188 31.1553 17.188 32.3559 C 17.188 33.5569 16.2146 34.5303 15.0138 34.5303 Z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "sad",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 30 60 C 13.458 60 0 46.5421 0 30.0001 C 0 13.458 13.458 0 30 0 C 46.542 0 60 13.458 60 30.0001 C 60 46.5421 46.542 60 30 60 ZM 30 3.7499 C 15.525 3.7499 3.75 15.5251 3.75 30.0001 C 3.75 44.4751 15.525 56.2501 30 56.2501 C 44.475 56.2501 56.25 44.4751 56.25 30.0001 C 56.25 15.5251 44.475 3.7499 30 3.7499 ZM 41.3696 45.8706 C 40.6533 46.2889 39.7346 46.0415 39.3202 45.3253 C 37.3965 42.0007 33.8247 39.9363 30.0015 39.9363 C 26.1783 39.9363 22.6066 42.0005 20.6828 45.3253 C 20.2684 46.0433 19.3478 46.2889 18.6334 45.8706 C 17.9153 45.4564 17.6697 44.5377 18.0878 43.8213 C 20.5459 39.5764 25.1117 36.9364 30.0014 36.9364 L 30.0016 36.9364 C 34.8918 36.9364 39.4571 39.5745 41.9152 43.8213 C 42.3314 44.5377 42.0858 45.4564 41.3696 45.8706 ZM 35.6416 21.5627 C 35.6416 17.8363 41.2338 17.8363 41.2338 21.5627 C 41.2338 25.2893 35.6416 25.2893 35.6416 21.5627 ZM 18.7828 21.546 C 18.7828 17.8172 24.375 17.8172 24.375 21.546 C 24.375 25.2726 18.7828 25.2726 18.7828 21.546 Z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "happy",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 30 60 C 13.458 60 0 46.5422 0 30 C 0 13.4578 13.458 0 30 0 C 46.542 0 60 13.4578 60 30 C 60 46.5422 46.542 60 30 60 ZM 30 3.7499 C 15.525 3.7499 3.75 15.5249 3.75 30 C 3.75 44.4751 15.525 56.2501 30 56.2501 C 44.475 56.2501 56.25 44.4751 56.25 30 C 56.25 15.5249 44.475 3.7499 30 3.7499 ZM 30.0003 47.217 L 30 47.217 C 23.8872 47.217 18.1806 43.9193 15.108 38.6106 C 14.5877 37.7153 14.8947 36.5668 15.79 36.0489 C 16.6853 35.5263 17.8337 35.8357 18.3517 36.7307 C 20.7564 40.8864 25.2211 43.4671 30.0001 43.4671 C 34.7791 43.4671 39.2437 40.8868 41.6485 36.7307 C 42.1665 35.8333 43.3173 35.5263 44.2102 36.0489 C 45.1079 36.5668 45.4149 37.7153 44.8922 38.6106 C 41.8196 43.9169 36.1125 47.217 30.0003 47.217 ZM 35.6416 21.5627 C 35.6416 17.8363 41.2338 17.8363 41.2338 21.5627 C 41.2338 25.2893 35.6416 25.2893 35.6416 21.5627 ZM 18.7828 21.546 C 18.7828 17.817 24.375 17.817 24.375 21.546 C 24.375 25.2726 18.7828 25.2726 18.7828 21.546 Z"
    }
  })])]), _vm._v(" "), _c('h5', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Como estava o humor do aluno hoje?")]), _vm._v(" "), _c('h6', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Clique no ícone abaixo para alterar")]), _vm._v(" "), _vm._l((_vm.humorTypes), function(type, key) {
    return _c('label', {
      staticClass: "humor-face",
      class: {
        'active': _vm.humor === key
      }
    }, [_c('svg', {
      attrs: {
        "width": "40px",
        "height": "40px"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": '#' + key.toLowerCase(),
        "fill": "#ff8900"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-center humor-face-text"
    }, [_vm._v(_vm._s(type.toUpperCase()))]), _vm._v(" "), _c('input', {
      staticClass: "humor-radio",
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions",
        "id": key
      },
      domProps: {
        "checked": _vm.humor === key,
        "value": key
      },
      on: {
        "change": _vm.putAgendaHumor
      }
    })])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-body"
  }, [_c('div', {
    staticClass: "inbox-header"
  }, [_c('h1', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Recebidas")])]), _vm._v(" "), _c('div', {
    staticClass: "inbox-content"
  }, [_c('filter-inbox', {
    attrs: {
      "context": 'received'
    }
  }), _vm._v(" "), _c('received-messages')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-sidebar"
  }, [_c('router-link', {
    staticClass: "btn green compose-btn btn-block",
    attrs: {
      "to": "/inbox/new-message"
    }
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Nova")])])]), _vm._v(" "), _c('ul', {
    staticClass: "inbox-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/inbox"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Recebidas")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/inbox/send-message"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviadas")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno (turma)")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Assunto")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Participantes")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-right"
  }, [_vm._v("Data de Recebimento")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.receivedMessages), function(message) {
    return _c('router-link', {
      key: message.messageGroup,
      class: {
        'active': message.notRead === 0, 'bold': message.notRead === 1
      },
      attrs: {
        "tag": "tr",
        "to": {
          path: ("/inbox/reply-message/" + (message.messageGroup))
        }
      }
    }, [_c('td', {
      staticClass: "view-message align-middle hidden-xs"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(message.student.name)), _c('br'), _vm._v(" "), (message.student.schoolClass && message.student.schoolClass.description) ? _c('small', [_vm._v("\n\t\t\t\t\t\t\t\tTurma: " + _vm._s(message.student.schoolClass.description) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.subject))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle"
    }, [_vm._v(_vm._s(message.members))]), _vm._v(" "), _c('td', {
      staticClass: "view-message align-middle text-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(message.dateTime, 'DD/MM/YYYY HH:mm')) + "\n\t\t\t\t\t\t")])])
  })), _vm._v(" "), (_vm.receivedMessages.length === 0) ? _c('tfoot', [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNenhuma mensagem recebida\n\t\t\t\t\t\t")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.receivedMessages.length > 0) ? _c('pagination', {
    attrs: {
      "layout": "prev, next"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medicine"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Medicações")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('medicine-filters')], 1), _vm._v(" "), _c('medicine-labels')], 1), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('medicine-pending'), _vm._v(" "), _c('medicine-history')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('class-level')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "class-level"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.classLevelModel),
      expression: "classLevelModel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': _vm.required
      }),
      expression: "{ 'required': required }"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "class-level",
      "name": "class-level",
      "required": _vm.required
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.classLevelModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changed]
    }
  }, [_c('option', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.schoolClassLevels), function(option, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(option))])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('student-messages')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meal-menu-clone",
    attrs: {
      "id": "printable"
    }
  }, [_c('page-bar', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Cardápio mensal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right no-print"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/meal-menu"
    }
  }, [_vm._v("\n\t\t\t\tVoltar\n\t\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn yellow-gold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.print('#printable')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\tImprimir\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light full-calendar-printable"
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig,
      "header": {
        left: '',
        center: 'title',
        right: ''
      },
      "editable": false,
      "events": _vm.events
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    staticClass: "page-title"
  }, [_vm._v("\n\t\tCaixa de Entrada\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('sidebar-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('message-new')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('time', {
    staticClass: "clock"
  }, [_c('span', {
    staticClass: "clock__hour"
  }, [_vm._v(_vm._s(_vm.hours))]), (!_vm.blink || _vm.seconds % 2 === 0) ? _c('span', [_vm._v(":")]) : _c('span', [_vm._v(" ")]), _c('span', {
    staticClass: "clock__minutes"
  }, [_vm._v(_vm._s(_vm.minutes))]), (!_vm.blink || (_vm.seconds % 2 === 0 && _vm.displaySeconds)) ? _c('span', [_vm._v(":")]) : (_vm.displaySeconds) ? _c('span', [_vm._v(" ")]) : _vm._e(), (_vm.displaySeconds) ? _c('span', {
    staticClass: "clock__seconds"
  }, [_vm._v(_vm._s(_vm.seconds))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Histórico de Medicações")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_c('thead', {
    staticClass: "flip-content"
  }, [_c('tr', [_c('th', {
    staticClass: "col-time bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário programado")])]), _vm._v(" "), _c('th', {
    staticClass: "col-time bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário ministrado")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ministrada por")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação e Dosagem")])]), _vm._v(" "), _c('th', {
    staticClass: "bg-gray align-middle"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Motivo")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyList.list.length),
      expression: "historyList.list.length"
    }]
  }, _vm._l((_vm.historyList.list), function(medicine, index) {
    return _c('tr', [_c('td', {
      staticClass: "prog align-middle"
    }, [(medicine.medicinesTaken) ? _c('i', {
      staticClass: "fa fa-check font-green",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('i', {
      staticClass: "fa fa-ban font-red",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.hour, 'HH:mm', true)) + "\n\n\t\t\t\t\t\t\t"), (medicine.rejectionReason) ? _c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn default btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancelRejectionMedicine(medicine.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar Rejeição\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(medicine.medicinesTaken) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.medicinesTaken[0].time, 'HH:mm', true)) + "\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('span', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(medicine.medicinesTaken) ? _c('span', [(!medicine.medicinesTaken[0].user) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")]) : _vm._e(), _vm._v(" "), (medicine.medicinesTaken[0].user) ? _c('span', [_vm._v(_vm._s(medicine.medicinesTaken[0].user.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (medicine.rejectionReason) ? _c('span', [_c('strong', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Rejeitado")]), _vm._v(" "), _c('small', {
      staticClass: "display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Motivo:")]), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(medicine.rejectionReason || '-') + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "width": "25px",
        "height": "25px",
        "src": medicine.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(medicine.student.name))]), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "font-grey-cascade display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Solicitado por")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(medicine.responsible.name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('span', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _c('br'), _vm._v(" "), _c('a', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-link btn-xs",
      attrs: {
        "target": "_blank",
        "href": medicine.medicalPrescriptionURL
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer receita\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(medicine.treatment) + "\n\t\t\t\t\t\t")])])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.historyList.list.length),
      expression: "!historyList.list.length"
    }]
  }, [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum histórico de mediação na data informada")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box blue"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-cutlery",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Refeições")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover m-b-0 text-center"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Alimento")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center"
  }, [_vm._v("Quantidade")])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.meals),
      expression: "meals"
    }]
  }, [_vm._l((_vm.meals), function(meal, index) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(meal.time.time) ? _c('p', [_vm._v(_vm._s(_vm._f("date")(meal.time.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), (!meal.time.time) ? _c('p', [_vm._v("-")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (meal.time.meal),
        expression: "meal.time.meal"
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreak(meal.time.meal, ', '))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!meal.time.meal),
        expression: "!meal.time.meal"
      }, {
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.quantityTypes), function(value, key) {
      return _c('label', {
        staticClass: "mt-radio mt-radio-outline",
        class: {
          'mt-radio-disabled': !meal.time.meal
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'meal-portion-' + index,
          "data-index": index,
          "disabled": !meal.time.meal
        },
        domProps: {
          "value": key,
          "checked": _vm.meals[index].mealPortion === key
        },
        on: {
          "change": _vm.putAgendaMealPortion
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('span')])
    }))])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (meal.time.beverage),
        expression: "meal.time.beverage"
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreak(meal.time.beverage, ', '))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!meal.time.beverage),
        expression: "!meal.time.beverage"
      }, {
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não informado")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.quantityTypes), function(value, key) {
      return _c('label', {
        staticClass: "mt-radio mt-radio-outline",
        class: {
          'mt-radio-disabled': !meal.time.beverage
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": 'beverage-portion-' + index,
          "data-index": index,
          "disabled": !meal.time.beverage
        },
        domProps: {
          "value": key,
          "checked": _vm.meals[index].beveragePortion === key
        },
        on: {
          "change": _vm.putAgendaBeveragePortion
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('span')])
    }))])])]
  })], 2), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.meals || !_vm.meals.length),
      expression: "!meals || !meals.length"
    }]
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Não há refeição registrada para este aluno")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_c('strong', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-blue"
  }, [_vm._v("Alimentos Adicionais")])]), _vm._v(" "), _c('form', {
    staticClass: "row additional-meals",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addAdditionalMealsItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-2 col-xs-3",
    class: {
      'has-error': _vm.errors.has('additionalmeal-time')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal.time"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.time),
      expression: "additionalMeal.time"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /([01]\d|2[0-3]):([0-5]\d)/
        }
      }),
      expression: "{ rules: { required: true, regex: /([01]\\d|2[0-3]):([0-5]\\d)/} }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 16:00",
      "id": "additionalmeal-time",
      "name": "additionalmeal-time"
    },
    domProps: {
      "value": (_vm.additionalMeal.time)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-xs-3",
    class: {
      'has-error': _vm.errors.has('additionalmeal-meal')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal.meal"
    }
  }, [_vm._v("Alimento/Líquido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.meal),
      expression: "additionalMeal.meal"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: Banana",
      "id": "additionalmeal-meal",
      "name": "additionalmeal-meal"
    },
    domProps: {
      "value": (_vm.additionalMeal.meal)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "meal", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-xs-2",
    class: {
      'has-error': _vm.errors.has('additionalmeal-portion')
    }
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label",
    attrs: {
      "for": "additionalmeal-portion"
    }
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalMeal.portion),
      expression: "additionalMeal.portion"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Exemplo: 1",
      "id": "additionalmeal-portion",
      "name": "additionalmeal-portion"
    },
    domProps: {
      "value": (_vm.additionalMeal.portion)
    },
    on: {
      "change": function($event) {
        _vm.completionStatus(_vm.additionalMeal)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalMeal, "portion", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2 col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-block blue m-t-24",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.items.length > 0
    }
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Adicionar")])])])]), _vm._v(" "), (_vm.additionals && _vm.additionals.length > 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.additionals && _vm.additionals.length > 0) ? _c('div', {
    staticClass: "table-responsible"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Alimento/Líquido")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.additionals), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(item.time, 'HH:mm', true)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.meal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.portion))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editAdditionalMealsItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteAdditionalMealsItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicações pendentes")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_c('thead', {
    staticClass: "flip-content"
  }, [_c('tr', [_c('th', {
    staticClass: "col-time align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário programado")])]), _vm._v(" "), _c('th', {
    staticClass: "col-time align-middle"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Horário ministrado")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Aluno")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação e Dosagem")])]), _vm._v(" "), _c('th', {
    staticClass: "align-middle"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Motivo")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingList.list.length),
      expression: "pendingList.list.length"
    }]
  }, _vm._l((_vm.pendingList.list), function(medicine, index) {
    return _c('tr', [_c('td', {
      staticClass: "prog align-middle",
      class: {
        'font-red bold': _vm.getTimeDiff(medicine.hour) > 0
      }
    }, [(_vm.getTimeDiff(medicine.hour) > 0) ? _c('i', {
      staticClass: "fa fa-exclamation-triangle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("date")(medicine.hour, 'HH:mm', true)) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('form', {
      attrs: {
        "role": "form"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.saveMedicineHour(medicine.id, medicine.takenHour)
        }
      }
    }, [_c('div', {
      staticClass: "input-group",
      class: {
        'has-error': _vm.errors.has(_vm.getTakenHourInputName(index))
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (medicine.takenHour),
        expression: "medicine.takenHour"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##:##'),
        expression: "'##:##'"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          rules: {
            required: true,
            regex: /^([01]\d|2[0-3]):?([0-5]\d)$/
          }
        }),
        expression: "{ rules: { required: true, regex: /^([01]\\d|2[0-3]):?([0-5]\\d)$/ } }"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text",
        "name": _vm.getTakenHourInputName(index),
        "disabled": _vm.isBeforeDate()
      },
      domProps: {
        "value": (medicine.takenHour)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(medicine, "takenHour", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-sm green",
      attrs: {
        "type": "submit",
        "disabled": _vm.errors.has(_vm.getTakenHourInputName(index)) || _vm.isBeforeDate()
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSalvar\n\t\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "width": "25px",
        "height": "25px",
        "src": medicine.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(medicine.student.name))]), _vm._v(" "), _c('small', {
      staticClass: "font-grey-cascade display-block m-t-5"
    }, [_c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Solicitado por")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(medicine.responsible.name) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('span', {
      staticClass: "display-block m-b-10"
    }, [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-link btn-xs",
      attrs: {
        "target": "_blank",
        "href": medicine.medicalPrescriptionURL
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tVer receita\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-xs red-pink",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setReject(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\tRejeitar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('form', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (medicine.reject),
        expression: "medicine.reject"
      }],
      staticClass: "m-t-10",
      attrs: {
        "role": "form"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.rejectionMedicine(medicine.id, medicine.rejectionReason, index)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (medicine.rejectionReason),
        expression: "medicine.rejectionReason"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text",
        "placeholder": "Justifique...",
        "required": ""
      },
      domProps: {
        "value": (medicine.rejectionReason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(medicine, "rejectionReason", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn btn-default btn-sm green",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tJustificar\n\t\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_vm._v(_vm._s(medicine.treatment))])])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pendingList.list.length),
      expression: "!pendingList.list.length"
    }]
  }, [_c('tr', [_c('td', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhuma medicação na data informada")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(425);
module.exports = __webpack_require__(424);


/***/ })
],[1125]);


// WEBPACK FOOTER //
// assets/scripts/app.6dde4463682d2ff5069c.js